{
  "app": {
    "name": "HMS",
    "fullName": "Hệ thống quản lý bệnh viện",
    "tagline": "Chăm sóc liền mạch."
  },
  "common": {
    "save": "Lưu",
    "saving": "Đang lưu…",
    "cancel": "Hủy",
    "close": "Đóng",
    "edit": "Sửa",
    "delete": "Xóa",
    "add": "Thêm",
    "create": "Tạo",
    "search": "Tìm kiếm",
    "searchPlaceholder": "Tìm kiếm…",
    "loading": "Đang tải…",
    "retry": "Thử lại",
    "back": "Quay lại",
    "next": "Tiếp",
    "previous": "Trước",
    "confirm": "Xác nhận",
    "yes": "Có",
    "no": "Không",
    "actions": "Thao tác",
    "status": "Trạng thái",
    "details": "Chi tiết",
    "none": "Không có",
    "all": "Tất cả",
    "optional": "Không bắt buộc",
    "required": "Bắt buộc",
    "notes": "Ghi chú",
    "reason": "Lý do",
    "date": "Ngày",
    "time": "Giờ",
    "from": "Từ",
    "to": "Đến",
    "filter": "Lọc",
    "clear": "Xóa lọc",
    "refresh": "Làm mới",
    "print": "In",
    "export": "Xuất",
    "import": "Nhập",
    "reset": "Đặt lại",
    "view": "Xem",
    "open": "Mở",
    "submit": "Gửi",
    "select": "Chọn",
    "selectPlaceholder": "Chọn…",
    "noResults": "Không tìm thấy kết quả",
    "total": "Tổng",
    "showing": "{{from}}–{{to}} trên {{total}}",
    "unknown": "Không rõ",
    "saved": "Đã lưu",
    "today": "Hôm nay",
    "name": "Tên",
    "code": "Mã",
    "type": "Loại",
    "description": "Mô tả",
    "createdAt": "Ngày tạo",
    "updatedAt": "Ngày cập nhật",
    "yearsShort": "{{count}} tuổi",
    "dash": "—",
    "more": "Thêm",
    "active": "Hoạt động",
    "inactive": "Ngừng hoạt động",
    "first": "Trang đầu",
    "last": "Trang cuối",
    "pageOf": "Trang {{page}} / {{pages}}",
    "rowsPerPage": "Số dòng mỗi trang",
    "pagination": "Phân trang",
    "viewAs": "Hiển thị dạng",
    "views": {
      "list": "Danh sách",
      "cards": "Thẻ",
      "grid": "Lưới"
    },
    "datePlaceholder": "dd/mm/yyyy",
    "pickDate": "Chọn ngày",
    "change": "Đổi",
    "goToPage": "Đến trang",
    "jumpBack": "Lùi {{count}} trang",
    "jumpForward": "Tiến {{count}} trang",
    "cancelled": "Đã hủy",
    "choose": "Chọn…",
    "selectAll": "Chọn tất cả"
  },
  "nav": {
    "dashboard": "Tổng quan",
    "patients": "Bệnh nhân",
    "appointments": "Lịch hẹn",
    "queue": "Hàng đợi",
    "encounters": "Lượt khám",
    "pharmacy": "Nhà thuốc",
    "laboratory": "Xét nghiệm",
    "billing": "Viện phí",
    "administration": "Quản trị",
    "users": "Người dùng",
    "departments": "Khoa phòng",
    "practitioners": "Nhân viên y tế",
    "hospital": "Bệnh viện",
    "auditLog": "Nhật ký kiểm tra",
    "translations": "Bản dịch",
    "languages": "Ngôn ngữ",
    "settings": "Cài đặt",
    "notifications": "Thông báo",
    "signOut": "Đăng xuất",
    "menu": "Menu",
    "home": "Trang chủ",
    "eyeCenter": "Trung tâm Mắt",
    "treatmentCycles": "Chu trình điều trị",
    "patientApp": "Ứng dụng bệnh nhân",
    "reports": "Báo cáo",
    "locations": "Địa danh",
    "inventory": "Kho",
    "inpatient": "Nội trú",
    "bedBoard": "Sơ đồ giường",
    "admissions": "Nhập viện",
    "wardSetup": "Khoa phòng & giường",
    "specialServices": "Dịch vụ đặc biệt",
    "serviceWorklist": "Danh sách việc",
    "serviceCatalog": "Dịch vụ & giá",
    "pos": "POS y tế",
    "posCounter": "Bán hàng",
    "salesHistory": "Lịch sử bán hàng",
    "itemsPrices": "Mặt hàng & giá",
    "finance": "Tài chính",
    "collapseMenu": "Thu gọn menu",
    "expandMenu": "Mở rộng menu",
    "posStock": "Tồn kho & bổ sung",
    "posCatalog": "Danh mục & giá",
    "diseases": "Bệnh",
    "nationalReporting": "Báo cáo quốc gia",
    "area": {
      "patientAdmin": "Quản lý bệnh nhân",
      "clinical": "Khám và điều trị",
      "eye": "Trung tâm mắt",
      "inpatient": "Nội trú",
      "supplies": "Thuốc và vật tư",
      "finance": "Tài chính",
      "reporting": "Hiệu suất và báo cáo quốc gia",
      "engagement": "Kết nối bệnh nhân",
      "platform": "Hệ thống và quản trị"
    },
    "tenants": "Tổ chức và bệnh viện",
    "referrals": "Chuyển tuyến",
    "followUps": "Tái khám",
    "duplicates": "Bệnh nhân trùng",
    "roles": "Vai trò và quyền",
    "appointmentDashboard": "Tổng quan",
    "appointmentList": "Danh sách lịch hẹn",
    "disabilityTypes": "Loại khuyết tật",
    "queueDashboard": "Bảng điều khiển nhân viên",
    "queueKiosk": "Kiosk tự phục vụ",
    "queueDisplay": "Màn hình phòng chờ",
    "queueReport": "Thời gian chờ",
    "queueServices": "Điểm phục vụ hàng đợi",
    "staffKpi": "KPI nhân viên",
    "staffDashboard": "Tổng quan",
    "staffLeaderboard": "Bảng xếp hạng",
    "staffTargets": "Chỉ tiêu"
  },
  "auth": {
    "signIn": "Đăng nhập",
    "signInTitle": "Chào mừng trở lại",
    "signInSubtitle": "Đăng nhập để vào hệ thống của bệnh viện.",
    "username": "Tên đăng nhập hoặc email",
    "password": "Mật khẩu",
    "signingIn": "Đang đăng nhập…",
    "sessionExpired": "Phiên làm việc đã hết hạn. Vui lòng đăng nhập lại.",
    "changePassword": "Đổi mật khẩu",
    "currentPassword": "Mật khẩu hiện tại",
    "newPassword": "Mật khẩu mới",
    "confirmPassword": "Xác nhận mật khẩu mới",
    "passwordMismatch": "Mật khẩu không khớp",
    "passwordChanged": "Đã đổi mật khẩu. Vui lòng đăng nhập lại.",
    "passwordPolicy": "Ít nhất 8 ký tự, gồm chữ hoa, chữ thường và chữ số.",
    "switchHospital": "Chuyển bệnh viện",
    "hospital": "Bệnh viện",
    "demoAccounts": "Tài khoản dùng thử",
    "showPassword": "Hiện mật khẩu",
    "hidePassword": "Ẩn mật khẩu",
    "usernamePlaceholder": "ví dụ: doctor",
    "featureClinical": "Bệnh nhân, lượt khám, nhà thuốc, xét nghiệm và viện phí ở một nơi",
    "featureAnalytics": "Bảng điều khiển trực tiếp và phân tích so sánh theo năm",
    "featureLanguages": "Lào, Thái, Anh, Trung và Việt — tùy chỉnh được cách gọi",
    "featureSecurity": "Phân quyền theo vai trò với nhật ký kiểm tra đầy đủ",
    "stats": {
      "title": "Thống kê trực tiếp",
      "patients": "Bệnh nhân đăng ký",
      "newThisMonth": "+{{count}} tháng này",
      "visitsThisYear": "Lượt khám năm nay",
      "today": "{{count}} hôm nay",
      "eyeExams": "Lượt khám mắt",
      "surgeries": "{{count}} ca mổ mắt",
      "villages": "Bản được phục vụ",
      "provinces": "tại {{count}} tỉnh",
      "departments": "Khoa lâm sàng",
      "practitioners": "{{count}} bác sĩ",
      "appAccounts": "Người dùng app bệnh nhân",
      "patientApp": "qua ứng dụng di động",
      "visitsByMonth": "Lượt khám mỗi tháng (12 tháng qua)"
    },
    "app": {
      "title": "Ứng dụng di động",
      "download": "Tải APK",
      "scan": "Quét bằng điện thoại",
      "howTo": "Cách cài đặt",
      "step1": "Tải APK về điện thoại Android (Android 7.0 trở lên).",
      "step2": "Mở tệp và cho phép cài ứng dụng từ nguồn này khi được hỏi.",
      "step3": "Mở ứng dụng: bệnh nhân tạo tài khoản bằng số điện thoại hoặc e-mail; nhân viên đăng nhập bằng tên người dùng.",
      "version": "Android · phiên bản {{version}} · {{date}}",
      "patient": {
        "name": "HMS Bệnh nhân",
        "desc": "Cho bệnh nhân: đăng ký bằng số điện thoại hoặc e-mail, xem hồ sơ, hàng đợi và hóa đơn"
      },
      "staff": {
        "name": "HMS Nhân viên",
        "desc": "Cho nhân viên bệnh viện: đăng nhập bằng tài khoản HMS"
      }
    }
  },
  "errors": {
    "generic": "Đã xảy ra lỗi. Vui lòng thử lại.",
    "network": "Không kết nối được máy chủ. Vui lòng kiểm tra kết nối mạng.",
    "UNAUTHORIZED": "Vui lòng đăng nhập để tiếp tục.",
    "INVALID_CREDENTIALS": "Sai tên đăng nhập hoặc mật khẩu.",
    "ACCOUNT_LOCKED": "Tài khoản tạm bị khóa do đăng nhập sai nhiều lần. Vui lòng thử lại sau.",
    "ACCOUNT_DISABLED": "Tài khoản bị khóa. Liên hệ bệnh viện.",
    "TOKEN_INVALID": "Phiên làm việc không còn hợp lệ. Vui lòng đăng nhập lại.",
    "TOKEN_REUSED": "Phiên đã kết thúc vì an toàn. Vui lòng đăng nhập lại.",
    "SESSION_EXPIRED": "Phiên làm việc đã hết hạn. Vui lòng đăng nhập lại.",
    "NO_HOSPITAL_ACCESS": "Tài khoản của bạn chưa được cấp quyền vào bệnh viện nào.",
    "HOSPITAL_ACCESS_DENIED": "Bạn không có quyền truy cập bệnh viện đó.",
    "FORBIDDEN": "Bạn không có quyền thực hiện thao tác này.",
    "NOT_FOUND": "Không tìm thấy dữ liệu yêu cầu.",
    "VALIDATION_FAILED": "Vui lòng sửa các trường được đánh dấu.",
    "INVALID_JSON": "Không đọc được yêu cầu.",
    "INVALID_PARAMETER": "Giá trị bộ lọc không hợp lệ.",
    "DUPLICATE": "Đã tồn tại bản ghi có cùng giá trị.",
    "CONFLICT": "Dữ liệu xung đột với dữ liệu hiện có.",
    "VERSION_CONFLICT": "Bản ghi đã được người khác thay đổi. Vui lòng tải lại và thử lại.",
    "SCHEDULE_CONFLICT": "Khung giờ này trùng với lịch hẹn khác của bác sĩ.",
    "INVALID_STATE": "Không thể thực hiện thao tác này ở trạng thái hiện tại.",
    "INVALID_TRANSITION": "Không thể thực hiện thao tác này ở trạng thái hiện tại.",
    "MRN_EXISTS": "Mã hồ sơ này đã được sử dụng.",
    "DUPLICATE_IDENTIFIER": "Đã có bệnh nhân dùng giấy tờ tùy thân này.",
    "POTENTIAL_DUPLICATE": "Đã có bệnh nhân tương tự.",
    "ALLERGY_WARNING": "Thuốc trùng với tiền sử dị ứng đã ghi nhận.",
    "OVERPAYMENT": "Số tiền vượt quá số dư còn nợ.",
    "TOO_MANY_REQUESTS": "Quá nhiều yêu cầu. Vui lòng đợi một chút.",
    "INTERNAL_ERROR": "Máy chủ gặp lỗi không mong muốn.",
    "UNSIGNED_NOTES": "Vui lòng ký hoặc xóa các ghi chú nháp trước khi kết thúc.",
    "ENCOUNTER_CLOSED": "Lượt khám này đã đóng.",
    "ENCOUNTER_EXISTS": "Lịch hẹn này đã có lượt khám.",
    "ENCOUNTER_HAS_ACTIVITY": "Không thể hủy lượt khám đã có ghi chú ký hoặc y lệnh.",
    "QUEUE_CLOSED": "Hàng đợi của khoa này đã đóng.",
    "INVOICE_HAS_PAYMENTS": "Vui lòng hoàn tiền trước khi hủy hóa đơn.",
    "EMPTY_INVOICE": "Hóa đơn cần ít nhất một mục.",
    "SPECIMEN_NOT_COLLECTED": "Vui lòng lấy mẫu trước khi nhập kết quả.",
    "RESULT_VERIFIED": "Kết quả đã duyệt phải được sửa qua quy trình đính chính.",
    "NOTHING_TO_DISPENSE": "Không còn thuốc cần cấp phát.",
    "QUANTITY_EXCEEDED": "Số lượng vượt quá số lượng kê đơn.",
    "CANNOT_DISABLE_SELF": "Bạn không thể vô hiệu hóa tài khoản của chính mình.",
    "CONSTRAINT_VIOLATION": "Dữ liệu vi phạm quy tắc lâm sàng hoặc nghiệp vụ.",
    "INVALID_REFERENCE": "Bản ghi được tham chiếu không tồn tại.",
    "PATIENT_INACTIVE": "Hồ sơ bệnh nhân này không hoạt động.",
    "PATIENT_MISMATCH": "Bản ghi được chọn thuộc về bệnh nhân khác.",
    "NOTE_SIGNED": "Ghi chú đã ký không thể sửa; hãy tạo bản bổ sung.",
    "NOTE_NOT_SIGNED": "Chỉ có thể bổ sung ghi chú đã ký.",
    "NO_DEPARTMENT": "Vui lòng chọn khoa trước.",
    "IDEMPOTENCY_KEY_REUSED": "Yêu cầu thanh toán này đã được dùng cho hóa đơn khác.",
    "LOCALE_REQUIRED": "Không thể tắt tiếng Anh.",
    "RETRY": "Bản ghi đang bận. Vui lòng thử lại.",
    "EXAM_SIGNED": "Lần khám đã ký. Hãy tạo bản sửa đổi để thay đổi.",
    "EXAM_EMPTY": "Hãy ghi ít nhất một kết quả trước khi ký.",
    "EXAM_EXISTS": "Lượt khám này đã có phiếu khám mắt đang mở.",
    "EXAM_NOT_SIGNED": "Chỉ có thể sửa đổi lần khám đã ký.",
    "EYE_SIDE_MISMATCH": "Sai mắt: mắt không khớp với kế hoạch hoặc kết quả đo.",
    "PREOP_NOT_CONFIRMED": "Hãy hoàn thành bảng kiểm an toàn trước mổ.",
    "BIOMETRY_REQUIRED": "Phẫu thuật đục thủy tinh thể cần sinh trắc của mắt mổ.",
    "IOL_NOT_SELECTED": "Hãy chọn thủy tinh thể nhân tạo trước khi xác nhận.",
    "IOL_POWER_MISMATCH": "Công suất thủy tinh thể đặt khác với kế hoạch đã chọn.",
    "IMPLANT_EXPIRED": "Vật liệu cấy ghép đã hết hạn.",
    "MEDICATION_EXPIRED": "Lô thuốc đã hết hạn.",
    "IOL_OUT_OF_RANGE": "Số đo nằm ngoài phạm vi của công thức.",
    "BIOMETRY_LOCKED": "Sinh trắc này đã được dùng cho phẫu thuật.",
    "DATE_IN_PAST": "Ngày đã qua.",
    "PATHWAY_SHARED": "Mẫu dùng chung chỉ đọc. Hãy sao chép về bệnh viện để chỉnh sửa.",
    "STAGE_IN_USE": "Không thể xóa giai đoạn đang có bệnh nhân.",
    "PATHWAY_ARCHIVED": "Chu trình này đã lưu trữ.",
    "ACTIVATION_INVALID": "Mã kích hoạt không hợp lệ hoặc đã hết hạn.",
    "OTP_INVALID": "Mã không đúng.",
    "OTP_EXPIRED": "Mã đã hết hạn. Hãy yêu cầu mã mới.",
    "OTP_LOCKED": "Nhập sai quá nhiều lần. Hãy yêu cầu mã mới.",
    "OTP_RATE_LIMITED": "Yêu cầu quá nhiều mã. Thử lại sau.",
    "VERIFICATION_REQUIRED": "Vui lòng xuất trình giấy tờ tại quầy đăng ký trước.",
    "QUEUE_PAUSED": "Khoa này tạm dừng lấy số qua ứng dụng.",
    "EID_INVALID": "Mã QR không hợp lệ hoặc hết hạn. Nhờ bệnh nhân làm mới.",
    "EID_OTHER_HOSPITAL": "Mã QR thuộc bệnh viện khác.",
    "PHOTO_TOO_LARGE": "Ảnh không được vượt quá 2 MB",
    "PHOTO_INVALID": "Hãy tải lên ảnh JPEG, PNG hoặc WebP",
    "SUBDISTRICT_IN_USE": "Có bệnh nhân sống tại xã/cụm bản này, không thể xóa",
    "INSUFFICIENT_STOCK": "Không đủ tồn kho dùng được",
    "SELF_APPROVAL": "Người khác phải kiểm tra hoặc duyệt chứng từ do bạn lập",
    "NO_DISPENSING_STORE": "Chưa thiết lập kho cấp phát",
    "NOTHING_APPROVED": "Duyệt ít nhất một dòng hoặc từ chối đề nghị",
    "DUPLICATE_LINE": "Mỗi mặt hàng chỉ được xuất hiện một lần",
    "DISCOUNT_EXCEEDS_BALANCE": "Giảm giá làm hóa đơn thấp hơn số đã trả",
    "BED_UNAVAILABLE": "Giường này không trống",
    "BED_OCCUPIED": "Giường đang có bệnh nhân",
    "ALREADY_ADMITTED": "Bệnh nhân đang nằm viện",
    "WARD_OCCUPIED": "Khoa vẫn còn bệnh nhân",
    "ROOM_OCCUPIED": "Phòng còn giường có bệnh nhân",
    "DISCHARGE_PENDING": "Còn việc chưa hoàn thành",
    "ADMISSION_HAS_ACTIVITY": "Đã có chỉ định hoặc hóa đơn, hãy cho xuất viện",
    "SAME_BED": "Bệnh nhân đã ở giường này",
    "ALREADY_BILLED": "Đã lên hóa đơn, hãy hủy hóa đơn trước",
    "NOT_FOR_SALE": "Mặt hàng không bán",
    "PATIENT_REQUIRED": "Chọn bệnh nhân cho thuốc kiểm soát",
    "NO_CASH_SESSION": "Hãy mở ca thu ngân trước",
    "SESSION_OPEN": "Bạn đang có ca thu ngân mở",
    "SESSION_CLOSED": "Ca thu ngân đã đóng, hãy ghi trả hàng",
    "STORE_INACTIVE": "Kho không hoạt động",
    "TOO_MANY_IMAGES": "Quá nhiều ảnh",
    "POS_REFILL_ONLY": "Hàng cho điểm bán POS phải gửi theo yêu cầu bổ sung POS",
    "POS_OUTLET": "Tồn kho điểm bán POS chỉ thay đổi qua bổ sung và bán hàng",
    "NOT_A_POS_OUTLET": "Bán hàng phải thực hiện tại điểm bán POS",
    "NOT_IN_CATALOG": "Chỉ yêu cầu được sản phẩm trong danh mục POS",
    "NOTHING_TO_SEND": "Không có gì để gửi: kho không có hàng được yêu cầu",
    "EXCEEDS_SENT": "Nhận nhiều hơn số đã gửi",
    "DUPLICATE_CODE": "Mã này đã được dùng",
    "TYPE_IN_USE": "Nhóm này vẫn còn bệnh. Hãy chuyển bệnh hoặc tắt nhóm.",
    "SEGREGATION_OF_DUTIES": "Người khác (không phải người tạo) phải duyệt",
    "NOT_DRAFT": "Chỉ bản nháp mới làm được",
    "NOT_VALIDATED": "Hãy kiểm tra trước",
    "NOT_APPROVED": "Phải được duyệt trước",
    "SNAPSHOT_HAS_ERRORS": "Bản báo cáo có lỗi; hãy sửa rồi tạo phiên bản mới",
    "HASH_MISMATCH": "Nội dung bản báo cáo không khớp dấu vân tay",
    "SNAPSHOT_FINAL": "Bản báo cáo này không thể thay đổi nữa",
    "SNAPSHOT_NOT_APPROVED": "Bản báo cáo phải được duyệt",
    "OPEN_BATCH_EXISTS": "Một lô khác cho cùng dữ liệu vẫn đang mở",
    "MAPPING_OVERLAP": "Đã có ánh xạ khác cho các ngày này; hãy ngừng nó trước",
    "METADATA_MISSING": "Hãy làm mới metadata DHIS2 trước",
    "INSTANCE_DISABLED": "Kết nối DHIS2 này đang tắt",
    "NOT_RETRYABLE": "Không thể gửi lại lô này",
    "NOT_RECONCILABLE": "Chỉ đối chiếu được lô đã gửi",
    "NOT_CANCELLABLE": "Không thể hủy lô này nữa",
    "INVALID_PERIOD": "Nhập kỳ dạng 202610, 2026Q4 hoặc 2026",
    "PERIOD_TYPE_MISMATCH": "Kỳ không khớp tần suất báo cáo",
    "REPORT_RETIRED": "Báo cáo này đã ngừng dùng",
    "REPORT_EMPTY": "Báo cáo này không có KPI đang dùng",
    "NO_DIRECTION": "Hãy chọn cao tốt hay thấp tốt trước",
    "DUPLICATE_NAME": "Tên này đã được dùng",
    "UNKNOWN_CALCULATOR": "Bộ tính không xác định",
    "CONCURRENT_CHANGE": "Đã có thay đổi trong lúc này; hãy thử lại",
    "ALREADY_RETIRED": "Đã ngừng dùng",
    "OWN_TENANT": "Bạn không thể tạm ngừng tổ chức bạn đang đăng nhập",
    "OWN_HOSPITAL": "Bạn không thể ngừng bệnh viện bạn đang đăng nhập",
    "REFERRAL_CLOSED": "Chuyển tuyến đã xong không thể sửa",
    "PATIENT_MERGED": "Hồ sơ bệnh nhân này đã được gộp vào hồ sơ khác",
    "MERGE_PENDING": "Việc gộp hai hồ sơ này đang chờ duyệt",
    "BOTH_ADMITTED": "Cả hai hồ sơ đang nằm viện; hãy cho ra viện một hồ sơ trước",
    "FOLLOW_UP_CLOSED": "Lịch tái khám này đã kết thúc",
    "NOT_REQUESTED": "Yêu cầu này đã được quyết định",
    "ROLE_LOCKED": "Quản trị viên cấp cao luôn có mọi quyền",
    "ROLE_BUILT_IN": "Không thể xóa vai trò có sẵn; hãy bỏ quyền của nó",
    "ROLE_IN_USE": "Vai trò này vẫn đang gán cho người dùng",
    "DISABILITY_TYPE_IN_USE": "Có bệnh nhân thuộc loại khuyết tật này. Hãy ngừng sử dụng thay vì xóa.",
    "DISABILITY_TYPE_HAS_SUB_TYPES": "Hãy xóa hoặc chuyển các loại con trước."
  },
  "validation": {
    "required": "Bắt buộc",
    "invalid": "Giá trị không hợp lệ",
    "invalidType": "Giá trị không hợp lệ",
    "tooLong": "Quá dài",
    "invalidOption": "Vui lòng chọn một tùy chọn hợp lệ",
    "invalidDate": "Vui lòng nhập ngày hợp lệ",
    "invalidDateTime": "Vui lòng nhập ngày giờ hợp lệ",
    "invalidNumber": "Vui lòng nhập số",
    "invalidInteger": "Vui lòng nhập số nguyên",
    "outOfRange": "Giá trị nằm ngoài phạm vi",
    "invalidEmail": "Vui lòng nhập email hợp lệ",
    "invalidPhone": "Vui lòng nhập số điện thoại hợp lệ",
    "implausibleDate": "Ngày không hợp lý",
    "weakPassword": "Mật khẩu chưa đủ mạnh",
    "incorrect": "Không chính xác",
    "inPast": "Thời gian đã qua",
    "invalidKey": "Khóa bản dịch không hợp lệ",
    "invalidValue": "Nội dung bản dịch không hợp lệ",
    "tooMany": "Quá nhiều mục",
    "mustConfirm": "Bắt buộc xác nhận",
    "eyeSideMismatch": "Mắt không khớp với chẩn đoán hình ảnh",
    "beforeStart": "Phải sau ngày bắt đầu",
    "invalidUrl": "Nhập liên kết hợp lệ",
    "exceedsOutstanding": "Vượt quá số còn thiếu",
    "expired": "Đã hết hạn",
    "exceedsAvailable": "Vượt quá số hiện có",
    "insufficient": "Không đủ",
    "duplicate": "Bị trùng",
    "min": "Quá nhỏ",
    "max": "Quá lớn",
    "notDiscountable": "Phí này không được giảm",
    "belowMin": "Không được thấp hơn mức tối thiểu",
    "inFuture": "Không được ở tương lai",
    "tooOld": "Quá xa trong quá khứ (tối đa 30 ngày)",
    "beforeAdmission": "Không được trước giờ nhập viện hoặc lần chuyển giường cuối",
    "httpsRequired": "Môi trường thật cần https",
    "notFound": "Không tìm thấy",
    "notAllowed": "Không được phép ở đây",
    "platformOnly": "Chỉ quản trị viên cấp cao mới có quyền nền tảng",
    "disabilityAlone": "Loại này không thể chọn cùng loại khác",
    "disabilityOneSubtype": "Chỉ chọn một loại con",
    "tooDeep": "Quá nhiều cấp"
  },
  "enums": {
    "sex": {
      "MALE": "Nam",
      "FEMALE": "Nữ",
      "OTHER": "Khác",
      "UNKNOWN": "Không rõ"
    },
    "maritalStatus": {
      "SINGLE": "Độc thân",
      "MARRIED": "Đã kết hôn",
      "DIVORCED": "Ly hôn",
      "WIDOWED": "Góa",
      "SEPARATED": "Ly thân",
      "UNKNOWN": "Không rõ"
    },
    "patientStatus": {
      "ACTIVE": "Hoạt động",
      "INACTIVE": "Ngừng hoạt động",
      "DECEASED": "Đã mất",
      "MERGED": "Đã gộp hồ sơ"
    },
    "appointmentStatus": {
      "BOOKED": "Đã đặt",
      "CONFIRMED": "Đã xác nhận",
      "CHECKED_IN": "Đã tiếp nhận",
      "IN_PROGRESS": "Đang khám",
      "COMPLETED": "Hoàn tất",
      "CANCELLED": "Đã hủy",
      "NO_SHOW": "Không đến"
    },
    "encounterStatus": {
      "PLANNED": "Dự kiến",
      "IN_PROGRESS": "Đang diễn ra",
      "COMPLETED": "Hoàn tất",
      "CANCELLED": "Đã hủy"
    },
    "encounterType": {
      "OPD": "Ngoại trú",
      "IPD": "Nội trú",
      "EMERGENCY": "Cấp cứu",
      "TELEMEDICINE": "Khám từ xa",
      "HOME_VISIT": "Khám tại nhà"
    },
    "ticketStatus": {
      "WAITING": "Đang chờ",
      "CALLED": "Đã gọi",
      "SERVING": "Đang phục vụ",
      "SERVED": "Đã phục vụ",
      "SKIPPED": "Bỏ qua",
      "CANCELLED": "Đã hủy",
      "TRANSFERRED": "Đã chuyển tiếp"
    },
    "queuePriority": {
      "NORMAL": "Thường",
      "URGENT": "Khẩn",
      "EMERGENCY": "Cấp cứu",
      "PRIORITY": "Ưu tiên"
    },
    "labPriority": {
      "ROUTINE": "Thường quy",
      "URGENT": "Khẩn",
      "STAT": "Cấp cứu (STAT)"
    },
    "labOrderStatus": {
      "ORDERED": "Đã chỉ định",
      "COLLECTED": "Đã lấy mẫu",
      "IN_PROGRESS": "Đang xét nghiệm",
      "COMPLETED": "Hoàn tất",
      "CANCELLED": "Đã hủy"
    },
    "labItemStatus": {
      "ORDERED": "Đã chỉ định",
      "RESULTED": "Đã có kết quả",
      "VERIFIED": "Đã duyệt",
      "CANCELLED": "Đã hủy"
    },
    "resultStatus": {
      "PRELIMINARY": "Sơ bộ",
      "VERIFIED": "Đã duyệt",
      "CORRECTED": "Đã đính chính"
    },
    "resultFlag": {
      "N": "Bình thường",
      "L": "Thấp",
      "H": "Cao",
      "LL": "Thấp nguy kịch",
      "HH": "Cao nguy kịch",
      "A": "Bất thường"
    },
    "prescriptionStatus": {
      "ISSUED": "Đã kê",
      "PARTIALLY_DISPENSED": "Cấp một phần",
      "DISPENSED": "Đã cấp thuốc",
      "CANCELLED": "Đã hủy"
    },
    "invoiceStatus": {
      "DRAFT": "Nháp",
      "ISSUED": "Chưa thanh toán",
      "PARTIALLY_PAID": "Thanh toán một phần",
      "PAID": "Đã thanh toán",
      "VOID": "Đã hủy"
    },
    "paymentStatus": {
      "PENDING": "Chờ xác nhận",
      "COMPLETED": "Hoàn tất",
      "FAILED": "Thất bại",
      "REFUNDED": "Đã hoàn tiền"
    },
    "paymentMethod": {
      "CASH": "Tiền mặt",
      "CARD": "Thẻ",
      "BANK_TRANSFER": "Chuyển khoản",
      "QR": "Thanh toán QR",
      "MOBILE_MONEY": "Ví điện tử",
      "INSURANCE": "Bảo hiểm"
    },
    "allergySeverity": {
      "MILD": "Nhẹ",
      "MODERATE": "Trung bình",
      "SEVERE": "Nặng",
      "LIFE_THREATENING": "Đe dọa tính mạng"
    },
    "allergyStatus": {
      "ACTIVE": "Đang có",
      "INACTIVE": "Không còn",
      "RESOLVED": "Đã khỏi",
      "ENTERED_IN_ERROR": "Nhập nhầm"
    },
    "alertSeverity": {
      "INFO": "Thông tin",
      "WARNING": "Cảnh báo",
      "CRITICAL": "Nguy kịch"
    },
    "noteType": {
      "SOAP": "SOAP",
      "PROGRESS": "Diễn biến",
      "ADMISSION": "Nhập viện",
      "DISCHARGE": "Ra viện",
      "NURSING": "Điều dưỡng",
      "CONSULT": "Hội chẩn",
      "PROCEDURE": "Thủ thuật"
    },
    "noteStatus": {
      "DRAFT": "Nháp",
      "SIGNED": "Đã ký",
      "AMENDED": "Đã bổ sung"
    },
    "diagnosisType": {
      "PRIMARY": "Chính",
      "SECONDARY": "Kèm theo",
      "ADMITTING": "Lúc vào viện",
      "DISCHARGE": "Lúc ra viện",
      "DIFFERENTIAL": "Phân biệt"
    },
    "verificationStatus": {
      "PROVISIONAL": "Sơ bộ",
      "CONFIRMED": "Xác định",
      "REFUTED": "Loại trừ",
      "ENTERED_IN_ERROR": "Nhập nhầm"
    },
    "departmentType": {
      "CLINICAL": "Lâm sàng",
      "DIAGNOSTIC": "Cận lâm sàng",
      "SUPPORT": "Hỗ trợ",
      "ADMINISTRATIVE": "Hành chính"
    },
    "userStatus": {
      "ACTIVE": "Hoạt động",
      "LOCKED": "Bị khóa",
      "DISABLED": "Vô hiệu hóa"
    },
    "role": {
      "SUPER_ADMIN": "Quản trị viên cấp cao",
      "HOSPITAL_ADMIN": "Quản trị bệnh viện",
      "DOCTOR": "Bác sĩ",
      "NURSE": "Điều dưỡng",
      "RECEPTIONIST": "Tiếp đón",
      "PHARMACIST": "Dược sĩ",
      "LAB_TECHNICIAN": "Nhân viên xét nghiệm",
      "CASHIER": "Thu ngân",
      "OPTOMETRIST": "Chuyên viên khúc xạ",
      "INVENTORY_MANAGER": "Quản lý kho",
      "PROCUREMENT_APPROVER": "Người duyệt mua hàng",
      "IMAGING_TECHNICIAN": "Kỹ thuật viên chẩn đoán hình ảnh",
      "ACCOUNTANT": "Cán bộ tài chính",
      "POS_MANAGER": "Quản lý quầy thuốc",
      "REPORTING_OFFICER": "Cán bộ báo cáo quốc gia",
      "REPORTING_APPROVER": "Người duyệt báo cáo",
      "SYSTEM_ADMIN": "Quản trị hệ thống",
      "HOSPITAL_DIRECTOR": "Giám đốc bệnh viện",
      "MEDICAL_DIRECTOR": "Giám đốc chuyên môn",
      "OPHTHALMOLOGIST": "Bác sĩ nhãn khoa",
      "OPHTHALMIC_SURGEON": "Phẫu thuật viên nhãn khoa",
      "OPHTHALMIC_NURSE": "Điều dưỡng nhãn khoa",
      "DIAGNOSTIC_TECHNICIAN": "Kỹ thuật viên chẩn đoán",
      "MEDICAL_RECORDS_OFFICER": "Cán bộ hồ sơ bệnh án",
      "AUDITOR": "Kiểm toán viên",
      "QUEUE_DEVICE": "Thiết bị kiosk / màn hình"
    },
    "medicationOrderStatus": {
      "ACTIVE": "Chờ cấp",
      "COMPLETED": "Đã cấp",
      "CANCELLED": "Đã hủy"
    },
    "eyeExamStatus": {
      "DRAFT": "Nháp",
      "IN_PROGRESS": "Đang khám",
      "SIGNED": "Đã ký",
      "AMENDED": "Đã sửa đổi",
      "CANCELLED": "Đã hủy"
    },
    "surgeryStatus": {
      "PLANNED": "Đã lên kế hoạch",
      "CONFIRMED": "Đã xác nhận bảng kiểm",
      "IN_PROGRESS": "Đang phẫu thuật",
      "COMPLETED": "Hoàn thành",
      "CANCELLED": "Đã hủy"
    },
    "followUpStatus": {
      "SCHEDULED": "Đã hẹn",
      "COMPLETED": "Xong",
      "MISSED": "Không đến",
      "CANCELLED": "Đã hủy"
    },
    "eyeMedStatus": {
      "ACTIVE": "Đang dùng",
      "COMPLETED": "Hoàn thành",
      "STOPPED": "Đã ngừng"
    },
    "carePlanStatus": {
      "ACTIVE": "Đang thực hiện",
      "COMPLETED": "Hoàn thành",
      "STOPPED": "Đã dừng"
    },
    "portalStatus": {
      "ACTIVE": "Ứng dụng hoạt động",
      "DISABLED": "Ứng dụng bị khóa"
    },
    "portalVerification": {
      "VERIFIED": "Đã xác minh danh tính",
      "PENDING_VERIFICATION": "Chờ kiểm tra giấy tờ"
    },
    "queueStatus": {
      "OPEN": "Mở",
      "PAUSED": "Tạm dừng lấy số qua app",
      "CLOSED": "Đóng"
    },
    "inventoryItemType": {
      "DRUG": "Thuốc",
      "SUPPLY": "Vật tư y tế",
      "EQUIPMENT": "Thiết bị",
      "DEVICE": "Thiết bị y tế (bán)"
    },
    "stockStatus": {
      "OUT": "Hết",
      "LOW": "Sắp hết",
      "OK": "Đủ",
      "OVER": "Dư",
      "ASSET": "Theo máy",
      "EXPIRING": "Hết hạn ≤ 90 ngày"
    },
    "expiryStatus": {
      "EXPIRED": "Hết hạn",
      "EXPIRING": "Sắp hết hạn"
    },
    "lotStatus": {
      "AVAILABLE": "Sẵn dùng",
      "QUARANTINE": "Cách ly"
    },
    "movementType": {
      "OPENING": "Tồn đầu",
      "RECEIPT": "Nhập mua",
      "DISPENSE": "Cấp theo đơn",
      "ISSUE": "Xuất cho khoa",
      "TRANSFER_OUT": "Chuyển đi",
      "TRANSFER_IN": "Chuyển đến",
      "ADJUSTMENT_IN": "Điều chỉnh (+)",
      "ADJUSTMENT_OUT": "Điều chỉnh (−)",
      "WRITE_OFF": "Hủy hàng",
      "RETURN_TO_SUPPLIER": "Trả nhà cung cấp",
      "SALE": "Bán tại quầy",
      "SALE_RETURN": "Khách trả hàng"
    },
    "adjustmentReason": {
      "OPENING_BALANCE": "Tồn đầu kỳ",
      "COUNT_CORRECTION": "Điều chỉnh kiểm kê",
      "DONATION": "Tài trợ",
      "FOUND": "Phát hiện thêm",
      "EXPIRED": "Hết hạn",
      "DAMAGED": "Hư hỏng",
      "LOST": "Mất",
      "RECALLED": "Thu hồi",
      "DEFECTIVE": "Lỗi",
      "OTHER": "Khác"
    },
    "prStatus": {
      "DRAFT": "Nháp",
      "SUBMITTED": "Chờ duyệt",
      "APPROVED": "Đã duyệt",
      "REJECTED": "Từ chối",
      "ORDERED": "Đã đặt hàng",
      "CANCELLED": "Đã hủy"
    },
    "prPriority": {
      "NORMAL": "Bình thường",
      "URGENT": "Khẩn"
    },
    "poStatus": {
      "DRAFT": "Nháp",
      "APPROVED": "Đã duyệt",
      "SENT": "Đã gửi",
      "PARTIALLY_RECEIVED": "Nhận một phần",
      "RECEIVED": "Đã nhận đủ",
      "CLOSED": "Đã đóng",
      "CANCELLED": "Đã hủy"
    },
    "storeType": {
      "MAIN": "Kho chính",
      "PHARMACY": "Nhà thuốc",
      "WARD": "Kho khoa phòng",
      "CLINIC": "Kho phòng khám",
      "POS": "Điểm bán POS"
    },
    "assetStatus": {
      "IN_SERVICE": "Đang dùng",
      "UNDER_MAINTENANCE": "Đang bảo trì",
      "OUT_OF_SERVICE": "Ngừng hoạt động",
      "DISPOSED": "Đã thanh lý"
    },
    "assetEvent": {
      "MAINTENANCE": "Bảo trì định kỳ",
      "CALIBRATION": "Hiệu chuẩn",
      "INSPECTION": "Kiểm tra",
      "REPAIR": "Sửa chữa",
      "STATUS_CHANGE": "Đổi trạng thái",
      "TRANSFER": "Di chuyển"
    },
    "maintenanceStatus": {
      "OK": "Đúng lịch",
      "DUE": "Đến hạn ≤ 30 ngày",
      "OVERDUE": "Quá hạn",
      "NONE": "—"
    },
    "stockUnit": {
      "TABLET": "Viên",
      "CAPSULE": "Viên nang",
      "BOTTLE": "Chai",
      "VIAL": "Lọ",
      "AMPOULE": "Ống",
      "SACHET": "Gói",
      "TUBE": "Tuýp",
      "INHALER": "Bình xịt",
      "PIECE": "Cái",
      "BOX": "Hộp",
      "PACK": "Gói",
      "ROLL": "Cuộn",
      "SYRINGE": "Ống tiêm",
      "SET": "Bộ",
      "UNIT": "Đơn vị"
    },
    "bedStatus": {
      "AVAILABLE": "Trống",
      "OCCUPIED": "Có bệnh nhân",
      "CLEANING": "Đang vệ sinh",
      "RESERVED": "Đã giữ chỗ",
      "OUT_OF_SERVICE": "Ngừng sử dụng"
    },
    "roomType": {
      "STANDARD": "Tiêu chuẩn",
      "PRIVATE": "Phòng riêng",
      "VIP": "VIP",
      "ICU": "Hồi sức tích cực",
      "OBSERVATION": "Theo dõi",
      "ISOLATION": "Cách ly"
    },
    "wardType": {
      "GENERAL": "Tổng quát",
      "SURGICAL": "Ngoại khoa",
      "PEDIATRIC": "Nhi",
      "MATERNITY": "Sản",
      "ICU": "Hồi sức tích cực",
      "OBSERVATION": "Theo dõi",
      "ISOLATION": "Cách ly",
      "PRIVATE": "Dịch vụ"
    },
    "bedType": {
      "STANDARD": "Tiêu chuẩn",
      "ELECTRIC": "Giường điện",
      "ICU": "ICU",
      "PEDIATRIC": "Trẻ em",
      "CRIB": "Nôi"
    },
    "admissionType": {
      "EMERGENCY": "Cấp cứu",
      "ELECTIVE": "Theo kế hoạch",
      "TRANSFER_IN": "Chuyển đến",
      "DAY_CASE": "Trong ngày",
      "MATERNITY": "Sinh đẻ"
    },
    "admissionStatus": {
      "ADMITTED": "Đang nằm viện",
      "DISCHARGED": "Đã xuất viện",
      "CANCELLED": "Đã hủy"
    },
    "dischargeType": {
      "HOME": "Về nhà",
      "REFERRED": "Chuyển tuyến",
      "AGAINST_ADVICE": "Xin về",
      "TRANSFERRED": "Chuyển viện",
      "DECEASED": "Tử vong"
    },
    "stayReason": {
      "ADMISSION": "Nhập viện",
      "TRANSFER": "Chuyển giường"
    },
    "serviceCategory": {
      "XRAY": "X-quang",
      "CT": "CT",
      "MRI": "MRI",
      "ULTRASOUND": "Siêu âm",
      "ECG": "Điện tim",
      "ECHO": "Siêu âm tim",
      "ENDOSCOPY": "Nội soi",
      "PHYSIOTHERAPY": "Vật lý trị liệu",
      "DENTAL": "Nha khoa",
      "PROCEDURE": "Thủ thuật",
      "OTHER": "Khác"
    },
    "serviceOrderStatus": {
      "ORDERED": "Đã chỉ định",
      "IN_PROGRESS": "Đang thực hiện",
      "COMPLETED": "Hoàn thành",
      "CANCELLED": "Đã hủy"
    },
    "serviceItemStatus": {
      "ORDERED": "Chờ thực hiện",
      "IN_PROGRESS": "Đang làm",
      "REPORTED": "Đã có kết quả",
      "VERIFIED": "Đã duyệt",
      "CANCELLED": "Đã hủy"
    },
    "saleStatus": {
      "COMPLETED": "Đã thanh toán",
      "PARTIALLY_RETURNED": "Trả một phần",
      "RETURNED": "Đã trả hàng",
      "VOIDED": "Đã hủy"
    },
    "stockDocType": {
      "RECEIPT": "Nhập hàng",
      "OPENING": "Tồn đầu kỳ",
      "ADJUSTMENT_IN": "Điều chỉnh tăng",
      "ISSUE": "Phiếu lĩnh",
      "TRANSFER": "Chuyển kho",
      "ADJUSTMENT_OUT": "Điều chỉnh giảm",
      "WRITE_OFF": "Hủy hàng",
      "RETURN_TO_SUPPLIER": "Trả nhà cung cấp"
    },
    "stockDocStatus": {
      "DRAFT": "Nháp",
      "SUBMITTED": "Chờ kiểm tra",
      "POSTED": "Đã ghi sổ",
      "REJECTED": "Bị từ chối",
      "CANCELLED": "Đã hủy",
      "IN_TRANSIT": "Đang vận chuyển"
    },
    "expenseCategory": {
      "SUPPLIES": "Vật tư",
      "UTILITIES": "Điện nước",
      "SALARIES": "Lương",
      "MAINTENANCE": "Bảo trì",
      "RENT": "Thuê",
      "TRANSPORT": "Vận chuyển",
      "MARKETING": "Quảng cáo",
      "TRAINING": "Đào tạo",
      "TAXES": "Thuế & lệ phí",
      "OTHER": "Khác"
    },
    "expenseStatus": {
      "SUBMITTED": "Chờ duyệt",
      "APPROVED": "Đã duyệt",
      "REJECTED": "Bị từ chối",
      "CANCELLED": "Đã hủy"
    },
    "cashSessionStatus": {
      "OPEN": "Đang mở",
      "CLOSED": "Đã đóng – chờ kiểm",
      "VERIFIED": "Đã kiểm"
    },
    "priceType": {
      "CHARGE_ITEM": "Phí dịch vụ",
      "SERVICE": "Dịch vụ đặc biệt",
      "MEDICATION": "Thuốc",
      "LAB_TEST": "Xét nghiệm",
      "ROOM": "Giá giường",
      "INVENTORY_ITEM": "Giá đề xuất từ kho",
      "POS_PRODUCT": "POS y tế"
    },
    "priceStatus": {
      "ACTIVE": "Đang dùng",
      "INACTIVE": "Ngừng dùng",
      "DISCONTINUED": "Ngừng cung cấp",
      "NOT_FOR_SALE": "Không bán"
    },
    "discountType": {
      "AMOUNT": "Số tiền",
      "PERCENT": "Phần trăm"
    },
    "plSection": {
      "REVENUE": "Doanh thu",
      "COST": "Giá vốn",
      "EXPENSES": "Chi phí",
      "RESULT": "Kết quả"
    },
    "plLine": {
      "INVOICES": "Hóa đơn bệnh nhân",
      "POS_SALES": "Bán tại quầy",
      "REFUNDS": "Hoàn tiền",
      "TOTAL_REVENUE": "Tổng doanh thu",
      "COST_OF_GOODS": "Thuốc và vật tư đã dùng",
      "GROSS_PROFIT": "Lợi nhuận gộp",
      "TOTAL_EXPENSES": "Tổng chi phí",
      "NET_PROFIT": "Lợi nhuận ròng"
    },
    "posLevel": {
      "OK": "Đủ",
      "LOW": "Sắp hết",
      "OUT": "Hết hàng"
    },
    "posProductStatus": {
      "PUBLISHED": "Hiển thị tại POS",
      "HIDDEN": "Đã ẩn"
    },
    "outletStatus": {
      "ACTIVE": "Đang dùng",
      "INACTIVE": "Ngừng dùng"
    },
    "refillStatus": {
      "DRAFT": "Bản nháp",
      "SUBMITTED": "Chờ kho",
      "PREPARING": "Đang chuẩn bị",
      "IN_TRANSIT": "Đang vận chuyển",
      "RECEIVED": "Đã nhận",
      "REJECTED": "Bị từ chối",
      "CANCELLED": "Đã hủy"
    },
    "patientTitle": {
      "MR": "Ông (ທ້າວ)",
      "MRS": "Bà (ນາງ)",
      "MISS": "Cô (ນາງສາວ)",
      "BOY": "Bé trai (ເດັກຊາຍ)",
      "GIRL": "Bé gái (ເດັກຍິງ)",
      "DR": "TS. (ດຣ.)",
      "MONK": "Nhà sư (ພຣະ)",
      "NOVICE": "Sa di (ສາມະເນນ)",
      "NUN": "Ni cô (ແມ່ຂາວ)"
    },
    "reporting": {
      "ACHIEVED": "Đạt",
      "WARNING": "Cảnh báo",
      "MISSED": "Không đạt",
      "INSUFFICIENT_DATA": "Thiếu dữ liệu",
      "NOT_APPLICABLE": "Không có mục tiêu",
      "PENDING_REVIEW": "Chờ xem xét",
      "OK": "Tốt",
      "INCOMPLETE": "Chưa đủ",
      "INVALID": "Không hợp lệ",
      "DRAFT": "Nháp",
      "VALIDATED": "Đã kiểm tra",
      "APPROVED": "Đã duyệt",
      "SUPERSEDED": "Đã thay thế",
      "INVALIDATED": "Đã vô hiệu",
      "ACTIVE": "Đang dùng",
      "RETIRED": "Ngừng dùng",
      "QUEUED": "Chờ gửi",
      "SUBMITTING": "Đang gửi",
      "ACCEPTED": "Đã nhận",
      "PARTIALLY_ACCEPTED": "Nhận một phần",
      "REJECTED": "Bị từ chối",
      "RETRY_PENDING": "Chờ gửi lại",
      "RECONCILIATION_REQUIRED": "Cần đối chiếu",
      "CANCELLED": "Đã hủy",
      "PENDING": "Đang chờ",
      "IGNORED": "Bỏ qua"
    },
    "kpiCategory": {
      "OPERATIONS": "Vận hành",
      "CLINICAL": "Lâm sàng",
      "SURGERY": "Phẫu thuật",
      "EYE_HEALTH": "Sức khỏe mắt",
      "EPIDEMIOLOGY": "Dịch tễ",
      "INPATIENT": "Nội trú",
      "SUPPLIES": "Vật tư",
      "DATA_QUALITY": "Chất lượng dữ liệu",
      "STAFF": "Nhân sự"
    },
    "kpiUnit": {
      "COUNT": "Số lượng",
      "PERCENT": "Phần trăm",
      "MINUTES": "Phút",
      "DAYS": "Ngày",
      "RATIO": "Tỷ lệ"
    },
    "kpiDirection": {
      "HIGHER_BETTER": "Càng cao càng tốt",
      "LOWER_BETTER": "Càng thấp càng tốt",
      "INFO": "Chỉ để thông tin"
    },
    "dimension": {
      "SEX": "Giới tính",
      "AGE_BAND": "Nhóm tuổi",
      "MALE": "Nam",
      "FEMALE": "Nữ",
      "AGE_0_14": "0–14 tuổi",
      "AGE_15_49": "15–49 tuổi",
      "AGE_50P": "50 tuổi trở lên"
    },
    "dhis2Env": {
      "MOCK": "Mô phỏng",
      "STAGING": "Thử nghiệm",
      "PRODUCTION": "Thật"
    },
    "mappingType": {
      "ORG_UNIT": "Đơn vị tổ chức",
      "DATA_SET": "Bộ dữ liệu",
      "DATA_ELEMENT": "Phần tử dữ liệu",
      "CATEGORY_OPTION": "Lựa chọn nhóm"
    },
    "valueTransform": {
      "NONE": "Như đã tính",
      "ROUND": "Số nguyên",
      "ONE_DECIMAL": "Một chữ số thập phân"
    },
    "metadataKind": {
      "ORG_UNIT": "Đơn vị",
      "DATA_SET": "Bộ dữ liệu",
      "DATA_ELEMENT": "Phần tử dữ liệu",
      "CATEGORY_OPTION_COMBO": "Tổ hợp nhóm",
      "ATTRIBUTE_OPTION_COMBO": "Tổ hợp thuộc tính"
    },
    "tenantType": {
      "HEALTHCARE_GROUP": "Nhóm y tế",
      "HOSPITAL": "Bệnh viện",
      "CLINIC": "Phòng khám",
      "GOVERNMENT": "Nhà nước",
      "NGO": "Tổ chức phi chính phủ"
    },
    "tenantStatus": {
      "ACTIVE": "Đang dùng",
      "SUSPENDED": "Tạm ngừng",
      "INACTIVE": "Ngừng dùng"
    },
    "referralStatus": {
      "REQUESTED": "Đã yêu cầu",
      "SENT": "Đã gửi",
      "ACCEPTED": "Đã nhận",
      "DECLINED": "Bị từ chối",
      "COMPLETED": "Hoàn tất",
      "CANCELLED": "Đã hủy",
      "UNREACHABLE": "Không liên lạc được"
    },
    "referralDirection": {
      "OUT": "Chuyển đi",
      "IN": "Chuyển đến"
    },
    "referralPriority": {
      "ROUTINE": "Thường",
      "URGENT": "Khẩn",
      "EMERGENCY": "Cấp cứu"
    },
    "referralTransport": {
      "SELF": "Tự đi",
      "FAMILY": "Cùng gia đình",
      "AMBULANCE": "Xe cấp cứu",
      "HOSPITAL_VEHICLE": "Xe bệnh viện",
      "OTHER": "Khác"
    },
    "referralEvent": {
      "CREATED": "Tạo",
      "UPDATED": "Sửa",
      "SENT": "Gửi",
      "ACCEPTED": "Nhận",
      "DECLINED": "Từ chối",
      "CONTACT_ATTEMPT": "Liên hệ",
      "UNREACHABLE": "Không liên lạc được",
      "COMPLETED": "Hoàn tất",
      "CANCELLED": "Hủy"
    },
    "contactResult": {
      "REACHED": "Liên lạc được",
      "NO_ANSWER": "Không trả lời",
      "WRONG_NUMBER": "Sai số",
      "LEFT_MESSAGE": "Đã để lại lời nhắn"
    },
    "followUpPriority": {
      "ROUTINE": "Thường",
      "URGENT": "Khẩn"
    },
    "mergeStatus": {
      "REQUESTED": "Chờ duyệt",
      "APPROVED": "Đã gộp",
      "REJECTED": "Từ chối",
      "CANCELLED": "Đã hủy"
    },
    "queuePriorityReason": {
      "ELDERLY": "Người cao tuổi",
      "DISABILITY": "Người khuyết tật",
      "PREGNANT": "Phụ nữ mang thai",
      "CHILD": "Trẻ nhỏ",
      "CLINICAL": "Lâm sàng",
      "OTHER": "Khác"
    },
    "queueStage": {
      "REGISTRATION": "Đăng ký",
      "TRIAGE": "Phân loại",
      "EXAMINATION": "Khám",
      "CONSULTATION": "Gặp bác sĩ",
      "DIAGNOSTICS": "Cận lâm sàng",
      "SURGERY": "Phẫu thuật",
      "PHARMACY": "Nhà thuốc",
      "CASHIER": "Thu ngân",
      "OTHER": "Khác"
    },
    "queueSource": {
      "DESK": "Quầy tiếp đón",
      "APPOINTMENT": "Check-in lịch hẹn",
      "QR": "Check-in bằng QR",
      "KIOSK": "Kiosk",
      "MOBILE": "Ứng dụng bệnh nhân"
    },
    "queueEvent": {
      "ISSUED": "Cấp số",
      "CALLED": "Đã gọi",
      "RECALLED": "Gọi lại",
      "SERVING": "Bắt đầu phục vụ",
      "COMPLETED": "Hoàn tất",
      "SKIPPED": "Bỏ qua (vắng mặt)",
      "REQUEUED": "Trở lại hàng đợi",
      "RETURNED": "Quay lại chờ",
      "CANCELLED": "Đã hủy",
      "TRANSFERRED": "Chuyển tiếp",
      "PRIORITY_CHANGED": "Đổi mức ưu tiên",
      "PATIENT_LINKED": "Liên kết hồ sơ bệnh nhân"
    },
    "queueActor": {
      "STAFF": "Nhân viên",
      "KIOSK": "Kiosk",
      "PATIENT_APP": "Ứng dụng bệnh nhân",
      "SYSTEM": "Hệ thống"
    },
    "queueVisitStatus": {
      "ACTIVE": "Đang ở bệnh viện",
      "COMPLETED": "Hoàn tất",
      "CANCELLED": "Đã hủy"
    },
    "queueServiceStatus": {
      "ACTIVE": "Đang dùng",
      "INACTIVE": "Ngừng dùng"
    }
  },
  "dashboard": {
    "title": "Tổng quan",
    "welcome": "Xin chào, {{name}}",
    "subtitle": "Hôm nay tại {{hospital}}",
    "patientsTotal": "Bệnh nhân đang hoạt động",
    "registeredToday": "Đăng ký hôm nay",
    "appointmentsToday": "Lịch hẹn hôm nay",
    "queueWaiting": "Đang chờ trong hàng đợi",
    "avgWait": "Thời gian chờ trung bình",
    "openEncounters": "Lượt khám đang mở",
    "pendingPrescriptions": "Đơn thuốc chờ cấp",
    "pendingLabOrders": "Chỉ định xét nghiệm chờ",
    "revenueToday": "Doanh thu hôm nay",
    "outstanding": "Số dư còn nợ",
    "encountersTrend": "Lượt khám · 7 ngày qua",
    "revenueTrend": "Doanh thu · 7 ngày qua",
    "appointmentsByDepartment": "Lịch hẹn hôm nay theo khoa",
    "minutes": "{{value}} phút",
    "noData": "Chưa có dữ liệu",
    "quickActions": "Thao tác nhanh"
  },
  "patients": {
    "title": "Bệnh nhân",
    "register": "Đăng ký bệnh nhân",
    "searchPlaceholder": "Tìm theo tên, mã hồ sơ, số điện thoại hoặc CCCD",
    "mrn": "Mã hồ sơ",
    "name": "Họ tên",
    "firstName": "Tên",
    "middleName": "Tên đệm",
    "lastName": "Họ",
    "preferredName": "Tên thường gọi",
    "dateOfBirth": "Ngày sinh",
    "age": "Tuổi",
    "sex": "Giới tính",
    "bloodGroup": "Nhóm máu",
    "maritalStatus": "Tình trạng hôn nhân",
    "occupation": "Nghề nghiệp",
    "nationality": "Quốc tịch",
    "phone": "Điện thoại",
    "email": "Email",
    "address": "Địa chỉ",
    "emergencyContactName": "Người liên hệ khẩn cấp",
    "emergencyContactPhone": "SĐT liên hệ khẩn cấp",
    "nationalId": "Số CCCD",
    "preferredLanguage": "Ngôn ngữ ưu tiên",
    "identifiers": "Giấy tờ tùy thân",
    "identifierType": "Loại giấy tờ",
    "identifierValue": "Số giấy tờ",
    "addIdentifier": "Thêm giấy tờ",
    "registeredOn": "Ngày đăng ký",
    "sectionPersonal": "Thông tin cá nhân",
    "sectionContact": "Liên hệ",
    "sectionEmergency": "Liên hệ khẩn cấp",
    "sectionIdentifiers": "Giấy tờ tùy thân",
    "created": "Đã đăng ký bệnh nhân {{mrn}}",
    "updated": "Đã cập nhật hồ sơ bệnh nhân",
    "editTitle": "Sửa thông tin bệnh nhân",
    "duplicateTitle": "Có thể trùng bệnh nhân",
    "duplicateMessage": "Các hồ sơ sau trông tương tự. Hãy mở một hồ sơ, hoặc xác nhận đây là người khác.",
    "duplicateConfirm": "Người khác — vẫn đăng ký",
    "identifierMatchTitle": "Giấy tờ này đã được đăng ký",
    "matchReason": {
      "NAME_AND_BIRTH_DATE": "Trùng họ tên và ngày sinh",
      "PHONE_AND_FIRST_NAME": "Trùng số điện thoại và tên"
    },
    "allergies": "Dị ứng",
    "noKnownAllergies": "Không có dị ứng đã biết",
    "addAllergy": "Thêm dị ứng",
    "allergen": "Dị nguyên",
    "reaction": "Phản ứng",
    "severity": "Mức độ",
    "onsetDate": "Ngày khởi phát",
    "alerts": "Cảnh báo",
    "addAlert": "Thêm cảnh báo",
    "alertType": "Loại cảnh báo",
    "alertMessage": "Nội dung",
    "tabOverview": "Tổng quan",
    "tabEncounters": "Lượt khám",
    "tabAppointments": "Lịch hẹn",
    "tabPrescriptions": "Đơn thuốc",
    "tabLabs": "Kết quả xét nghiệm",
    "tabInvoices": "Hóa đơn",
    "newEncounter": "Bắt đầu khám",
    "bookAppointment": "Đặt lịch hẹn",
    "addToQueue": "Thêm vào hàng đợi",
    "empty": "Không có bệnh nhân phù hợp.",
    "pickerPlaceholder": "Tìm bệnh nhân theo tên hoặc mã hồ sơ",
    "sectionPhoto": "Ảnh",
    "sectionAddress": "Địa chỉ",
    "province": "Tỉnh",
    "district": "Huyện",
    "subdistrict": "Xã/cụm bản",
    "village": "Bản/làng",
    "addressLine": "Số nhà / đường",
    "addressLineHint": "Không bắt buộc: số nhà, tổ, đường hoặc điểm mốc",
    "chooseProvinceFirst": "Chọn tỉnh trước",
    "chooseDistrictFirst": "Chọn huyện trước",
    "noSubdistricts": "Chưa có xã/cụm bản",
    "disability": "Khuyết tật",
    "takePhoto": "Chụp ảnh",
    "choosePhoto": "Chọn ảnh",
    "undoPhoto": "Hoàn tác",
    "removePhoto": "Xóa ảnh",
    "photoHint": "JPEG, PNG hoặc WebP. Ảnh sẽ được thu nhỏ tự động.",
    "photoInvalid": "Tệp này không phải ảnh được hỗ trợ",
    "nameTitle": "Danh xưng",
    "noTitle": "— Không có —",
    "titleSuggested": "Gợi ý theo giới tính và tuổi",
    "disabilityDetails": "Chi tiết khuyết tật"
  },
  "appointments": {
    "title": "Lịch hẹn",
    "book": "Đặt lịch hẹn",
    "date": "Ngày",
    "start": "Bắt đầu",
    "end": "Kết thúc",
    "time": "Giờ",
    "practitioner": "Bác sĩ",
    "department": "Khoa",
    "type": "Loại khám",
    "reason": "Lý do khám",
    "notes": "Ghi chú",
    "patient": "Bệnh nhân",
    "anyPractitioner": "Tất cả bác sĩ",
    "anyDepartment": "Tất cả khoa",
    "checkIn": "Tiếp nhận",
    "confirm": "Xác nhận",
    "cancel": "Hủy lịch hẹn",
    "noShow": "Không đến",
    "startEncounter": "Bắt đầu khám",
    "openEncounter": "Mở lượt khám",
    "booked": "Đã đặt lịch hẹn {{number}}",
    "checkedIn": "Đã tiếp nhận — số thứ tự {{ticket}}",
    "cancelled": "Đã hủy lịch hẹn",
    "empty": "Không có lịch hẹn trong ngày.",
    "priority": "Ưu tiên",
    "number": "Số"
  },
  "queue": {
    "title": "Hàng đợi",
    "department": "Khoa",
    "selectDepartment": "Chọn khoa",
    "callNext": "Gọi người tiếp theo",
    "counter": "Quầy / phòng",
    "waiting": "Đang chờ",
    "inService": "Đã gọi / đang phục vụ",
    "served": "Đã phục vụ",
    "ticket": "Số thứ tự",
    "issuedAt": "Giờ lấy số",
    "recall": "Gọi lại",
    "startService": "Bắt đầu phục vụ",
    "complete": "Xong",
    "skip": "Bỏ qua",
    "requeue": "Quay lại hàng đợi",
    "cancelTicket": "Hủy số",
    "walkIn": "Lấy số trực tiếp",
    "display": "Màn hình gọi số",
    "nowServing": "Đang phục vụ",
    "nextUp": "Tiếp theo",
    "empty": "Không có ai đang chờ.",
    "calling": "Mời số {{ticket}}",
    "waitMinutes": "{{value}} phút",
    "scanQr": "Quét QR bệnh nhân",
    "estimatedWait": "Thời gian chờ ước tính",
    "min": "phút",
    "fromApp": "Số lấy qua app",
    "loadDetail": "{{counters}} quầy · chờ TB {{avg}} phút · lâu nhất {{longest}} phút",
    "open": "Mở",
    "pause": "Dừng app",
    "pauseHelp": "Ngừng lấy số qua app; quầy vẫn cấp số",
    "close": "Đóng",
    "source": {
      "MOBILE": "Từ ứng dụng bệnh nhân",
      "QR": "Đăng ký bằng QR",
      "KIOSK": "Từ kiosk"
    },
    "subtitle": "Gọi, gọi lại, bỏ qua, chuyển tiếp và hoàn tất cho bệnh nhân tại điểm phục vụ của bạn",
    "kioskOpen": "Kiosk",
    "report": "Thời gian chờ",
    "servicePoint": "Điểm phục vụ",
    "selectService": "Chọn điểm phục vụ",
    "allServices": "Tất cả điểm phục vụ",
    "stage": "Giai đoạn",
    "priorityWaiting": "Đang chờ có ưu tiên",
    "nobodyCalled": "Chưa gọi ai. Nhấn “Gọi số tiếp theo”.",
    "skipped": "Bỏ qua",
    "noSkipped": "Không có số bị bỏ qua.",
    "done": "Đã xong",
    "noneDone": "Chưa có ai xong.",
    "waitingTimes": "Báo cáo thời gian chờ",
    "notRegistered": "Chưa đăng ký",
    "assistanceRequested": "Cần hỗ trợ tại kiosk",
    "priorityRequested": "Xin ưu tiên: {{reason}}",
    "hasDisability": "Có ghi nhận khuyết tật",
    "age": "{{value}} tuổi",
    "sinceCalled": "Thời gian từ khi gọi / bắt đầu phục vụ",
    "waited": "đã chờ {{value}} phút",
    "recalled": "gọi lại {{value}} lần",
    "findOrRegister": "Tìm hoặc đăng ký bệnh nhân",
    "openEncounter": "Mở lượt khám",
    "transfer": "Chuyển tiếp",
    "backToQueue": "Quay lại chờ",
    "backToQueueHelp": "Cho bệnh nhân quay lại danh sách chờ (ví dụ chờ thuốc nhỏ mắt có tác dụng); vẫn giữ thứ tự",
    "call": "Gọi",
    "callThis": "Gọi số này ngay (ngoài thứ tự)",
    "priority": "Ưu tiên",
    "cancelTitle": "Hủy số {{ticket}}?",
    "cancelHelp": "Số này sẽ đóng và bệnh nhân rời hàng đợi. Thông tin vẫn lưu trong lịch sử hàng đợi.",
    "cancelReason": "Lý do",
    "transferredIn": "Từ hàng đợi khác",
    "setPriority": "Mức ưu tiên của {{ticket}}",
    "priorityHelp": {
      "NORMAL": "Theo thứ tự đến",
      "PRIORITY": "Người cao tuổi, khuyết tật, mang thai, trẻ nhỏ",
      "URGENT": "Lâm sàng: khám trước người khác",
      "EMERGENCY": "Lâm sàng: khám ngay"
    },
    "triageOnly": "Mức khẩn và cấp cứu do nhân viên y tế đặt.",
    "priorityReason": "Lý do ưu tiên",
    "note": "Ghi chú",
    "transferTitle": "Chuyển tiếp {{ticket}}",
    "transferHelp": "Bệnh nhân giữ nguyên số và vào hàng đợi đã chọn.",
    "registerFirst": "Bệnh nhân này chưa đăng ký. Hãy đăng ký hoặc tìm bệnh nhân trước; trước đó chỉ có thể chuyển đến quầy đăng ký.",
    "waitingCount": "{{value}} đang chờ",
    "handoverNote": "Ghi chú cho điểm phục vụ tiếp theo",
    "handoverNoteHint": "ví dụ: đã nhỏ thuốc giãn đồng tử lúc 10:15",
    "transferred": "Đã chuyển {{ticket}} đến {{service}}",
    "linkPatientTitle": "Bệnh nhân của số {{ticket}}",
    "linkPatientHelp": "Tìm hồ sơ bệnh nhân, hoặc đăng ký bệnh nhân mới (mở thẻ mới) rồi tìm ở đây.",
    "findPatient": "Bệnh nhân",
    "registerNew": "Đăng ký bệnh nhân mới",
    "linkPatient": "Liên kết với số",
    "patientLinked": "Đã liên kết bệnh nhân với số",
    "history": "Lịch sử hàng đợi",
    "historyTitle": "Lịch sử hàng đợi của {{ticket}}",
    "patient": "Bệnh nhân",
    "visitStatus": "Lượt đến",
    "timeInHospital": "Thời gian tại bệnh viện",
    "encounter": "Lượt khám",
    "noHistory": "Chưa có lịch sử.",
    "displaySetup": "Thiết lập màn hình này",
    "displaySetupHelp": "Chọn các điểm phục vụ màn hình này hiển thị. Địa chỉ màn hình giữ lựa chọn, hãy lưu dấu trang trên trình duyệt của màn hình.",
    "openDisplay": "Mở màn hình",
    "displayTitle": "Hàng đợi",
    "nowCalling": "Đang gọi",
    "pleaseWait": "Vui lòng chờ số của bạn",
    "missed": "Lỡ lượt: vui lòng đến quầy",
    "displayFooter": "Số của bạn giữ nguyên trong suốt lượt khám. Vui lòng giữ phiếu.",
    "soundOn": "Bật thông báo",
    "soundOff": "Tắt thông báo",
    "fullscreen": "Toàn màn hình",
    "tapForSound": "Chạm để bật âm thanh",
    "announce": "Số {{ticket}}, mời đến {{counter}}, {{service}}",
    "rep": {
      "title": "Thời gian chờ hàng đợi",
      "subtitle": "Thời gian chờ và thời gian phục vụ từ lịch sử hàng đợi, theo điểm phục vụ",
      "today": "Hôm nay",
      "week": "7 ngày",
      "month": "30 ngày",
      "noData": "Không có số nào trong khoảng thời gian này.",
      "avgWait": "Thời gian chờ trung bình",
      "medianWait": "Thời gian chờ trung vị",
      "p90Wait": "90% được gọi trong",
      "p90Hint": "9 trên 10 bệnh nhân chờ ít hơn mức này",
      "maxWait": "Chờ lâu nhất",
      "waitHint": "Từ lúc vào hàng đợi đến lần gọi đầu tiên",
      "avgService": "Thời gian phục vụ trung bình",
      "avgVisit": "Thời gian lượt đến trung bình",
      "visitsCompleted": "Hoàn tất {{value}} / {{total}} lượt",
      "tickets": "Số thứ tự",
      "ticketsHint": "{{served}} đã phục vụ · {{transferred}} chuyển tiếp",
      "missed": "Bỏ qua (vắng mặt)",
      "cancelled": "{{value}} đã hủy",
      "kiosk": "Lượt qua kiosk",
      "kioskHint": "{{registered}} đăng ký tại quầy · {{help}} cần hỗ trợ",
      "byHour": "Lượt đến theo giờ trong ngày",
      "arrivals": "{{value}} lượt đến",
      "avgWaitShort": "chờ TB {{value}} phút",
      "bySourcePriority": "Theo nguồn và mức ưu tiên",
      "byService": "Theo điểm phục vụ",
      "transferredOn": "Chuyển tiếp",
      "byDay": "Theo ngày"
    },
    "kiosk": {
      "title": "Tự check-in",
      "welcome": "Xin chào. Hôm nay chúng tôi có thể giúp gì cho bạn?",
      "haveAppointment": "Tôi có lịch hẹn hôm nay",
      "haveAppointmentHint": "Check-in và nhận số thứ tự",
      "registeredWalkIn": "Tôi là bệnh nhân cũ, không có hẹn",
      "registeredWalkInHint": "Nhận số cho một dịch vụ",
      "newOrHelp": "Bệnh nhân mới, hoặc tôi cần hỗ trợ",
      "newOrHelpHint": "Nhận số cho quầy đăng ký",
      "emergencyNote": "Cấp cứu? Hãy đến thẳng khoa cấp cứu hoặc báo cho nhân viên.",
      "identifyTitle": "Tìm hồ sơ của bạn",
      "mrnOrPhone": "Mã bệnh nhân (HN) hoặc số điện thoại",
      "birthDate": "Ngày sinh",
      "day": "Ngày",
      "month": "Tháng",
      "year": "Năm",
      "delete": "Xóa",
      "privacy": "Chúng tôi chỉ dùng thông tin này để tìm hồ sơ của bạn. Không hiển thị thông tin cá nhân trên màn hình.",
      "continue": "Tiếp tục",
      "hello": "Xin chào {{name}}.",
      "noAppointment": "Không tìm thấy lịch hẹn của bạn hôm nay.",
      "takeWalkIn": "Nhận số cho một dịch vụ",
      "checkIn": "Check-in",
      "chooseService": "Bạn muốn đến đâu?",
      "waitInfo": "{{waiting}} đang chờ · khoảng {{minutes}} phút",
      "priorityQuestion": "Bạn có cần phục vụ ưu tiên không?",
      "priorityHint": "Nhân viên sẽ xác nhận ưu tiên khi gọi bạn.",
      "request": {
        "ELDERLY": "Từ 60 tuổi trở lên",
        "DISABILITY": "Người khuyết tật",
        "PREGNANT": "Đang mang thai",
        "CHILD": "Đi cùng trẻ nhỏ"
      },
      "notSure": "Chưa biết đi đâu? Nhận số cho quầy đăng ký",
      "helpTitle": "Quầy đăng ký",
      "helpText": "Nhân viên quầy đăng ký sẽ đăng ký hoặc hỗ trợ bạn, rồi hướng dẫn bạn đến đúng dịch vụ.",
      "newPatientTicket": "Tôi là bệnh nhân mới",
      "needHelpTicket": "Tôi cần hỗ trợ",
      "registrationTicket": "Nhận số cho quầy đăng ký",
      "startOver": "Bắt đầu lại",
      "yourNumber": "Số của bạn",
      "ahead": "{{value}} người trước bạn · khoảng {{minutes}} phút",
      "slipNote": "Vui lòng theo dõi số của bạn trên màn hình. Số giữ nguyên trong suốt lượt khám.",
      "slipRegistration": "Vui lòng chờ đến khi số của bạn được gọi đến quầy đăng ký.",
      "alreadyQueued": "Bạn đã có số hôm nay. Đây là số của bạn.",
      "print": "In phiếu",
      "done": "Xong",
      "error": {
        "NOT_FOUND": "Không tìm thấy hồ sơ với thông tin này.",
        "TOO_MANY_REQUESTS": "Quá nhiều lần thử. Vui lòng hỏi quầy đăng ký.",
        "QUEUE_PAUSED": "Tự check-in đang tạm dừng cho dịch vụ này. Vui lòng hỏi quầy.",
        "QUEUE_CLOSED": "Dịch vụ này hôm nay đã đóng. Vui lòng hỏi quầy.",
        "NOT_TODAY": "Lịch hẹn này không phải hôm nay.",
        "INVALID_TRANSITION": "Không thể check-in lịch hẹn này tại đây. Vui lòng hỏi quầy.",
        "NO_DEPARTMENT": "Không thể check-in lịch hẹn này tại đây. Vui lòng hỏi quầy.",
        "OTHER": "Đã xảy ra lỗi. Vui lòng hỏi quầy đăng ký."
      }
    }
  },
  "encounters": {
    "title": "Lượt khám",
    "mine": "Bệnh nhân của tôi",
    "all": "Tất cả",
    "today": "Hôm nay",
    "number": "Mã lượt khám",
    "type": "Loại",
    "startedAt": "Bắt đầu",
    "endedAt": "Kết thúc",
    "chiefComplaint": "Lý do chính",
    "practitioner": "Bác sĩ",
    "department": "Khoa",
    "complete": "Kết thúc khám",
    "completeConfirm": "Kết thúc lượt khám này? Ghi chú và y lệnh sẽ chỉ còn được xem.",
    "cancel": "Hủy lượt khám",
    "cancelReason": "Lý do hủy",
    "started": "Đã bắt đầu lượt khám {{number}}",
    "completed": "Đã kết thúc lượt khám",
    "vitals": "Dấu hiệu sinh tồn",
    "recordVitals": "Ghi dấu hiệu sinh tồn",
    "temperature": "Nhiệt độ",
    "heartRate": "Mạch",
    "respiratoryRate": "Nhịp thở",
    "bloodPressure": "Huyết áp",
    "systolic": "Tâm thu",
    "diastolic": "Tâm trương",
    "spo2": "SpO₂",
    "weight": "Cân nặng",
    "height": "Chiều cao",
    "bmi": "BMI",
    "painScore": "Mức đau (0–10)",
    "recordedAt": "Thời điểm ghi",
    "recordedBy": "Người ghi",
    "unitCelsius": "°C",
    "unitBpm": "lần/phút",
    "unitPerMin": "/phút",
    "unitMmHg": "mmHg",
    "unitPercent": "%",
    "unitKg": "kg",
    "unitCm": "cm",
    "diagnoses": "Chẩn đoán",
    "addDiagnosis": "Thêm chẩn đoán",
    "diagnosisCode": "Mã ICD-10",
    "diagnosisDescription": "Tên chẩn đoán",
    "diagnosisType": "Loại",
    "verification": "Mức xác định",
    "markEnteredInError": "Đánh dấu nhập nhầm",
    "notes": "Ghi chép lâm sàng",
    "newNote": "Ghi chú mới",
    "noteType": "Loại ghi chú",
    "content": "Nội dung",
    "saveDraft": "Lưu nháp",
    "saveAndSign": "Lưu và ký",
    "sign": "Ký",
    "amend": "Bổ sung",
    "amendReason": "Lý do bổ sung",
    "amendmentOf": "Bản bổ sung của ghi chú trước",
    "signedBy": "Ký bởi {{name}} · {{time}}",
    "draftBy": "Bản nháp của {{name}}",
    "prescriptions": "Đơn thuốc",
    "newPrescription": "Kê đơn mới",
    "labOrders": "Chỉ định xét nghiệm",
    "newLabOrder": "Chỉ định xét nghiệm",
    "noVitals": "Chưa ghi dấu hiệu sinh tồn.",
    "noDiagnoses": "Chưa có chẩn đoán.",
    "noNotes": "Chưa có ghi chú.",
    "noPrescriptions": "Chưa có đơn thuốc.",
    "noLabOrders": "Chưa có chỉ định xét nghiệm.",
    "closedBanner": "Lượt khám này ở trạng thái {{status}} và chỉ được xem.",
    "start": "Bắt đầu khám",
    "empty": "Không tìm thấy lượt khám.",
    "soapTemplate": "S (Chủ quan):\nO (Khách quan):\nA (Đánh giá):\nP (Kế hoạch):"
  },
  "pharmacy": {
    "title": "Nhà thuốc",
    "worklist": "Chờ cấp phát",
    "history": "Lịch sử",
    "catalog": "Danh mục thuốc",
    "prescription": "Đơn thuốc",
    "prescriptionNumber": "Số đơn thuốc",
    "prescriber": "Bác sĩ kê đơn",
    "issuedAt": "Ngày kê",
    "items": "Thuốc",
    "medication": "Thuốc",
    "selectMedication": "Tìm thuốc",
    "dose": "Liều",
    "doseUnit": "Đơn vị",
    "frequency": "Tần suất",
    "route": "Đường dùng",
    "duration": "Thời gian dùng",
    "quantity": "Số lượng",
    "instructions": "Hướng dẫn",
    "addItem": "Thêm thuốc",
    "removeItem": "Bỏ",
    "issue": "Ký và phát hành",
    "issued": "Đã kê đơn {{number}}",
    "dispense": "Cấp phát",
    "dispenseAll": "Cấp toàn bộ số còn lại",
    "dispensed": "Đã cấp phát thuốc",
    "dispensedQty": "Đã cấp",
    "remaining": "Còn lại",
    "cancelPrescription": "Hủy đơn thuốc",
    "allergyWarningTitle": "Cảnh báo dị ứng",
    "allergyWarningBody": "{{medication}} trùng với dị ứng đã ghi nhận “{{allergen}}” ({{severity}}).",
    "overrideAndIssue": "Bỏ qua cảnh báo và kê đơn",
    "patientAllergies": "Dị ứng của bệnh nhân",
    "genericName": "Tên hoạt chất",
    "brandName": "Tên biệt dược",
    "strength": "Hàm lượng",
    "dosageForm": "Dạng bào chế",
    "unitPrice": "Đơn giá",
    "manufacturer": "Nhà sản xuất",
    "newMedication": "Thêm thuốc mới",
    "editMedication": "Sửa thông tin thuốc",
    "empty": "Không có đơn thuốc đang chờ."
  },
  "lab": {
    "title": "Xét nghiệm",
    "worklist": "Danh sách chờ",
    "completed": "Đã hoàn tất",
    "order": "Phiếu xét nghiệm",
    "orderNumber": "Số phiếu",
    "orderedBy": "Người chỉ định",
    "orderedAt": "Thời điểm chỉ định",
    "priority": "Ưu tiên",
    "tests": "Xét nghiệm",
    "selectTests": "Chọn xét nghiệm",
    "clinicalNotes": "Thông tin lâm sàng",
    "placeOrder": "Gửi chỉ định",
    "orderPlaced": "Đã gửi phiếu xét nghiệm {{number}}",
    "collect": "Lấy mẫu",
    "collected": "Đã lấy mẫu",
    "specimen": "Mẫu bệnh phẩm",
    "result": "Kết quả",
    "value": "Giá trị",
    "resultText": "Kết quả (văn bản)",
    "flag": "Đánh dấu",
    "unit": "Đơn vị",
    "referenceRange": "Khoảng tham chiếu",
    "saveResult": "Lưu kết quả",
    "verify": "Duyệt",
    "verified": "Đã duyệt kết quả",
    "correct": "Đính chính kết quả",
    "correctionReason": "Lý do đính chính",
    "corrected": "Đã đính chính kết quả",
    "enteredBy": "Người nhập",
    "verifiedBy": "Người duyệt",
    "cancelOrder": "Hủy phiếu",
    "empty": "Không có phiếu xét nghiệm trong danh sách này.",
    "category": "Nhóm",
    "price": "Giá",
    "turnaround": "Thời gian trả kết quả",
    "awaitingResult": "Chờ kết quả"
  },
  "billing": {
    "title": "Viện phí",
    "invoices": "Hóa đơn",
    "newInvoice": "Tạo hóa đơn",
    "invoice": "Hóa đơn",
    "invoiceNumber": "Số hóa đơn",
    "patient": "Bệnh nhân",
    "encounter": "Lượt khám",
    "items": "Mục",
    "description": "Nội dung",
    "quantity": "SL",
    "unitPrice": "Đơn giá",
    "discount": "Giảm giá",
    "tax": "Thuế",
    "subtotal": "Tạm tính",
    "total": "Tổng cộng",
    "paid": "Đã trả",
    "balance": "Còn nợ",
    "issuedAt": "Ngày lập",
    "chargeItems": "Dịch vụ và phí",
    "addCharge": "Thêm dịch vụ",
    "unbilledItems": "Mục chưa tính phí của lượt khám",
    "includeUnbilled": "Gồm thuốc và xét nghiệm chưa tính phí",
    "payments": "Thanh toán",
    "recordPayment": "Ghi nhận thanh toán",
    "amount": "Số tiền",
    "method": "Phương thức",
    "provider": "Đơn vị thanh toán",
    "reference": "Mã tham chiếu",
    "paymentRecorded": "Đã ghi nhận thanh toán",
    "payInFull": "Thanh toán toàn bộ",
    "void": "Hủy hóa đơn",
    "voidReason": "Lý do hủy",
    "refund": "Hoàn tiền",
    "refundReason": "Lý do hoàn tiền",
    "receipt": "Biên lai",
    "printReceipt": "In biên lai",
    "created": "Đã tạo hóa đơn {{number}}",
    "pendingConfirmation": "Đang chờ đơn vị thanh toán xác nhận",
    "outstanding": "Còn nợ",
    "thankYou": "Cảm ơn quý khách. Chúc mau khỏe!",
    "selectEncounter": "Lượt khám (không bắt buộc)",
    "empty": "Không tìm thấy hóa đơn.",
    "receivedBy": "Người thu",
    "applyDiscount": "Giảm giá",
    "discountHint": "Giảm giá được ghi lại kèm tên và lý do của bạn, cần quyền giảm giá.",
    "discountPreview": "Giảm {{discount}} · tổng mới {{total}}",
    "discountSaved": "Đã lưu giảm giá",
    "lineDiscounts": "Giảm giá theo dòng",
    "noDiscount": "không giảm giá",
    "billDiscount": "Giảm giá toàn hóa đơn"
  },
  "admin": {
    "usersTitle": "Người dùng",
    "newUser": "Thêm người dùng",
    "editUser": "Sửa người dùng",
    "username": "Tên đăng nhập",
    "fullName": "Họ và tên",
    "email": "Email",
    "phone": "Điện thoại",
    "roles": "Vai trò",
    "password": "Mật khẩu ban đầu",
    "resetPassword": "Đặt lại mật khẩu",
    "newPassword": "Mật khẩu mới",
    "disable": "Vô hiệu hóa",
    "enable": "Kích hoạt",
    "lastLogin": "Đăng nhập gần nhất",
    "locked": "Bị khóa",
    "userCreated": "Đã tạo người dùng",
    "isPractitioner": "Người dùng này là nhân viên y tế",
    "employeeCode": "Mã nhân viên",
    "specialty": "Chuyên khoa",
    "licenseNumber": "Số chứng chỉ hành nghề",
    "departmentsTitle": "Khoa phòng",
    "newDepartment": "Thêm khoa phòng",
    "departmentType": "Loại khoa",
    "practitionersTitle": "Nhân viên y tế",
    "newPractitioner": "Thêm nhân viên y tế",
    "displayName": "Tên hiển thị",
    "department": "Khoa",
    "hospitalTitle": "Cài đặt bệnh viện",
    "hospitalName": "Tên bệnh viện",
    "registrationNumber": "Số đăng ký",
    "timezone": "Múi giờ",
    "currency": "Tiền tệ",
    "defaultLanguage": "Ngôn ngữ mặc định",
    "organization": "Tổ chức",
    "auditTitle": "Nhật ký kiểm tra",
    "auditAction": "Hành động",
    "auditResource": "Đối tượng",
    "auditActor": "Người dùng",
    "auditTime": "Thời gian",
    "auditIp": "Địa chỉ IP",
    "auditChanges": "Thay đổi",
    "auditBefore": "Trước",
    "auditAfter": "Sau",
    "auditResourceId": "Mã đối tượng",
    "hospitalDetails": "Thông tin chung",
    "hospitalLocation": "Vị trí",
    "addressDetails": "Đường, tòa nhà và chi tiết khác",
    "addressDetailsHint": "In trên tiêu đề giấy dưới tên bệnh viện",
    "latitude": "Vĩ độ",
    "longitude": "Kinh độ",
    "latitudeHint": "Từ -90 đến 90; nhập cả hai hoặc không nhập",
    "longitudeHint": "Từ -180 đến 180; nhập cả hai hoặc không nhập",
    "openMap": "Mở bản đồ",
    "clearPosition": "Xóa tọa độ",
    "positionHint": "Độ thập phân, ví dụ 17.966000 và 102.600000 cho Viêng Chăn. Nút Dùng vị trí của tôi hoạt động khi ở bệnh viện.",
    "useMyLocation": "Dùng vị trí của tôi",
    "locateFailed": "Không đọc được vị trí của thiết bị này",
    "hospitalPhoto": "Ảnh và logo bệnh viện",
    "changePhoto": "Đổi ảnh",
    "uploadPhoto": "Tải ảnh lên",
    "removePhoto": "Xóa ảnh",
    "photoHint": "JPEG, PNG hoặc WebP. Ảnh được dùng làm logo bệnh viện trên menu, trang đăng nhập và giấy tờ in. Ảnh vuông là tốt nhất.",
    "noPhotoYet": "Chưa có ảnh: logo mặc định HMS đang được hiển thị.",
    "removePhotoMessage": "Logo mặc định HMS sẽ được hiển thị lại.",
    "photoSaved": "Đã lưu ảnh bệnh viện",
    "photoRemoved": "Đã xóa ảnh bệnh viện",
    "hospitalNameLo": "Tên bệnh viện (tiếng Lào)",
    "hospitalNameEn": "Tên bệnh viện (tiếng Anh)",
    "hospitalNameEnHint": "Hiển thị khi giao diện không phải tiếng Lào và trên giấy tờ in"
  },
  "translations": {
    "title": "Bản dịch",
    "subtitle": "Tùy chỉnh mọi văn bản trong ứng dụng. Thay đổi có hiệu lực ngay trên web và di động.",
    "locale": "Ngôn ngữ",
    "scope": "Áp dụng cho",
    "scopeUSER": "Chỉ mình tôi",
    "scopeHOSPITAL": "Bệnh viện này",
    "scopeGLOBAL": "Tất cả bệnh viện",
    "scopeHelpUSER": "Cách gọi riêng chỉ bạn nhìn thấy.",
    "scopeHelpHOSPITAL": "Mọi người trong bệnh viện này sẽ thấy cách gọi này.",
    "scopeHelpGLOBAL": "Cách gọi mặc định cho mọi bệnh viện (quản trị viên cấp cao).",
    "key": "Khóa",
    "reference": "Bản gốc tiếng Anh",
    "baseValue": "Văn bản mặc định",
    "override": "Văn bản tùy chỉnh",
    "effective": "Đang hiển thị",
    "searchPlaceholder": "Tìm khóa hoặc văn bản",
    "onlyCustomized": "Chỉ mục đã tùy chỉnh",
    "onlyMissing": "Còn thiếu ở ngôn ngữ này",
    "resetKey": "Khôi phục mặc định",
    "resetAll": "Khôi phục toàn bộ mặc định",
    "resetAllConfirm": "Xóa mọi văn bản tùy chỉnh của ngôn ngữ và phạm vi này?",
    "importDone": "Đã nhập {{count}} bản dịch",
    "importInvalid": "Tệp không phải tệp bản dịch JSON hợp lệ.",
    "saveAll": "Lưu thay đổi",
    "unsaved": "{{count}} thay đổi chưa lưu",
    "stats": "Đã tùy chỉnh {{customized}} · Tổng {{total}} văn bản",
    "missing": "Còn thiếu",
    "inheritedFrom": "Từ: {{layer}}",
    "layerBundled": "Có sẵn",
    "saved": "Đã lưu bản dịch"
  },
  "languages": {
    "title": "Ngôn ngữ",
    "add": "Thêm ngôn ngữ",
    "code": "Mã ngôn ngữ",
    "codeHelp": "Mã ISO, ví dụ km hoặc zh-Hant",
    "name": "Tên tiếng Anh",
    "nativeName": "Tên bản ngữ",
    "fallback": "Ngôn ngữ dự phòng",
    "enabled": "Bật",
    "builtin": "Có sẵn",
    "custom": "Tự thêm",
    "added": "Đã thêm ngôn ngữ. Hãy dịch tại trang Bản dịch."
  },
  "settings": {
    "title": "Cài đặt",
    "appearance": "Giao diện",
    "theme": "Chủ đề",
    "themeHelp": "Chọn chủ đề màu. “Theo hệ thống” sẽ đổi theo chế độ sáng hoặc tối của thiết bị.",
    "accent": "Màu nhấn",
    "accentDefault": "Theo chủ đề",
    "density": "Mật độ hiển thị",
    "densityCompact": "Gọn",
    "densityComfortable": "Thoáng",
    "language": "Ngôn ngữ",
    "languageHelp": "Chọn ngôn ngữ cho menu và nhãn.",
    "account": "Tài khoản",
    "myTranslations": "Cách gọi của tôi",
    "myTranslationsHelp": "Đổi tên nhãn chỉ cho riêng bạn — ví dụ gọi “Lượt khám” là “Lần khám”.",
    "savedOnServer": "Tùy chọn được lưu vào tài khoản và áp dụng cả trên ứng dụng di động."
  },
  "themes": {
    "system": "Theo hệ thống",
    "clinical": "Xanh lâm sàng",
    "night": "Ban đêm",
    "ocean": "Đại dương",
    "forest": "Rừng xanh",
    "lotus": "Hoa sen",
    "midnight": "Nửa đêm",
    "contrast": "Tương phản cao",
    "gold": "Vàng kim",
    "oph": "Trung tâm mắt OPH"
  },
  "notifications": {
    "title": "Thông báo",
    "empty": "Không có thông báo mới.",
    "markAllRead": "Đánh dấu đã đọc tất cả",
    "unread": "{{count}} chưa đọc",
    "prescriptionIssued": "Đơn thuốc mới cần cấp phát: {{ref}}",
    "labOrdered": "Chỉ định xét nghiệm mới: {{ref}}",
    "labResultVerified": "Đã có kết quả xét nghiệm: {{ref}}",
    "patientCheckedIn": "Bệnh nhân đã đến: {{ref}}",
    "highIop": "Nhãn áp cao: {{ref}}",
    "eyeSurgeryScheduled": "Đã lên lịch phẫu thuật mắt: {{ref}}",
    "lowStock": "Sắp hết hàng",
    "prSubmitted": "Đề nghị mua chờ duyệt",
    "prApproved": "Đề nghị mua của bạn đã được duyệt",
    "prRejected": "Đề nghị mua của bạn bị từ chối",
    "poApproval": "Đơn đặt hàng chờ duyệt",
    "stockDocSubmitted": "Chứng từ kho chờ kiểm tra: {{ref}}",
    "patientAdmitted": "Bệnh nhân nhập viện: {{ref}}",
    "patientDischarged": "Đã xuất viện, sẵn sàng lập hóa đơn: {{ref}}",
    "serviceOrdered": "Chỉ định dịch vụ mới: {{ref}}",
    "serviceReported": "Kết quả chờ duyệt: {{ref}}",
    "serviceVerified": "Đã có kết quả: {{ref}}",
    "expenseSubmitted": "Chi phí chờ duyệt: {{ref}}",
    "cashSessionClosed": "Ca thu ngân chờ kiểm: {{ref}}",
    "posRefillSubmitted": "Yêu cầu bổ sung POS cần chuẩn bị: {{ref}}",
    "posRefillSent": "Hàng bổ sung POS đang đến — hãy xác nhận nhận hàng: {{ref}}"
  },
  "time": {
    "justNow": "vừa xong",
    "minutesAgo": "{{count}} phút trước",
    "hoursAgo": "{{count}} giờ trước",
    "daysAgo": "{{count}} ngày trước"
  },
  "mobile": {
    "serverUrl": "Địa chỉ máy chủ",
    "serverUrlHelp": "URL máy chủ HMS, ví dụ https://hms.example.org hoặc http://192.168.1.10:8090"
  },
  "months": {
    "1": "Th1",
    "2": "Th2",
    "3": "Th3",
    "4": "Th4",
    "5": "Th5",
    "6": "Th6",
    "7": "Th7",
    "8": "Th8",
    "9": "Th9",
    "10": "Th10",
    "11": "Th11",
    "12": "Th12"
  },
  "analytics": {
    "title": "Phân tích dữ liệu",
    "year": "Năm",
    "today": "Hôm nay",
    "periodYtd": "{{from}} – {{to}}, so với cùng kỳ {{prevYear}}",
    "periodFull": "Cả năm {{year}} so với {{prevYear}}",
    "netRevenue": "Doanh thu thuần",
    "collected": "Đã thu",
    "collectionRate": "Đã thu {{value}}",
    "visits": "Lượt khám",
    "newPatients": "Bệnh nhân mới",
    "revenuePerVisit": "Doanh thu mỗi lượt khám",
    "vsLastYear": "so với năm trước",
    "noPrevious": "Không có dữ liệu năm trước",
    "revenueByCategory": "Doanh thu theo nhóm dịch vụ",
    "paymentMethods": "Thanh toán theo phương thức",
    "waterfall": "Từ phí dịch vụ đến tiền thu",
    "gross": "Tổng phí",
    "discounts": "Giảm giá",
    "outstanding": "Còn nợ",
    "net": "Doanh thu thuần",
    "revenueByMonth": "Doanh thu thuần theo tháng",
    "revenueByQuarter": "Doanh thu theo quý",
    "revenueByMonthCategory": "Doanh thu theo tháng và nhóm dịch vụ",
    "revenueByDepartment": "Doanh thu theo khoa",
    "statement": "Báo cáo doanh thu",
    "item": "Khoản mục",
    "change": "Thay đổi",
    "changePct": "Thay đổi %",
    "sectionRevenue": "Doanh thu",
    "totalGross": "Tổng doanh thu",
    "sectionOperations": "Hoạt động",
    "invoices": "Hóa đơn",
    "visitsByMonth": "Lượt khám theo tháng",
    "topDiagnoses": "Chẩn đoán thường gặp",
    "demographics": "Bệnh nhân đến khám theo nhóm tuổi và giới tính",
    "quarter": "Quý {{n}}",
    "noData": "Không có dữ liệu trong kỳ này",
    "category": {
      "CONSULTATION": "Khám bệnh",
      "PHARMACY": "Thuốc",
      "LABORATORY": "Xét nghiệm",
      "PROCEDURE": "Thủ thuật",
      "SERVICE": "Cấp cứu và dịch vụ",
      "ADMINISTRATIVE": "Hành chính",
      "OTHER": "Khác",
      "OPHTHALMOLOGY": "Trung tâm mắt",
      "SPECIAL_SERVICES": "Dịch vụ đặc biệt",
      "INPATIENT": "Giường nội trú",
      "POS_SALES": "Bán tại quầy"
    }
  },
  "eye": {
    "title": "Trung tâm Mắt",
    "subtitle": "Nhãn khoa: khám, phẫu thuật, tiêm và tái khám",
    "overview": "Tổng quan",
    "eyeRecord": "Hồ sơ mắt",
    "generalRecord": "Hồ sơ chung",
    "openPatientRecord": "Mở hồ sơ mắt của bệnh nhân",
    "patient": "Bệnh nhân",
    "eyeSide": "Mắt",
    "eyes": "Mắt",
    "side": {
      "OD": "Mắt phải (OD)",
      "OS": "Mắt trái (OS)",
      "OU": "Hai mắt (OU)"
    },
    "examinations": "Lần khám",
    "surgeries": "Phẫu thuật",
    "injections": "Tiêm nội nhãn",
    "followUps": "Tái khám",
    "medications": "Thuốc mắt",
    "imaging": "Chẩn đoán hình ảnh",
    "procedures": "Thủ thuật",
    "biometryIol": "Sinh trắc & IOL",
    "trends": "Xu hướng",
    "currentStatus": "Tình trạng hiện tại (mới nhất mỗi mắt)",
    "newExam": "Khám mắt mới",
    "startEyeExam": "Bắt đầu khám mắt",
    "openEyeExam": "Phiếu khám mắt",
    "useOpenEncounter": "Tiếp tục trong lượt khám đang mở:",
    "startWithNewEncounter": "Bắt đầu với lượt khám mới",
    "planSurgery": "Lên kế hoạch mổ",
    "injection": "Tiêm",
    "followUp": "Tái khám",
    "recordInjection": "Ghi nhận tiêm nội nhãn",
    "prescribeDrops": "Kê thuốc nhỏ mắt",
    "scheduleFollowUp": "Hẹn tái khám",
    "visualAcuity": "Thị lực",
    "iop": "Nhãn áp (IOP)",
    "refraction": "Khúc xạ",
    "slitLamp": "Khám sinh hiển vi (đèn khe)",
    "fundus": "Khám đáy mắt",
    "diagnoses": "Chẩn đoán mắt",
    "historyAndPlan": "Bệnh sử, ghi chú và kế hoạch",
    "addVisualAcuity": "Ghi thị lực",
    "addPressure": "Ghi nhãn áp",
    "addRefraction": "Ghi khúc xạ",
    "addDiagnosis": "Thêm chẩn đoán",
    "measurementType": "Loại đo",
    "chartType": "Bảng thị lực",
    "acuity": "Thị lực",
    "acuityHint": "Snellen (6/12, 20/40), thập phân, logMAR, CF, HM, LP, NLP",
    "correction": "Chỉnh kính",
    "correctionPlaceholder": "vd. kính gọng, kính áp tròng",
    "pressure": "Áp lực",
    "method": "Phương pháp",
    "measuredAt": "Thời điểm đo",
    "refractionType": "Loại",
    "sphere": "Cầu (SPH)",
    "cylinder": "Trụ (CYL)",
    "axis": "Trục",
    "add": "Độ cộng (ADD)",
    "pd": "Khoảng đồng tử (PD)",
    "acuityWithRx": "Thị lực với đơn kính này",
    "vaType": {
      "UNAIDED": "Không kính",
      "CORRECTED": "Có kính",
      "PINHOLE": "Kính lỗ",
      "BEST_CORRECTED": "Thị lực chỉnh kính tối đa (BCVA)",
      "NEAR": "Nhìn gần"
    },
    "chart": {
      "SNELLEN": "Snellen",
      "LOGMAR": "LogMAR",
      "DECIMAL": "Thập phân",
      "TUMBLING_E": "Chữ E",
      "LEA": "Ký hiệu LEA",
      "JAEGER": "Jaeger (gần)",
      "OTHER": "Khác"
    },
    "refractionTypes": {
      "AUTO": "Khúc xạ tự động",
      "RETINOSCOPY": "Soi bóng đồng tử",
      "SUBJECTIVE": "Chủ quan",
      "FINAL_PRESCRIPTION": "Đơn kính cuối cùng"
    },
    "iopMethod": {
      "GOLDMANN": "Goldmann",
      "NON_CONTACT": "Không tiếp xúc (thổi hơi)",
      "TONOPEN": "Tono-Pen",
      "REBOUND": "Bật nảy (iCare)",
      "OTHER": "Khác"
    },
    "iopLevel": {
      "LOW": "Thấp",
      "NORMAL": "Bình thường",
      "ELEVATED": "Tăng",
      "CRITICAL": "Nguy hiểm"
    },
    "dxType": {
      "PRIMARY": "Chính",
      "SECONDARY": "Phụ",
      "DIFFERENTIAL": "Phân biệt",
      "COMPLICATION": "Biến chứng"
    },
    "severity": "Mức độ",
    "severities": {
      "MILD": "Nhẹ",
      "MODERATE": "Trung bình",
      "SEVERE": "Nặng",
      "EARLY": "Giai đoạn sớm",
      "ADVANCED": "Giai đoạn tiến triển",
      "END_STAGE": "Giai đoạn cuối",
      "NON_PROLIFERATIVE": "Không tăng sinh",
      "PROLIFERATIVE": "Tăng sinh"
    },
    "icdCode": "Mã ICD-10",
    "diagnosis": "Chẩn đoán",
    "dx": {
      "H25_1": "Đục nhân thủy tinh thể tuổi già",
      "H26_9": "Đục thủy tinh thể, không đặc hiệu",
      "H40_1": "Glôcôm góc mở nguyên phát",
      "H40_2": "Glôcôm góc đóng nguyên phát",
      "E11_3": "Bệnh võng mạc đái tháo đường",
      "H35_3": "Thoái hóa hoàng điểm tuổi già",
      "H33_0": "Bong võng mạc có vết rách",
      "H34_8": "Tắc tĩnh mạch võng mạc",
      "H10_0": "Viêm kết mạc cấp do vi khuẩn",
      "H16_0": "Loét giác mạc",
      "H11_0": "Mộng thịt",
      "H04_1": "Hội chứng khô mắt",
      "H52_1": "Cận thị",
      "H52_0": "Viễn thị",
      "H52_4": "Lão thị",
      "H50_0": "Lác trong",
      "H53_0": "Nhược thị",
      "H20_0": "Viêm màng bồ đào trước cấp",
      "H00_0": "Lẹo mắt",
      "H57_1": "Đau mắt"
    },
    "field": {
      "chiefComplaint": "Lý do khám",
      "historyOfPresentIllness": "Bệnh sử",
      "pastOcularHistory": "Tiền sử bệnh mắt",
      "familyOcularHistory": "Tiền sử gia đình về mắt",
      "systemicHistory": "Tiền sử bệnh toàn thân",
      "clinicalNotes": "Ghi chú lâm sàng",
      "plan": "Kế hoạch",
      "lids": "Mi mắt",
      "lashes": "Lông mi",
      "conjunctiva": "Kết mạc",
      "sclera": "Củng mạc",
      "cornea": "Giác mạc",
      "anteriorChamber": "Tiền phòng",
      "iris": "Mống mắt",
      "pupil": "Đồng tử",
      "lens": "Thủy tinh thể",
      "vitreous": "Dịch kính",
      "opticDisc": "Đĩa thị",
      "cupDiscRatio": "Tỷ lệ lõm/đĩa (C/D)",
      "macula": "Hoàng điểm",
      "vessels": "Mạch máu",
      "retina": "Võng mạc",
      "peripheralRetina": "Võng mạc chu biên",
      "notes": "Ghi chú"
    },
    "fillNormal": "Điền kết quả bình thường",
    "notRecorded": "Chưa ghi nhận",
    "noDiagnoses": "Chưa có chẩn đoán",
    "cdrSuspicious": "C/D từ 0,6 nghi glôcôm",
    "worse": "Kém đi",
    "better": "Tốt hơn",
    "previousValue": "Lần trước: {{value}}",
    "sign": "Ký phiếu khám",
    "signConfirm": "Ký sẽ khóa phiếu khám. Sửa sau này phải tạo bản sửa đổi. Ký ngay?",
    "signed": "Đã ký phiếu khám",
    "amend": "Sửa đổi",
    "amendHelp": "Hệ thống tạo bản sao để sửa; bản gốc được giữ nguyên trong hồ sơ.",
    "amendReason": "Lý do sửa đổi",
    "amendmentOf": "Đây là bản sửa đổi của",
    "originalExam": "phiếu khám gốc",
    "supersededBy": "Phiếu khám này đã được sửa đổi. Xem",
    "latestAmendment": "bản sửa đổi mới nhất",
    "signedBanner": "Ký bởi {{name}} lúc {{date}}",
    "comparedWith": "So với lần khám trước ngày {{date}}",
    "cancelExam": "Hủy phiếu khám",
    "logmarHelp": "LogMAR: 0,0 = 6/6, 0,3 = 6/12, 1,0 = 6/60. Càng thấp càng tốt; trục được đảo nên đi lên là tốt hơn.",
    "drivingStandard": "6/12 (chuẩn lái xe)",
    "iopUpperNormal": "21 mmHg giới hạn trên",
    "cstThreshold": "300 µm",
    "mdModerate": "−6 dB",
    "centralThickness": "Độ dày vùng trung tâm",
    "rnfl": "Độ dày lớp sợi thần kinh (RNFL)",
    "sphericalEquivalent": "Cầu tương đương",
    "visualField": "Thị trường",
    "noTrendData": "Chưa có dữ liệu",
    "treatments": "Điều trị",
    "bcva": "Thị lực chỉnh kính tối đa",
    "frequencies": {
      "qd": "Ngày 1 lần",
      "bid": "Ngày 2 lần",
      "tid": "Ngày 3 lần",
      "qid": "Ngày 4 lần",
      "q2h": "Mỗi 2 giờ",
      "qhs": "Mỗi tối trước khi ngủ"
    },
    "medication": "Thuốc",
    "medicationName": "Tên thuốc",
    "otherMedication": "Khác (nhập tên)",
    "dose": "Liều",
    "frequency": "Tần suất",
    "duration": "Thời gian",
    "startDate": "Ngày bắt đầu",
    "endDate": "Ngày kết thúc",
    "instructions": "Hướng dẫn",
    "stop": "Ngừng",
    "stopMedication": "Ngừng thuốc mắt",
    "noMedications": "Không có thuốc mắt",
    "lotNumber": "Số lô",
    "expiryDate": "Hạn dùng",
    "indication": "Chỉ định",
    "complications": "Biến chứng",
    "confirmEyeStatement": "Tôi đã xác nhận {{eye}} với bệnh nhân và vị trí đánh dấu, đã kiểm tra thuốc, liều và hạn dùng.",
    "noInjections": "Chưa có mũi tiêm",
    "by": "Người thực hiện",
    "modality": "Phương thức",
    "results": "Kết quả",
    "device": "Thiết bị",
    "noImaging": "Chưa có chẩn đoán hình ảnh",
    "modalities": {
      "FUNDUS_PHOTO": "Chụp đáy mắt",
      "OCT": "OCT",
      "OCT_ANGIOGRAPHY": "OCT mạch máu",
      "VISUAL_FIELD": "Thị trường",
      "CORNEAL_TOPOGRAPHY": "Bản đồ giác mạc",
      "PACHYMETRY": "Đo độ dày giác mạc",
      "B_SCAN": "Siêu âm B",
      "BIOMETRY": "Sinh trắc",
      "OTHER": "Khác"
    },
    "procedure": "Thủ thuật",
    "outcome": "Kết quả",
    "noExams": "Chưa có phiếu khám mắt",
    "noSurgeries": "Chưa có phẫu thuật",
    "noFollowUps": "Không có lịch tái khám",
    "postOp": "Tái khám sau mổ",
    "caseNumber": "Mã ca",
    "biometry": "Sinh trắc",
    "biometryHelp": "Sinh trắc quang học từng mắt. Chọn một lần đo để tính thủy tinh thể nhân tạo.",
    "addBiometry": "Thêm sinh trắc",
    "noBiometry": "Chưa có sinh trắc",
    "axialLength": "Chiều dài trục nhãn cầu",
    "lensThickness": "Độ dày thủy tinh thể",
    "axialAsymmetry": "Chiều dài trục hai mắt chênh {{diff}} mm. Hãy đo lại trước khi chọn thủy tinh thể.",
    "toricHint": "Loạn thị giác mạc {{cyl}} D. Cân nhắc IOL toric.",
    "formula": "Công thức",
    "formulas": {
      "SRK_T": "SRK/T",
      "BARRETT_UNIVERSAL_II": "Barrett Universal II",
      "HAIGIS": "Haigis",
      "HOFFER_Q": "Hoffer Q",
      "HOLLADAY": "Holladay",
      "KANE": "Kane",
      "OTHER": "Khác"
    },
    "aConstant": "Hằng số A",
    "targetRefraction": "Khúc xạ mục tiêu",
    "iolModel": "Mẫu IOL",
    "iolPower": "Công suất IOL",
    "iolPowerAuto": "Để trống để dùng công suất gợi ý",
    "fromBiometer": "Theo bản in của máy sinh trắc",
    "predictedRefraction": "Khúc xạ dự kiến",
    "saveCalculation": "Lưu kết quả tính",
    "suggestedPower": "Công suất IOL gợi ý",
    "emmetropicPower": "Công suất chính thị",
    "noCalculations": "Chưa có kết quả tính IOL",
    "selected": "Đã chọn",
    "select": "Chọn",
    "iolSelected": "Đã chọn thủy tinh thể cho phẫu thuật",
    "operativeEye": "Mắt phẫu thuật",
    "surgeryType": "Loại phẫu thuật",
    "surgeryTypes": {
      "CATARACT": "Đục thủy tinh thể",
      "GLAUCOMA": "Glôcôm",
      "RETINA": "Võng mạc",
      "VITRECTOMY": "Cắt dịch kính",
      "CORNEA": "Giác mạc",
      "REFRACTIVE": "Khúc xạ",
      "OCULOPLASTIC": "Tạo hình mắt",
      "STRABISMUS": "Lác",
      "PTERYGIUM": "Mộng thịt",
      "LASER": "Laser",
      "OTHER": "Khác"
    },
    "procedureExample": {
      "CATARACT": "Phaco + đặt IOL",
      "GLAUCOMA": "Cắt bè củng giác mạc",
      "RETINA": "Đai củng mạc",
      "VITRECTOMY": "Cắt dịch kính qua pars plana",
      "CORNEA": "Ghép giác mạc xuyên",
      "REFRACTIVE": "LASIK",
      "OCULOPLASTIC": "Tạo hình mi",
      "STRABISMUS": "Lùi cơ trực trong",
      "PTERYGIUM": "Cắt mộng ghép kết mạc tự thân",
      "LASER": "Mở bao sau bằng YAG",
      "OTHER": "Mô tả thủ thuật"
    },
    "anesthesia": "Vô cảm",
    "anesthesiaTypes": {
      "TOPICAL": "Tê tại chỗ (nhỏ)",
      "LOCAL": "Tê tại chỗ",
      "PERIBULBAR": "Tê cạnh nhãn cầu",
      "RETROBULBAR": "Tê hậu nhãn cầu",
      "SUB_TENON": "Tê dưới bao Tenon",
      "GENERAL": "Gây mê toàn thân"
    },
    "scheduledAt": "Lịch mổ",
    "preopDiagnosis": "Chẩn đoán trước mổ",
    "noBiometryForEye": "Mắt này chưa có sinh trắc",
    "chooseEyeFirst": "Hãy chọn mắt trước",
    "cataractNeedsBiometry": "Phẫu thuật đục thủy tinh thể cần sinh trắc và IOL đã chọn cho mắt này trước bảng kiểm.",
    "safetyChecklist": "Bảng kiểm an toàn trước mổ",
    "checklistHelp": "Thực hiện khi bệnh nhân tỉnh và cả ê-kíp có mặt. Ê-kíp tự nêu mắt mổ, không sao chép từ kế hoạch.",
    "teamStatesEye": "Mắt do ê-kíp xác nhận",
    "eyeMismatchTitle": "Sai mắt!",
    "eyeMismatchBody": "Kế hoạch là {{planned}} nhưng ê-kíp nêu {{stated}}. Dừng lại và kiểm tra.",
    "check": {
      "patientIdentityConfirmed": "Đã xác nhận danh tính (tên + ngày sinh)",
      "procedureConfirmed": "Đã xác nhận thủ thuật với bệnh nhân và phiếu đồng ý",
      "eyeSideConfirmed": "Đã xác nhận mắt mổ",
      "consentConfirmed": "Có phiếu đồng ý đã ký",
      "siteMarked": "Đã đánh dấu vị trí mổ"
    },
    "confirmChecklist": "Xác nhận bảng kiểm",
    "checklistConfirmed": "Đã xác nhận bảng kiểm an toàn",
    "confirmedBy": "Xác nhận bởi {{name}} lúc {{date}}",
    "startSurgery": "Bắt đầu mổ",
    "startConfirm": "Bắt đầu {{procedure}} trên {{eye}}?",
    "cancelSurgery": "Hủy phẫu thuật",
    "cancelledBecause": "Đã hủy: {{reason}}",
    "surgicalPlan": "Kế hoạch phẫu thuật",
    "surgeon": "Phẫu thuật viên",
    "startedAt": "Bắt đầu",
    "completedAt": "Hoàn thành",
    "lensPlan": "Kế hoạch IOL",
    "openBiometry": "Mở sinh trắc",
    "noBiometryLinked": "Chưa liên kết sinh trắc",
    "selectedLens": "IOL đã chọn",
    "noLensSelected": "Chưa chọn IOL",
    "operativeRecord": "Biên bản phẫu thuật",
    "operativeFindings": "Phát hiện trong mổ",
    "operativeNotes": "Diễn biến phẫu thuật",
    "postopNotes": "Y lệnh sau mổ",
    "noneIfBlank": "Để trống nếu không có",
    "implants": "Vật liệu cấy ghép",
    "implantTypes": {
      "IOL": "Thủy tinh thể nhân tạo",
      "CAPSULAR_TENSION_RING": "Vòng căng bao",
      "GLAUCOMA_DRAINAGE_DEVICE": "Van dẫn lưu glôcôm",
      "STENT": "Stent",
      "SILICONE_OIL": "Dầu silicon",
      "GAS": "Khí nội nhãn",
      "OTHER": "Khác"
    },
    "model": "Mẫu",
    "manufacturer": "Nhà sản xuất",
    "serialNumber": "Số sê-ri",
    "powerMismatchTitle": "Công suất IOL khác kế hoạch.",
    "powerMismatchBody": "IOL đã chọn là {{planned}} D. Đối chiếu hộp IOL với kế hoạch.",
    "powerOverride": "Tôi đã xác minh công suất này với phẫu thuật viên (ghi nhận ngoại lệ)",
    "firstPostOpVisit": "Tái khám sau mổ lần đầu",
    "completeSurgery": "Hoàn tất phẫu thuật",
    "surgeryCompleted": "Phẫu thuật đã hoàn tất",
    "followUpDate": "Ngày tái khám",
    "inDays": "Sau {{count}} ngày",
    "examsToday": "Khám hôm nay",
    "openExams": "Phiếu khám đang mở",
    "surgeriesUpcoming": "Ca mổ sắp tới",
    "surgeriesMonth": "Ca mổ tháng này",
    "injectionsMonth": "Mũi tiêm tháng này",
    "followUpsToday": "Tái khám hôm nay",
    "followUpsOverdue": "Tái khám quá hạn",
    "highIopPatients": "Bệnh nhân nhãn áp trên 21",
    "activityByMonth": "Hoạt động phòng khám mắt (12 tháng trọn gần nhất)",
    "activity": {
      "exams": "Lượt khám",
      "injections": "Mũi tiêm",
      "surgeries": "Ca mổ"
    },
    "surgeriesByType": "Phẫu thuật theo loại (12 tháng trọn gần nhất)",
    "topEyeDiagnoses": "Chẩn đoán mắt thường gặp (12 tháng)",
    "iopControl": "Kiểm soát nhãn áp (mới nhất mỗi mắt, 12 tháng)",
    "iopControlHelp": "Bình thường 10–21 mmHg. Mắt tăng và nguy hiểm cần xem lại.",
    "cataractOutcome": "Kết quả mổ đục thủy tinh thể",
    "cataractOutcomeHelp": "{{good}}/{{measured}} mắt đã đo đạt 6/12 trở lên trong 90 ngày ({{operated}} ca mổ trong 12 tháng).",
    "upcomingSurgeries": "Ca mổ sắp tới",
    "anyDate": "Mọi ngày",
    "myCases": "Ca của tôi",
    "due": {
      "overdue": "Quá hạn",
      "today": "Hôm nay",
      "week": "7 ngày tới"
    },
    "phone": "Điện thoại",
    "doctor": "Bác sĩ",
    "markSeen": "Đã khám",
    "markMissed": "Lỡ hẹn"
  },
  "pathways": {
    "title": "Chu trình điều trị",
    "subtitle": "Chu trình chăm sóc từng bệnh, từng bước, cho bác sĩ, điều dưỡng và bệnh nhân",
    "cycles": "Chu trình",
    "dueReviews": "Đến hạn đánh giá",
    "new": "Chu trình mới",
    "searchPlaceholder": "Tìm bệnh, mã hoặc chu trình…",
    "categoryLabel": "Nhóm",
    "category": {
      "EYE": "Mắt",
      "CHRONIC": "Bệnh mạn tính",
      "INFECTIOUS": "Bệnh truyền nhiễm",
      "MATERNAL": "Bà mẹ & sơ sinh",
      "SURGICAL": "Ngoại khoa",
      "PEDIATRIC": "Nhi khoa",
      "MENTAL": "Sức khỏe tâm thần",
      "GENERAL": "Chung"
    },
    "shared": "Dùng chung",
    "sharedTemplate": "Mẫu dùng chung",
    "sharedReadOnly": "Đây là mẫu dùng chung. Sao chép về bệnh viện để điều chỉnh.",
    "hospital": "Bệnh viện này",
    "scope": "Phạm vi",
    "cyclic": "Chu trình lặp",
    "linear": "Lộ trình một chiều",
    "stageCount": "{{count}} giai đoạn",
    "activePatients": "{{count}} bệnh nhân",
    "disease": "Bệnh",
    "diseaseCode": "Mã ICD-10",
    "stages": "Giai đoạn",
    "stage": "Giai đoạn",
    "patients": "Bệnh nhân",
    "pathway": "Chu trình điều trị",
    "currentStage": "Giai đoạn hiện tại",
    "cycle": "Vòng",
    "cycleN": "Vòng {{n}}",
    "daysShort": "{{count}} ngày",
    "nextReview": "Đánh giá tiếp theo",
    "nextReviewHint": "Để trống để dùng thời lượng giai đoạn",
    "nextReviewOn": "Đánh giá {{date}}",
    "dueToday": "Hôm nay",
    "dueWeek": "7 ngày",
    "dueMonth": "30 ngày",
    "noneDue": "Không có lịch đánh giá",
    "details": "Chi tiết",
    "autoCode": "Tự tạo nếu để trống",
    "color": "Màu",
    "inherit": "Theo chu trình",
    "isCyclicHelp": "Lặp lại: sau giai đoạn cuối, bệnh nhân bắt đầu vòng mới",
    "translations": "Ngôn ngữ khác",
    "addStage": "Thêm giai đoạn",
    "untitled": "Chưa đặt tên",
    "moveUp": "Lên",
    "moveDown": "Xuống",
    "stageName": "Tên giai đoạn",
    "durationDays": "Thời lượng (ngày)",
    "icon": "Biểu tượng",
    "actions": "Việc ê-kíp cần làm",
    "actionsHint": "Danh sách việc cho bác sĩ và điều dưỡng",
    "patientInstructions": "Hướng dẫn cho bệnh nhân",
    "patientInstructionsHint": "Hiển thị trong ứng dụng bệnh nhân",
    "preview": "Xem trước",
    "previewCyclic": "Bấm vào giai đoạn để sửa. Mũi tên thể hiện chu trình lặp.",
    "previewLinear": "Bấm vào giai đoạn để sửa. Lộ trình kết thúc sau giai đoạn cuối.",
    "copyToHospital": "Sao chép về bệnh viện",
    "copied": "Đã sao chép — có thể chỉnh sửa",
    "archive": "Lưu trữ",
    "restore": "Khôi phục",
    "archived": "Đã lưu trữ",
    "lastUpdated": "Cập nhật {{date}} bởi {{name}}",
    "patientCycles": "Chu trình điều trị",
    "enroll": "Bắt đầu chu trình",
    "enrolled": "Đã bắt đầu chu trình",
    "pickStartStage": "Bấm giai đoạn để bắt đầu (mặc định: đầu tiên)",
    "noPlans": "Chưa có chu trình",
    "showEnded": "Hiện đã kết thúc ({{count}})",
    "hideEnded": "Ẩn đã kết thúc",
    "startedOn": "Bắt đầu {{date}}",
    "since": "từ {{date}}",
    "advance": "Giai đoạn tiếp",
    "advanceTo": "Chuyển bệnh nhân sang",
    "startsCycle": "bắt đầu vòng {{n}}",
    "completesPlan": "Đây là giai đoạn cuối: chu trình sẽ hoàn thành.",
    "moveTo": "Chuyển giai đoạn",
    "addNote": "Ghi chú",
    "stop": "Dừng chu trình",
    "history": "Lịch sử",
    "event": {
      "STARTED": "Bắt đầu",
      "ADVANCED": "Giai đoạn tiếp",
      "MOVED": "Chuyển",
      "NEW_CYCLE": "Vòng mới",
      "COMPLETED": "Hoàn thành",
      "STOPPED": "Dừng",
      "NOTE": "Ghi chú"
    }
  },
  "portal": {
    "cardTitle": "Ứng dụng bệnh nhân",
    "noAccount": "Chưa dùng ứng dụng bệnh nhân.",
    "contact": "Điện thoại / e-mail",
    "createdVia": "Đăng ký qua",
    "via": {
      "SELF_REGISTRATION": "Tự đăng ký (bệnh nhân mới)",
      "SELF_LINKED": "Tự đăng ký (khớp hồ sơ)",
      "STAFF_ACTIVATION": "Mã kích hoạt từ quầy"
    },
    "lastLogin": "Đăng nhập gần nhất",
    "verifiedBy": "Kiểm tra giấy tờ bởi",
    "pendingHelp": "Đăng ký từ app. Kiểm tra giấy tờ rồi bấm Xác minh danh tính.",
    "activeCode": "Mã kích hoạt còn hạn đến {{date}}",
    "issueActivation": "Cấp quyền dùng app",
    "newActivation": "Mã kích hoạt mới",
    "verifyIdentity": "Xác minh danh tính",
    "verified": "Đã xác minh",
    "disable": "Khóa ứng dụng",
    "enable": "Mở ứng dụng",
    "disableConfirm": "Bệnh nhân bị đăng xuất trên mọi điện thoại cho đến khi mở lại.",
    "activationTitle": "Kích hoạt ứng dụng bệnh nhân",
    "activationFor": "Kích hoạt cho",
    "activationExpires": "Hiệu lực đến {{date}}",
    "step1": "Cài app HMS và chọn \"Tôi là bệnh nhân\".",
    "step2": "Bấm \"Tạo tài khoản\", nhập số điện thoại hoặc e-mail và mã này.",
    "step3": "Nhập mã OTP được gửi để hoàn tất.",
    "activationOnce": "Mã chỉ hiển thị một lần. In ra hoặc để bệnh nhân quét ngay.",
    "identifyTitle": "Nhận diện bệnh nhân bằng QR",
    "identifyHelp": "Nhờ bệnh nhân mở \"Mã sức khỏe\" trong app và quét QR.",
    "pasteCode": "Hoặc dán mã từ máy quét",
    "identify": "Nhận diện",
    "cameraUnavailable": "Không dùng được camera. Dùng máy quét hoặc dán mã.",
    "stopCamera": "Tắt camera",
    "startCamera": "Bật camera",
    "hasAllergies": "Có {{count}} dị ứng — kiểm tra trước khi điều trị.",
    "checkIdCard": "Đăng ký từ app: kiểm tra giấy tờ trước khi điều trị.",
    "appointmentsToday": "Lịch hẹn hôm nay",
    "checkedIn": "Đã đăng ký khám",
    "openRecord": "Mở hồ sơ",
    "giveTicket": "Cấp số thứ tự",
    "scanAnother": "Quét tiếp",
    "adminTitle": "Ứng dụng bệnh nhân",
    "adminSubtitle": "Cách bệnh nhân truy cập và tin nhắn của cổng thử nghiệm",
    "flowActivation": "Đã đăng ký tại bệnh viện",
    "flowActivationText": "Mở hồ sơ và bấm \"Cấp quyền dùng app\". Bệnh nhân quét QR (hoặc nhập mã) trong app và xác nhận bằng OTP.",
    "flowSelf": "Đăng ký từ điện thoại",
    "flowSelfText": "Bệnh nhân nhập điện thoại hoặc e-mail, họ tên, ngày sinh và xác nhận OTP. Khớp hồ sơ thì liên kết; nếu không, hồ sơ mới chờ kiểm tra giấy tờ ở lần khám đầu.",
    "flowVisit": "Các lần khám sau",
    "flowVisitText": "Bệnh nhân đưa mã QR. Nhân viên quét ở trang Bệnh nhân hoặc Hàng đợi để mở hồ sơ, đăng ký hoặc cấp số. Bệnh nhân cũng có thể lấy số trong app.",
    "dummyGateway": "Chế độ thử nghiệm: SMS/e-mail và thanh toán ngân hàng là mô phỏng. Mã OTP được ghi bên dưới (ẩn) và hiển thị trong app; không trừ tiền.",
    "outbox": "Hộp thư đi (mô phỏng)",
    "outboxEmpty": "Chưa có tin nhắn",
    "destination": "Đến",
    "message": "Nội dung",
    "msgStatus": {
      "SIMULATED": "Mô phỏng"
    },
    "appStatus": {
      "VERIFIED": "App · đã xác minh",
      "PENDING_VERIFICATION": "App · chờ kiểm tra CMND",
      "DISABLED": "App · đã tắt"
    },
    "appStatusHelp": {
      "VERIFIED": "Đã đăng ký app bệnh nhân, đã xác minh danh tính",
      "PENDING_VERIFICATION": "Đăng ký qua app; kiểm tra CMND lần khám tới",
      "DISABLED": "Quyền dùng app đã bị tắt"
    },
    "appFilter": "App bệnh nhân",
    "appFilterRegistered": "Đã đăng ký app",
    "appFilterNone": "Chưa đăng ký app"
  },
  "patientApp": {
    "iAmPatient": "Tôi là bệnh nhân",
    "iAmStaff": "Nhân viên bệnh viện",
    "welcome": "Sức khỏe trong tầm tay",
    "welcomeSub": "Xem lượt khám, kết quả, hóa đơn, lấy số và xuất trình mã sức khỏe.",
    "signIn": "Đăng nhập",
    "register": "Tạo tài khoản",
    "hospital": "Bệnh viện",
    "usePhone": "Điện thoại",
    "useEmail": "E-mail",
    "phone": "Số di động",
    "email": "Địa chỉ e-mail",
    "sendCode": "Gửi mã",
    "codeSentTo": "Nhập mã 6 số gửi đến {{destination}}",
    "code": "Mã xác minh",
    "verify": "Xác nhận",
    "resend": "Gửi mã mới",
    "demoCode": "Thử nghiệm — mã của bạn là {{code}}",
    "loginHint": "Nếu có tài khoản, bạn sẽ nhận được mã.",
    "haveActivation": "Tôi có mã kích hoạt từ bệnh viện",
    "activationCode": "Mã kích hoạt",
    "firstName": "Tên",
    "lastName": "Họ",
    "dateOfBirth": "Ngày sinh",
    "sex": "Giới tính",
    "newHere": "Lần đầu? Tạo tài khoản",
    "haveAccount": "Đã có tài khoản? Đăng nhập",
    "pendingBanner": "Xuất trình giấy tờ tại quầy ở lần khám đầu để mở đầy đủ tính năng.",
    "home": "Trang chủ",
    "records": "Hồ sơ",
    "queue": "Xếp hàng",
    "payments": "Thanh toán",
    "profile": "Cá nhân",
    "hello": "Xin chào, {{name}}",
    "myId": "Mã sức khỏe của tôi",
    "idHelp": "Đưa mã QR này tại quầy hoặc cho bác sĩ.",
    "refreshesIn": "Làm mới sau {{s}} giây",
    "nextAppointment": "Lịch hẹn tới",
    "noAppointment": "Không có lịch hẹn",
    "yourTicket": "Số thứ tự của bạn",
    "position": "Thứ tự {{n}}",
    "eta": "Khoảng {{min}} phút",
    "calledNow": "Đến lượt bạn — {{counter}}",
    "takeTicket": "Lấy số thứ tự",
    "chooseDepartment": "Chọn khoa",
    "waitingCount": "{{count}} người đang chờ",
    "noTicket": "Hôm nay chưa có số. Lấy số khi đến bệnh viện.",
    "visits": "Lượt khám",
    "diagnoses": "Chẩn đoán",
    "prescriptions": "Thuốc",
    "labResults": "Kết quả xét nghiệm",
    "eyeHealth": "Sức khỏe mắt",
    "treatmentCycles": "Điều trị của tôi",
    "noRecords": "Chưa có lượt khám",
    "outstanding": "Cần thanh toán",
    "pay": "Thanh toán",
    "choosePayment": "Bạn muốn thanh toán thế nào?",
    "method": {
      "QR": "Thanh toán QR",
      "CARD": "Thẻ",
      "BANK_TRANSFER": "Chuyển khoản",
      "MOBILE_MONEY": "Ví điện tử"
    },
    "dummyCheckout": "Thanh toán thử — không trừ tiền. Chọn phản hồi ngân hàng để mô phỏng.",
    "approve": "Mô phỏng: ngân hàng chấp nhận",
    "decline": "Mô phỏng: ngân hàng từ chối",
    "paymentApproved": "Thanh toán thành công. Cảm ơn!",
    "paymentDeclined": "Thanh toán bị từ chối. Thử lại hoặc trả tại quầy.",
    "bills": "Hóa đơn",
    "paymentHistory": "Lịch sử thanh toán",
    "noInvoices": "Không có hóa đơn",
    "noPayments": "Chưa có thanh toán",
    "balance": "Còn nợ",
    "total": "Tổng",
    "notifications": "Tin nhắn",
    "noNotifications": "Không có tin nhắn",
    "notify": {
      "DIAGNOSIS": "Bác sĩ đã ghi chẩn đoán ({{ref}})",
      "QUEUE_CALLED": "Đang gọi số {{ref}} của bạn",
      "EncounterCompleted": "Tóm tắt lượt khám {{ref}} đã sẵn sàng",
      "PrescriptionIssued": "Đơn thuốc mới {{ref}}",
      "LabResultVerified": "Có kết quả xét nghiệm ({{ref}})",
      "InvoiceCreated": "Hóa đơn mới {{ref}}",
      "PaymentCompleted": "Đã nhận thanh toán {{ref}}",
      "EyeExaminationSigned": "Kết quả khám mắt đã sẵn sàng",
      "EyeSurgeryScheduled": "Đã lên lịch mổ mắt ({{ref}})",
      "AppointmentBooked": "Đã đặt lịch hẹn ({{ref}})"
    },
    "allergies": "Dị ứng",
    "bloodGroup": "Nhóm máu",
    "stageNow": "Hiện tại: {{stage}}",
    "instructions": "Cần làm",
    "signOut": "Đăng xuất",
    "settings": "Ngôn ngữ & giao diện",
    "verifiedAccount": "Đã xác minh danh tính",
    "pendingAccount": "Chờ kiểm tra giấy tờ",
    "patientNumber": "Mã bệnh nhân",
    "continue": "Tiếp tục",
    "sexAge": "Giới · tuổi",
    "address": "Địa chỉ",
    "registeredOn": "Đăng ký tại bệnh viện",
    "myInformation": "Thông tin của tôi",
    "infoHelp": "Để sửa thông tin, vui lòng liên hệ quầy đăng ký.",
    "outcome": {
      "ALREADY_REGISTERED": {
        "title": "Bạn đã đăng ký rồi",
        "text": "Số điện thoại hoặc e-mail này đã có tài khoản ({{mrn}}). Bạn đã được đăng nhập."
      },
      "LINKED": {
        "title": "Đã tạo tài khoản",
        "text": "Đã tìm thấy hồ sơ {{mrn}} của bạn và liên kết với tài khoản. Bạn có thể xem lượt khám, kết quả và hóa đơn."
      },
      "CREATED": {
        "title": "Đã tạo tài khoản",
        "text": "Chào mừng! Mã bệnh nhân mới của bạn là {{mrn}}."
      },
      "ACTIVATED": {
        "title": "Đã kích hoạt ứng dụng",
        "text": "Tài khoản của bạn đã liên kết với hồ sơ {{mrn}}."
      }
    },
    "appName": "HMS Bệnh nhân"
  },
  "print": {
    "eyeCenterName": "Trung tâm Điều trị và Chăm sóc Sức khỏe Mắt",
    "eyeRegistration": "In phiếu đăng ký khám mắt",
    "patientCode": "Mã bệnh nhân",
    "queueNo": "Số thứ tự",
    "fullName": "Họ và tên",
    "dateOfBirth": "Ngày sinh",
    "sex": "Giới tính",
    "age": "Tuổi",
    "years": "{{count}} tuổi",
    "occupation": "Nghề nghiệp",
    "disability": "Bệnh nhân khuyết tật",
    "village": "Bản",
    "district": "Huyện",
    "province": "Tỉnh",
    "phone": "Điện thoại",
    "registeredOn": "Ngày đăng ký",
    "registeredBy": "Người đăng ký",
    "patientInfo": "Thông tin bệnh nhân",
    "newPatient": "Bệnh nhân mới",
    "returningPatient": "Bệnh nhân tái khám",
    "examDetails": "Chi tiết khám",
    "titleFemale": "Bà",
    "titleMale": "Ông",
    "downloadPdf": "Tải PDF (A4)"
  },
  "reports": {
    "title": "Báo cáo",
    "subtitle": "Chạy, in và xuất mọi báo cáo của bệnh viện",
    "catalog": "Danh mục báo cáo",
    "total": "Tổng",
    "run": "Chạy báo cáo",
    "exportCsv": "Xuất CSV",
    "quickRange": "Khoảng nhanh",
    "thisMonth": "Tháng này",
    "lastMonth": "Tháng trước",
    "thisYear": "Năm nay",
    "pickReport": "Chọn một báo cáo trong danh mục",
    "pressRun": "Chọn khoảng thời gian rồi bấm “Chạy báo cáo”",
    "period": "Kỳ",
    "rows": "Số dòng",
    "truncated": "Chỉ hiển thị 5.000 dòng đầu; hãy thu hẹp khoảng thời gian.",
    "printedAt": "In lúc",
    "noRows": "Không có dữ liệu trong kỳ này",
    "category": {
      "PATIENTS": "Bệnh nhân",
      "CLINICAL": "Lâm sàng",
      "SERVICES": "Dịch vụ",
      "FINANCE": "Tài chính",
      "OPERATIONS": "Vận hành",
      "EYE": "Trung tâm mắt",
      "INVENTORY": "Kho thuốc & vật tư",
      "PROCUREMENT": "Mua sắm",
      "EQUIPMENT": "Thiết bị y tế",
      "INPATIENT": "Nội trú",
      "SALES": "Quầy bán thuốc"
    },
    "r": {
      "patients-registered": {
        "title": "Bệnh nhân đăng ký",
        "desc": "Mọi bệnh nhân đăng ký trong kỳ kèm địa chỉ"
      },
      "patients-by-address": {
        "title": "Bệnh nhân theo địa chỉ",
        "desc": "Bệnh nhân theo tỉnh và huyện"
      },
      "demographics": {
        "title": "Nhân khẩu học",
        "desc": "Bệnh nhân khám theo nhóm tuổi và giới"
      },
      "appointments": {
        "title": "Lịch hẹn",
        "desc": "Tất cả lịch hẹn trong kỳ"
      },
      "visits-by-department": {
        "title": "Lượt khám theo khoa",
        "desc": "Lượt khám hằng ngày theo khoa và loại"
      },
      "visits": {
        "title": "Sổ khám bệnh",
        "desc": "Mọi lượt khám kèm chẩn đoán"
      },
      "morbidity": {
        "title": "Bệnh tật (ICD-10)",
        "desc": "Ca chẩn đoán theo mã, giới và nhóm tuổi"
      },
      "medications": {
        "title": "Sử dụng thuốc",
        "desc": "Số lượng kê đơn và cấp phát theo thuốc"
      },
      "laboratory": {
        "title": "Khối lượng xét nghiệm",
        "desc": "Xét nghiệm đã chỉ định, duyệt và bất thường"
      },
      "revenue-daily": {
        "title": "Doanh thu hằng ngày",
        "desc": "Xuất hóa đơn, giảm giá và thu theo ngày"
      },
      "revenue-by-service": {
        "title": "Doanh thu theo dịch vụ",
        "desc": "Số tiền theo loại dịch vụ"
      },
      "payments": {
        "title": "Thanh toán đã nhận",
        "desc": "Mọi khoản thanh toán kèm phương thức và thu ngân"
      },
      "outstanding": {
        "title": "Công nợ",
        "desc": "Hóa đơn chưa thanh toán và tuổi nợ"
      },
      "queue-performance": {
        "title": "Hiệu quả hàng đợi",
        "desc": "Số phiếu, thời gian chờ và phục vụ"
      },
      "care-plans": {
        "title": "Chu kỳ điều trị",
        "desc": "Bệnh nhân theo lộ trình và giai đoạn"
      },
      "patient-app": {
        "title": "Sử dụng ứng dụng bệnh nhân",
        "desc": "Tài khoản, kích hoạt, phiếu và thanh toán"
      },
      "staff-activity": {
        "title": "Hoạt động nhân viên",
        "desc": "Thao tác ghi nhận theo nhân viên"
      },
      "eye-exams": {
        "title": "Khám mắt",
        "desc": "Lượt khám kèm VA, IOP và chẩn đoán"
      },
      "eye-surgeries": {
        "title": "Phẫu thuật mắt",
        "desc": "Ca mổ kèm phẫu thuật viên, IOL và kết quả"
      },
      "eye-injections": {
        "title": "Tiêm nội nhãn",
        "desc": "Mũi tiêm kèm thuốc và số lô"
      },
      "eye-high-iop": {
        "title": "Nhãn áp cao",
        "desc": "IOP gần nhất trên 21 mmHg"
      },
      "eye-follow-ups": {
        "title": "Tái khám mắt",
        "desc": "Lịch tái khám mắt đã hẹn và quá hạn"
      },
      "inventory-stock": {
        "title": "Tồn kho hiện có",
        "desc": "Số lượng, giá vốn và giá trị theo mặt hàng và kho"
      },
      "inventory-low-stock": {
        "title": "Sắp hết & đặt lại",
        "desc": "Mặt hàng đạt mức đặt lại kèm số lượng gợi ý"
      },
      "inventory-expiry": {
        "title": "Báo cáo hạn dùng",
        "desc": "Lô đã hoặc sẽ hết hạn đến ngày kết thúc"
      },
      "inventory-movements": {
        "title": "Sổ nhập xuất kho",
        "desc": "Mọi biến động kho trong kỳ"
      },
      "inventory-consumption": {
        "title": "Tiêu hao theo mặt hàng",
        "desc": "Số lượng cấp phát, xuất dùng, giá trị và số ngày đủ dùng"
      },
      "inventory-consumption-department": {
        "title": "Tiêu hao theo khoa",
        "desc": "Giá trị dùng theo đơn thuốc và từng khoa"
      },
      "inventory-valuation": {
        "title": "Định giá tồn kho",
        "desc": "Giá trị tồn theo loại và nhóm"
      },
      "inventory-adjustments": {
        "title": "Điều chỉnh & hủy hàng",
        "desc": "Tồn đầu, điều chỉnh, hủy và trả hàng"
      },
      "inventory-abc": {
        "title": "Phân tích ABC",
        "desc": "Xếp hạng theo giá trị tiêu hao (A = 80% đầu)"
      },
      "purchase-requests": {
        "title": "Đề nghị mua",
        "desc": "Đề nghị tạo trong kỳ kèm trạng thái và giá trị"
      },
      "purchase-orders": {
        "title": "Đơn đặt hàng",
        "desc": "Đơn trong kỳ, giá trị đã nhận và còn thiếu"
      },
      "goods-receipts": {
        "title": "Hàng đã nhận",
        "desc": "Mọi dòng nhận hàng kèm lô, hạn dùng và giá"
      },
      "supplier-performance": {
        "title": "Hiệu quả nhà cung cấp",
        "desc": "Giá trị đặt, giao đúng hạn và thời gian giao theo nhà cung cấp"
      },
      "equipment-register": {
        "title": "Sổ thiết bị",
        "desc": "Toàn bộ thiết bị kèm vị trí, bảo hành và bảo trì"
      },
      "equipment-maintenance": {
        "title": "Nhật ký bảo trì",
        "desc": "Bảo trì, hiệu chuẩn và sửa chữa trong kỳ"
      },
      "equipment-due": {
        "title": "Thiết bị đến hạn bảo trì",
        "desc": "Thiết bị đến hạn hoặc quá hạn bảo trì đến ngày kết thúc"
      },
      "ipd-census": {
        "title": "Bệnh nhân đang nằm viện",
        "desc": "Mọi bệnh nhân nội trú với giường, số ngày và ngày dự kiến ra viện"
      },
      "ipd-admissions": {
        "title": "Nhập viện",
        "desc": "Lượt nhập viện trong kỳ với hình thức, khoa và kết quả"
      },
      "ipd-discharges": {
        "title": "Ra viện",
        "desc": "Bệnh nhân ra viện trong kỳ, số ngày nằm viện và tái khám"
      },
      "ipd-occupancy": {
        "title": "Công suất giường",
        "desc": "Số giường mỗi khoa, ngày giường đã dùng và công suất"
      },
      "ipd-length-of-stay": {
        "title": "Thời gian nằm viện",
        "desc": "Trung bình, ngắn nhất, dài nhất theo khoa và hình thức ra viện"
      },
      "special-services": {
        "title": "Dịch vụ đặc biệt",
        "desc": "Mọi chỉ định X-quang, siêu âm, điện tim ... với trạng thái và thời gian trả kết quả"
      },
      "special-services-summary": {
        "title": "Dịch vụ đặc biệt theo loại",
        "desc": "Số chỉ định, hoàn thành, còn chờ và doanh thu mỗi dịch vụ"
      },
      "sales-daily": {
        "title": "Bán tại quầy theo ngày",
        "desc": "Doanh số, giảm giá, hoàn tiền, tiền mặt và lãi mỗi ngày"
      },
      "sales-items": {
        "title": "Mặt hàng bán chạy",
        "desc": "Số lượng bán, trả lại, doanh thu, giá vốn và lãi mỗi mặt hàng"
      },
      "sales-transactions": {
        "title": "Hóa đơn bán hàng",
        "desc": "Mọi giao dịch tại quầy với thu ngân, thanh toán và trả hàng"
      },
      "finance-profit-loss": {
        "title": "Lãi lỗ",
        "desc": "Doanh thu, giá vốn, chi phí và lợi nhuận ròng"
      },
      "finance-revenue-sources": {
        "title": "Doanh thu theo nguồn",
        "desc": "Hóa đơn theo khoa và bán tại quầy"
      },
      "finance-discounts": {
        "title": "Giảm giá đã cho",
        "desc": "Mọi khoản giảm giá trên hóa đơn và tại quầy kèm lý do"
      },
      "finance-expenses": {
        "title": "Chi phí",
        "desc": "Chi phí với người ghi và người duyệt"
      },
      "finance-cash-sessions": {
        "title": "Ca thu ngân",
        "desc": "Tiền mặt phải có và đếm được, chênh lệch và xác nhận"
      },
      "finance-price-list": {
        "title": "Bảng giá",
        "desc": "Mọi phí, thuốc, xét nghiệm, dịch vụ, giá giường và hàng bán"
      },
      "finance-price-changes": {
        "title": "Thay đổi giá",
        "desc": "Giá cũ, giá mới, lý do và người thay đổi"
      },
      "stock-documents": {
        "title": "Chứng từ kho",
        "desc": "Nhập, xuất và chuyển kho với người lập và người kiểm"
      },
      "morbidity-by-type": {
        "title": "Bệnh tật theo nhóm bệnh",
        "desc": "Ca chẩn đoán theo nhóm bệnh, kèm ca phải báo cáo, giới tính và nhóm tuổi"
      }
    },
    "col": {
      "abnormal": "Bất thường",
      "abnormalRate": "% bất thường",
      "actions": "Thao tác",
      "activationCodes": "Mã kích hoạt",
      "activePatients": "Bệnh nhân đang điều trị",
      "administeredBy": "Người tiêm",
      "age": "Tuổi",
      "age15to49": "15–49",
      "age50plus": "50+",
      "age5to14": "5–14",
      "ageGroup": "Nhóm tuổi",
      "ageing": "Tuổi nợ",
      "amount": "Số tiền",
      "appPaid": "Thanh toán qua app",
      "appPayments": "Lượt thanh toán app",
      "appTickets": "Phiếu từ app",
      "appointmentNumber": "Số lịch hẹn",
      "avgServiceMinutes": "TB phục vụ (phút)",
      "avgTurnaroundMinutes": "TB trả kết quả (phút)",
      "avgWaitMinutes": "TB chờ (phút)",
      "balance": "Còn nợ",
      "caseNumber": "Số ca",
      "cases": "Số ca",
      "category": "Loại",
      "code": "Mã",
      "collected": "Đã thu",
      "completedInRange": "Hoàn thành",
      "complications": "Biến chứng",
      "creates": "Tạo mới",
      "date": "Ngày",
      "dateOfBirth": "Ngày sinh",
      "daysOverdue": "Số ngày quá hạn",
      "department": "Khoa",
      "diagnoses": "Chẩn đoán",
      "diagnosis": "Chẩn đoán",
      "discount": "Giảm giá",
      "district": "Huyện",
      "doctor": "Bác sĩ",
      "emergency": "Cấp cứu",
      "encounterNumber": "Số lượt khám",
      "examinedBy": "Người khám",
      "eye": "Mắt",
      "female": "Nữ",
      "form": "Dạng",
      "fromApp": "Từ app",
      "gross": "Tổng gộp",
      "indication": "Chỉ định",
      "invoiceNumber": "Số hóa đơn",
      "invoices": "Hóa đơn",
      "iol": "IOL",
      "iop": "IOP (mmHg)",
      "iopOd": "IOP OD",
      "iopOs": "IOP OS",
      "issuedAt": "Ngày lập",
      "lastActivity": "Hoạt động gần nhất",
      "lines": "Dòng",
      "lotNumber": "Số lô",
      "male": "Nam",
      "maxWaitMinutes": "Chờ lâu nhất (phút)",
      "measuredAt": "Thời điểm đo",
      "medication": "Thuốc",
      "method": "Phương thức",
      "mrn": "Mã bệnh nhân",
      "net": "Thực thu",
      "newAccounts": "Tài khoản mới",
      "newInRange": "Mới trong kỳ",
      "newPatients": "Bệnh nhân mới",
      "nextFollowUp": "Tái khám tiếp",
      "opd": "Ngoại trú",
      "ordered": "Đã chỉ định",
      "other": "Khác",
      "outstanding": "Còn nợ",
      "overdueReviews": "Quá hạn tái khám",
      "paidAt": "Thời điểm trả",
      "pathway": "Lộ trình",
      "patientName": "Bệnh nhân",
      "patients": "Bệnh nhân",
      "paymentNumber": "Số phiếu thu",
      "phone": "Điện thoại",
      "postOpVa": "VA sau mổ",
      "practitioner": "Bác sĩ",
      "prescriptions": "Đơn thuốc",
      "procedureName": "Thủ thuật",
      "province": "Tỉnh",
      "quantity": "Số lượng",
      "quantityDispensed": "Đã cấp",
      "quantityPrescribed": "Đã kê",
      "reason": "Lý do",
      "receivedBy": "Người thu",
      "registeredAt": "Ngày đăng ký",
      "registeredBy": "Người đăng ký",
      "scheduledStart": "Giờ hẹn",
      "selfRegistered": "Tự đăng ký",
      "served": "Đã phục vụ",
      "sex": "Giới",
      "share": "Tỷ trọng",
      "signatures": "Ký duyệt",
      "skipped": "Bỏ qua",
      "staff": "Nhân viên",
      "stage": "Giai đoạn",
      "startedAt": "Bắt đầu",
      "startedInRange": "Bắt đầu trong kỳ",
      "status": "Trạng thái",
      "surgeon": "Phẫu thuật viên",
      "test": "Xét nghiệm",
      "tickets": "Phiếu",
      "total": "Tổng",
      "type": "Loại",
      "under5": "Dưới 5",
      "updates": "Cập nhật",
      "vaOd": "VA OD",
      "vaOs": "VA OS",
      "value": "Giá trị",
      "verified": "Đã duyệt",
      "views": "Lượt xem",
      "village": "Bản",
      "itemCode": "Mã",
      "item": "Mặt hàng",
      "itemType": "Loại",
      "store": "Kho",
      "unit": "Đơn vị",
      "onHand": "Tồn thực tế",
      "usable": "Dùng được",
      "unitCost": "Đơn giá",
      "stockValue": "Giá trị tồn",
      "reorderLevel": "Mức đặt lại",
      "nextExpiry": "Hạn gần nhất",
      "onOrder": "Đang đặt",
      "avgDailyUse": "TB/ngày",
      "daysOfCover": "Đủ dùng (ngày)",
      "suggestedQuantity": "Gợi ý đặt",
      "estimatedCost": "Chi phí dự kiến",
      "expiryDate": "Hạn dùng",
      "daysLeft": "Còn (ngày)",
      "expiryStatus": "Tình trạng",
      "performedAt": "Ngày giờ",
      "movementType": "Loại",
      "balanceAfter": "Tồn sau",
      "reference": "Chứng từ",
      "performedBy": "Người thực hiện",
      "dispensed": "Cấp theo đơn",
      "issued": "Xuất khoa",
      "totalUsed": "Tổng dùng",
      "items": "Mặt hàng",
      "expiredValue": "Giá trị hết hạn",
      "abcClass": "Nhóm ABC",
      "cumulativeShare": "Tỷ trọng lũy kế",
      "prNumber": "Số PR",
      "createdAt": "Ngày tạo",
      "requestedBy": "Người đề nghị",
      "priority": "Ưu tiên",
      "estimatedTotal": "Tổng dự kiến",
      "decidedBy": "Người quyết định",
      "decidedAt": "Ngày quyết định",
      "orders": "Đơn hàng",
      "poNumber": "Số PO",
      "orderDate": "Ngày đặt",
      "supplier": "Nhà cung cấp",
      "expectedDate": "Dự kiến giao",
      "receivedValue": "Giá trị đã nhận",
      "outstandingValue": "Giá trị còn thiếu",
      "approvedBy": "Người duyệt",
      "receivedAt": "Ngày nhận",
      "grnNumber": "Số phiếu nhập",
      "orderedValue": "Giá trị đặt",
      "onTimeRate": "Đúng hạn",
      "avgLeadDays": "Thời gian giao TB (ngày)",
      "lateOrders": "Đơn trễ",
      "assetTag": "Mã tài sản",
      "serialNumber": "Số máy",
      "model": "Model",
      "location": "Vị trí",
      "purchaseDate": "Ngày mua",
      "purchaseCost": "Giá mua",
      "warrantyExpiry": "Bảo hành đến",
      "nextMaintenance": "Bảo trì tiếp",
      "maintenanceStatus": "Bảo trì",
      "eventType": "Loại",
      "cost": "Chi phí",
      "statusAfter": "Trạng thái sau",
      "nextDueDate": "Hạn kế tiếp",
      "notes": "Ghi chú",
      "dueDate": "Ngày đến hạn",
      "admissionNumber": "Số nhập viện",
      "admissionType": "Hình thức",
      "admissions": "Lượt nhập viện",
      "admittedAt": "Ngày vào",
      "againstAdvice": "Xin về",
      "attending": "Bác sĩ điều trị",
      "available": "Trống",
      "averageDays": "Số ngày TB",
      "bed": "Giường",
      "bedDays": "Ngày giường",
      "beds": "Giường",
      "cancelled": "Đã hủy",
      "cash": "Tiền mặt",
      "cashier": "Thu ngân",
      "changeRate": "Thay đổi %",
      "changedAt": "Thời gian",
      "changedBy": "Người đổi",
      "checkedAt": "Thời gian kiểm",
      "checkedBy": "Người kiểm",
      "cleaning": "Đang vệ sinh",
      "closedAt": "Đóng lúc",
      "completed": "Hoàn thành",
      "countedCash": "Đếm được",
      "customer": "Khách hàng",
      "days": "Ngày",
      "deceased": "Tử vong",
      "description": "Mô tả",
      "destination": "Đến",
      "dischargeType": "Hình thức ra viện",
      "dischargedAt": "Ngày ra viện",
      "dischargedBy": "Người cho ra viện",
      "discharges": "Lượt ra viện",
      "discountType": "Theo",
      "discountValue": "Giá trị",
      "docNumber": "Số chứng từ",
      "docType": "Loại",
      "entityType": "Loại",
      "expectedCash": "Phải có",
      "expectedDischarge": "Dự kiến ra",
      "expenseDate": "Ngày",
      "expenseNumber": "Số phiếu chi",
      "followUpDate": "Tái khám",
      "home": "Về nhà",
      "line": "Khoản mục",
      "margin": "Lãi",
      "marginRate": "Lãi %",
      "maxDays": "Dài nhất",
      "minDays": "Ngắn nhất",
      "name": "Tên",
      "newPrice": "Giá mới",
      "nonCash": "Không tiền mặt",
      "occupancyRate": "Công suất %",
      "occupied": "Có bệnh nhân",
      "oldPrice": "Giá cũ",
      "openedAt": "Mở lúc",
      "openingFloat": "Tiền đầu ca",
      "orderNumber": "Số chỉ định",
      "orderedAt": "Thời gian chỉ định",
      "outOfService": "Ngừng sử dụng",
      "payee": "Người nhận",
      "paymentMethod": "Thanh toán",
      "pending": "Còn chờ",
      "preparedBy": "Người lập",
      "price": "Giá",
      "recordedBy": "Người ghi",
      "referred": "Chuyển tuyến",
      "refunded": "Đã hoàn",
      "refunds": "Hoàn tiền",
      "reportedBy": "Người đọc kết quả",
      "returned": "Trả lại",
      "revenue": "Doanh thu",
      "saleNumber": "Số hóa đơn",
      "sales": "Lượt bán",
      "section": "Phần",
      "service": "Dịch vụ",
      "sessionNumber": "Ca",
      "sold": "Bán",
      "soldAt": "Thời gian bán",
      "source": "Nguồn",
      "turnaroundMinutes": "Thời gian trả KQ (phút)",
      "variance": "Chênh lệch",
      "verifiedBy": "Người duyệt",
      "ward": "Khoa",
      "diseaseType": "Nhóm bệnh",
      "notifiableCases": "Ca phải báo cáo"
    },
    "from": "Từ",
    "to": "Đến"
  },
  "locations": {
    "title": "Địa danh",
    "subtitle": "Tỉnh, huyện, xã/cụm bản và bản của Lào",
    "counts": "{{provinces}} tỉnh · {{districts}} huyện · {{villages}} bản",
    "pickDistrict": "Chọn huyện để quản lý xã/cụm bản và bản",
    "addSubdistrict": "Thêm xã/cụm bản",
    "editSubdistrict": "Sửa xã/cụm bản",
    "noSubdistricts": "Chưa có xã/cụm bản. Hãy thêm và gán bản.",
    "villageCount": "{{count}} bản",
    "assignVillages": "Gán bản",
    "searchVillage": "Tìm bản",
    "nameLa": "Tên (tiếng Lào)",
    "nameEn": "Tên (tiếng Anh)",
    "inOtherSubdistrict": "thuộc {{name}}"
  },
  "inventory": {
    "title": "Kho thuốc, nhà thuốc & thiết bị y tế",
    "subtitle": "Tồn kho, lô và hạn dùng, đề nghị mua và đơn đặt hàng, nhà cung cấp và thiết bị y tế",
    "item": "Mặt hàng",
    "items": "Mặt hàng",
    "name": "Tên",
    "itemType": "Loại",
    "category": "Nhóm",
    "unit": "Đơn vị",
    "manufacturer": "Nhà sản xuất",
    "unitCost": "Đơn giá vốn",
    "unitCostShort": "Giá vốn {{value}} / đơn vị",
    "reorderLevel": "Mức đặt hàng lại",
    "reorderLevelHint": "Cảnh báo và gợi ý đặt hàng khi tồn kho dùng được giảm đến mức này",
    "reorderQuantity": "Số lượng đặt lại",
    "maxLevel": "Mức tối đa",
    "maxLevelHint": "Vượt mức này được tính là tồn kho dư",
    "maxShort": "Tối đa {{value}}",
    "trackExpiry": "Theo dõi lô và hạn dùng",
    "controlled": "Thuốc kiểm soát đặc biệt",
    "controlledShort": "Kiểm soát",
    "storageCondition": "Điều kiện bảo quản",
    "linkMedication": "Thuốc (danh mục nhà thuốc)",
    "linkMedicationHint": "Thuốc đã liên kết sẽ trừ kho khi cấp phát theo đơn",
    "noMedicationLink": "Không liên kết (không cấp theo đơn)",
    "fromMedication": "Lấy từ thông tin thuốc",
    "newItem": "Thêm mặt hàng",
    "editItem": "Sửa mặt hàng",
    "searchItem": "Tìm thuốc, vật tư hoặc thiết bị…",
    "noItems": "Không tìm thấy mặt hàng",
    "usable": "Tồn dùng được",
    "onHand": "Tồn thực tế",
    "onOrder": "Đang đặt",
    "stockValue": "Giá trị tồn",
    "stockStatus": "Tình trạng tồn",
    "daysOfCover": "Đủ dùng (ngày)",
    "days": "{{count}} ngày",
    "daysLeft": "Còn {{count}} ngày",
    "expiredAgo": "Đã hết hạn {{count}} ngày",
    "overdueDays": "Quá hạn {{count}} ngày",
    "nextExpiry": "Hạn gần nhất",
    "assetsCount": "{{count}} thiết bị",
    "allStores": "Tất cả kho",
    "allSuppliers": "Tất cả nhà cung cấp",
    "store": "Kho",
    "storeType": "Loại kho",
    "newStore": "Thêm kho",
    "editStore": "Sửa kho",
    "dispensing": "Cấp phát",
    "dispensingStore": "Cấp thuốc theo đơn từ kho này",
    "dispensingStoreHint": "Tồn kho thuốc đã liên kết sẽ trừ tại kho này khi nhà thuốc cấp phát.",
    "fromStore": "Từ kho",
    "toStore": "Đến kho",
    "toDepartment": "Cho khoa",
    "department": "Khoa",
    "deliverTo": "Giao đến",
    "supplier": "Nhà cung cấp",
    "newSupplier": "Thêm nhà cung cấp",
    "editSupplier": "Sửa nhà cung cấp",
    "noSuppliers": "Chưa có nhà cung cấp",
    "contact": "Liên hệ",
    "contactPerson": "Người liên hệ",
    "phone": "Điện thoại",
    "email": "E-mail",
    "address": "Địa chỉ",
    "taxId": "Mã số thuế",
    "paymentTerms": "Điều khoản thanh toán",
    "leadTimeDays": "Thời gian giao (ngày)",
    "leadDays": "giao trong {{count}} ngày",
    "orders": "Đơn hàng",
    "receivedValueShort": "Giá trị đã nhận",
    "lots": "Lô",
    "lotNumber": "Số lô",
    "expiryDate": "Hạn dùng",
    "noLots": "Không có lô hàng",
    "lotsAndExpiry": "Lô & hạn dùng",
    "ledger": "Sổ nhập xuất kho",
    "allLots": "Tất cả lô",
    "expiredOnly": "Đã hết hạn",
    "within": "≤ {{count}} ngày",
    "lotsTotal": "{{count}} lô · {{value}}",
    "lotsCount": "{{count}} lô",
    "lotSummary": "Lô {{lot}} tại {{store}}: {{quantity}}",
    "receivedAt": "Ngày nhận",
    "movementType": "Loại nhập xuất",
    "quantity": "Số lượng",
    "balanceAfter": "Tồn sau",
    "reference": "Chứng từ",
    "performedAt": "Ngày / giờ",
    "performedBy": "Người thực hiện",
    "noMovements": "Chưa có nhập xuất",
    "recentMovements": "Nhập xuất gần đây",
    "clearItemFilter": "Hiện tất cả mặt hàng",
    "byStore": "Tồn theo kho",
    "usageByMonth": "Nhập và dùng mỗi tháng",
    "avgDailyUse": "Dùng trung bình/ngày",
    "coverDays": "Đủ dùng khoảng {{count}} ngày",
    "noUse": "Không dùng trong 90 ngày qua",
    "expiredQty": "Hàng hết hạn",
    "equipmentHint": "Thiết bị được theo dõi theo từng máy ({{count}} đã đăng ký).",
    "openEquipment": "Mở sổ thiết bị",
    "addStock": "Nhập thêm tồn",
    "stockAdded": "Đã nhập tồn",
    "adjustmentType": "Loại",
    "reason": "Lý do",
    "removeFromLot": "Xuất bỏ",
    "stockRemoved": "Đã xuất bỏ",
    "issue": "Xuất dùng",
    "issueStock": "Xuất cho khoa",
    "issued": "Đã xuất {{number}}",
    "transfer": "Chuyển kho",
    "transferStock": "Chuyển giữa các kho",
    "transferred": "Đã chuyển {{number}}",
    "fefoHint": "Xuất từ lô hết hạn trước (FEFO).",
    "requestPurchase": "Đề nghị mua",
    "warnings": "Cảnh báo",
    "noWarnings": "Không có cảnh báo — tồn kho, hạn dùng và thiết bị đều ổn",
    "seeAll": "Xem tất cả",
    "uncategorized": "Chưa phân nhóm",
    "updatedAt": "Cập nhật {{time}}",
    "requestOnlyHint": "Bạn có thể tạo đề nghị mua ở thẻ Đề nghị mua.",
    "purchaseRequest": "Đề nghị mua hàng",
    "purchaseOrder": "Đơn đặt hàng",
    "prNumber": "Số PR",
    "poNumber": "Số PO",
    "newRequest": "Tạo đề nghị mua",
    "editRequest": "Sửa đề nghị mua {{number}}",
    "newOrder": "Tạo đơn đặt hàng",
    "editOrder": "Sửa đơn đặt hàng {{number}}",
    "noRequests": "Chưa có đề nghị mua",
    "noOrders": "Chưa có đơn đặt hàng",
    "mineOnly": "Chỉ của tôi",
    "createdAt": "Ngày tạo",
    "created": "Tạo",
    "requestedBy": "Người đề nghị",
    "requestedByOn": "{{name}} đề nghị lúc {{date}}",
    "requestingDepartment": "Khoa đề nghị",
    "priority": "Mức ưu tiên",
    "neededBy": "Cần trước ngày",
    "reasonForRequest": "Lý do / căn cứ",
    "estimatedUnitCost": "Đơn giá dự kiến",
    "estimatedTotal": "Tổng dự kiến",
    "lineTotal": "Thành tiền",
    "saveDraft": "Lưu nháp",
    "saveAndSubmit": "Lưu và gửi duyệt",
    "submit": "Gửi duyệt",
    "approve": "Duyệt",
    "reject": "Từ chối",
    "approveRequest": "Duyệt {{number}}",
    "rejectRequest": "Từ chối {{number}}",
    "approveHint": "Duyệt số lượng từng dòng; 0 là bỏ dòng đó.",
    "requested": "Đề nghị",
    "approvedQty": "Được duyệt",
    "decisionNote": "Ghi chú quyết định",
    "cancelRequest": "Hủy đề nghị",
    "cancelRequestConfirm": "Đề nghị sẽ bị hủy và không thể đặt hàng nữa.",
    "selfApprovalHint": "Bạn là người đề nghị nên cần người duyệt khác quyết định.",
    "selfApprovalPoHint": "Bạn lập đơn này nên cần người khác duyệt.",
    "awaitingApproval": "Đang chờ người duyệt mua hàng phê duyệt.",
    "prSubmitted": "Đã gửi duyệt đề nghị mua",
    "prApproved": "Đã duyệt đề nghị mua",
    "prRejected": "Đã từ chối đề nghị mua",
    "prCancelled": "Đã hủy đề nghị mua",
    "createPo": "Tạo đơn đặt hàng",
    "poCreated": "Đã tạo đơn đặt hàng {{number}}",
    "history": "Lịch sử",
    "details": "Chi tiết",
    "reorderSuggestions": "Gợi ý đặt hàng",
    "suggestionsHint": "Mặt hàng đạt hoặc dưới mức đặt lại (trừ số đang đặt). Số lượng gợi ý bổ sung đến mức tối đa.",
    "noSuggestions": "Hiện không có mặt hàng cần đặt",
    "createPrFromSelection": "Tạo đề nghị ({{count}} mặt hàng)",
    "reorderReason": "Bổ sung mặt hàng đã đến mức đặt lại",
    "orderDate": "Ngày đặt",
    "orderedOn": "đặt ngày {{date}}",
    "expectedDate": "Dự kiến giao",
    "expectedDateHint": "Để trống: hôm nay + thời gian giao của nhà cung cấp",
    "overdue": "Quá hạn",
    "total": "Tổng",
    "ordered": "Đã đặt",
    "received": "Đã nhận",
    "receivedValue": "đã nhận {{value}}",
    "outstanding": "Còn thiếu",
    "saveOrder": "Lưu đơn đặt hàng",
    "markSent": "Đánh dấu đã gửi nhà cung cấp",
    "receive": "Nhận hàng",
    "receiveGoods": "Nhận hàng — {{number}}",
    "receiveHint": "Nhập số hàng đã đến. Thuốc và hàng có hạn dùng cần số lô và hạn dùng; không nhận hàng đã hết hạn.",
    "receiveQty": "Nhận lần này",
    "required": "Bắt buộc",
    "deliveryNote": "Số phiếu giao hàng",
    "confirmReceipt": "Xác nhận nhận hàng",
    "goodsReceived": "Đã nhập kho",
    "goodsReceipts": "Phiếu nhập kho",
    "noReceipts": "Chưa nhận hàng",
    "closeShort": "Đóng (phần còn lại không giao)",
    "closeShortConfirm": "Đơn sẽ đóng theo số lượng đã nhận.",
    "cancelOrder": "Hủy đơn",
    "poApproved": "Đã duyệt đơn đặt hàng",
    "poSent": "Đã gửi đơn đặt hàng",
    "poCancelled": "Đã hủy đơn đặt hàng",
    "poClosed": "Đã đóng đơn đặt hàng",
    "preparedBy": "Người lập",
    "approvedBy": "Người duyệt",
    "supplierAcknowledgement": "Nhà cung cấp xác nhận",
    "description": "Mô tả",
    "equipment": "Thiết bị",
    "newAsset": "Đăng ký thiết bị",
    "editAsset": "Sửa thiết bị",
    "noAssets": "Chưa có thiết bị",
    "equipmentType": "Loại thiết bị",
    "equipmentTypeHint": "Mặt hàng loại Thiết bị (tạo ở thẻ Mặt hàng trước).",
    "searchEquipment": "Tìm thiết bị, mã tài sản, số máy hoặc vị trí…",
    "assetTag": "Mã tài sản",
    "assetTagHint": "Để trống: đánh số tự động",
    "serialNumber": "Số máy",
    "model": "Model",
    "location": "Vị trí",
    "purchaseDate": "Ngày mua",
    "purchaseCost": "Giá mua",
    "purchasedFor": "mua giá {{value}} ngày {{date}}",
    "warrantyExpiry": "Bảo hành đến",
    "underWarranty": "Còn bảo hành",
    "warrantyEnded": "Hết bảo hành",
    "maintenanceInterval": "Bảo trì mỗi (ngày)",
    "lastMaintenance": "Bảo trì gần nhất",
    "lastOn": "lần trước {{date}}",
    "nextMaintenance": "Bảo trì tiếp theo",
    "nextMaintenanceHint": "Để trống: lần trước + chu kỳ",
    "maintenanceDueOnly": "Đến hạn bảo trì",
    "maintenanceCost": "Chi phí bảo trì",
    "serviceHistory": "Lịch sử bảo trì & sửa chữa",
    "noEvents": "Chưa có bảo trì",
    "logEvent": "Ghi nhận bảo trì — {{tag}}",
    "logEventShort": "Ghi bảo trì",
    "eventType": "Loại",
    "eventDate": "Ngày",
    "cost": "Chi phí",
    "statusAfter": "Trạng thái sau",
    "noChange": "Không đổi",
    "nextDueDate": "Hạn kế tiếp",
    "nextDueHint": "Để trống: hôm nay + chu kỳ bảo trì",
    "recordedBy": "Người ghi",
    "tab": {
      "dashboard": "Thống kê",
      "items": "Mặt hàng",
      "stock": "Tồn kho",
      "requests": "Đề nghị mua",
      "orders": "Đơn đặt hàng",
      "suppliers": "Nhà cung cấp",
      "equipment": "Thiết bị y tế",
      "alerts": "Cảnh báo",
      "stores": "Kho",
      "stockIn": "Nhập kho",
      "stockOut": "Xuất kho",
      "transfers": "Chuyển kho",
      "toCheck": "Chờ kiểm tra",
      "posRefills": "Yêu cầu bổ sung POS"
    },
    "kpi": {
      "stockValue": "Giá trị tồn kho",
      "itemsCount": "{{count}} mặt hàng",
      "outOfStock": "Hết hàng",
      "lowCount": "{{count}} sắp hết",
      "lowStock": "Sắp hết",
      "overCount": "{{count}} dư",
      "expiring30": "Hết hạn ≤ 30 ngày",
      "expiredLots": "{{count}} lô hết hạn · {{value}}",
      "prPending": "Đề nghị chờ duyệt",
      "prApproved": "{{count}} đã duyệt chưa đặt",
      "poOpen": "Đơn đặt hàng đang mở",
      "poOverdue": "{{count}} quá hạn · còn {{value}}",
      "equipment": "Thiết bị y tế",
      "maintenance": "{{due}} đến hạn · {{overdue}} quá hạn"
    },
    "chart": {
      "flowByMonth": "Nhập, dùng và hủy mỗi tháng",
      "received": "Nhập",
      "consumed": "Dùng",
      "writtenOff": "Hủy",
      "valueByCategory": "Giá trị tồn theo nhóm",
      "topConsumed": "Dùng nhiều nhất (90 ngày, theo giá trị)",
      "expiryTimeline": "Giá trị hàng hết hạn theo tháng",
      "expiringValue": "Sắp hết hạn",
      "spendBySupplier": "Mua hàng theo nhà cung cấp (12 tháng)"
    },
    "severity": {
      "danger": "{{count}} khẩn",
      "warning": "{{count}} cảnh báo",
      "info": "{{count}} thông tin"
    },
    "alert": {
      "OUT_OF_STOCK": "Hết hàng",
      "LOW_STOCK": "Sắp hết",
      "OVERSTOCK": "Tồn dư",
      "EXPIRED": "Hết hạn",
      "EXPIRING": "Sắp hết hạn",
      "PO_OVERDUE": "Giao trễ",
      "PO_APPROVAL": "Đơn chờ duyệt",
      "PR_PENDING": "Đề nghị chờ duyệt",
      "MAINTENANCE_OVERDUE": "Quá hạn bảo trì",
      "MAINTENANCE_DUE": "Đến hạn bảo trì",
      "WARRANTY_EXPIRING": "Sắp hết bảo hành",
      "ASSET_OUT_OF_SERVICE": "Thiết bị ngừng hoạt động",
      "stockDetail": "Dùng được {{usable}} · đặt lại ở {{reorder}} · đang đặt {{onOrder}}",
      "overDetail": "Dùng được {{usable}} · tối đa {{max}}",
      "lotDetail": "Lô {{lot}} · {{store}} · {{quantity}} · {{date}} · {{value}}",
      "poOverdueDetail": "{{supplier}} · dự kiến {{date}} (trễ {{count}} ngày)",
      "prDetail": "Bởi {{by}} · {{priority}}"
    },
    "barcode": "Mã vạch",
    "grnNumber": "Phiếu nhập",
    "margin": "lãi {{value}}%",
    "noPictures": "Chưa có ảnh. Thêm một hoặc nhiều ảnh sản phẩm.",
    "notForSale": "Không bán",
    "pictures": "Hình ảnh và giá bán",
    "salePrice": "Giá bán",
    "salePriceDrugHint": "Dùng chung giá cho đơn thuốc và bán tại quầy",
    "salePriceHint": "Giá bán tại quầy thuốc",
    "sellable": "Bán tại quầy",
    "docs": {
      "availableNow": "Hiện có",
      "cancelConfirm": "Chứng từ sẽ bị hủy. Tồn kho không thay đổi.",
      "cancelTitle": "Hủy chứng từ",
      "cancelled": "Đã hủy chứng từ",
      "checkNote": "Ghi chú người kiểm",
      "checkedBy": "Người kiểm",
      "destination": "Đến",
      "fefo": "Hết hạn trước xuất trước",
      "lineCount": "{{count}} dòng",
      "newRequisition": "Phiếu lĩnh mới",
      "newStockIn": "Phiếu nhập mới",
      "newWriteOff": "Hủy / trả hàng",
      "none": "Không có chứng từ",
      "nothingToCheck": "Không có chứng từ chờ bạn kiểm",
      "number": "Số chứng từ",
      "pendingCheck": "Chờ kiểm",
      "pickItem": "Chọn mặt hàng cần nhập",
      "pickLotHint": "Hủy và trả hàng lấy từ một lô. Chọn mặt hàng rồi bấm \"Xuất bỏ\" ở lô.",
      "post": "Kiểm và ghi sổ",
      "postConfirm": "Tồn kho sẽ thay đổi ngay. Kiểm số lượng, lô và hạn dùng với hàng thực tế.",
      "postTitle": "Ghi sổ {{number}}",
      "posted": "Đã ghi sổ {{number}}, tồn kho đã cập nhật",
      "receiptDocuments": "Phiếu nhập và kiểm tra",
      "receiptHint": "Phiếu nhập chờ người thứ hai kiểm hàng và ghi sổ.",
      "receiveFromPo": "Nhập từ đơn đặt hàng",
      "receivedBy": "Người nhận",
      "reference": "Tham chiếu",
      "reject": "Từ chối",
      "rejectReason": "Lý do từ chối",
      "rejected": "Đã từ chối chứng từ",
      "rejectedBecause": "Bị từ chối: {{note}}",
      "shortNow": "Một số dòng không đủ tồn; ghi sổ sẽ thất bại.",
      "storeKeeper": "Thủ kho",
      "submitForCheck": "Gửi kiểm tra",
      "submitRequisition": "Gửi phiếu lĩnh",
      "submitted": "Đã gửi {{number}} để kiểm tra",
      "type": "Loại",
      "value": "Giá trị",
      "waitingForChecker": "Đang chờ người kiểm thứ hai ghi sổ.",
      "inHint": "Nhập kho: hàng từ đơn đặt hàng, tồn đầu kỳ và điều chỉnh. Mỗi chứng từ do người thứ hai kiểm và ghi sổ.",
      "outHint": "Xuất kho: phiếu lĩnh của khoa, hủy hàng, điều chỉnh và trả nhà cung cấp. Hàng chỉ xuất khi người thứ hai ghi sổ.",
      "transferHint": "Chuyển hàng giữa các kho, giữ nguyên lô và hạn dùng. Người thứ hai ghi sổ.",
      "checkHint": "Chứng từ do người khác lập, chờ bạn đối chiếu hàng và ghi sổ hoặc từ chối."
    }
  },
  "gallery": {
    "add": "Thêm ảnh",
    "main": "Chính",
    "makeMain": "Đặt làm ảnh chính",
    "next": "Tiếp",
    "previous": "Trước",
    "none": "Chưa có ảnh",
    "open": "Mở ảnh"
  },
  "inpatient": {
    "title": "Điều trị nội trú",
    "subtitle": "Nhập viện, chuyển giường và xuất viện, tính tiền giường theo ngày",
    "addBed": "Thêm giường",
    "addRoom": "Thêm phòng",
    "admissionNumber": "Số nhập viện",
    "admissionType": "Hình thức nhập viện",
    "admit": "Nhập viện",
    "admitPatient": "Cho bệnh nhân nhập viện",
    "admitted": "Đã nhập viện: {{number}}",
    "admittedAt": "Ngày nhập viện",
    "admittingDiagnosis": "Chẩn đoán lúc vào",
    "allWards": "Tất cả khoa",
    "attending": "Bác sĩ điều trị",
    "attendingDefault": "Chưa chọn",
    "bed": "Giường",
    "bedCharges": "Tiền giường",
    "bedChargesSoFar": "Tiền giường đến nay",
    "bedDayRule": "Ngày giường tính theo đêm (nửa đêm) với giá của giường; nằm trong ngày tính một ngày.",
    "bedNumber": "Số giường",
    "bedStays": "Giường đã nằm",
    "bedType": "Loại giường",
    "beds": "Giường",
    "billAfterDischarge": "Tiền giường được lập hóa đơn sau khi xuất viện",
    "billed": "Đã lập hóa đơn",
    "by": "bởi {{name}}",
    "cancelAdmission": "Hủy nhập viện",
    "cancelHint": "Chỉ dùng khi nhập viện nhầm. Giường được giải phóng và không tính phí.",
    "cancelled": "Đã hủy nhập viện",
    "cancelledBecause": "Đã hủy: {{reason}}",
    "capacity": "Số giường",
    "clinical": "Lâm sàng",
    "createBill": "Lập hóa đơn",
    "dailyRate": "Giá mỗi ngày",
    "dailyRateHint": "Tính theo đêm cho mỗi giường trong phòng",
    "day": "ngày",
    "dayN": "ngày {{count}}",
    "discharge": "Xuất viện",
    "dischargeAnyway": "Vẫn cho xuất viện",
    "dischargeDiagnosis": "Chẩn đoán ra viện",
    "dischargeHint": "Giường chuyển sang vệ sinh và tiền giường sẵn sàng lập hóa đơn.",
    "dischargeMedications": "Thuốc mang về",
    "dischargeSummary": "Tóm tắt ra viện",
    "dischargeTitle": "Cho {{name}} xuất viện",
    "dischargeType": "Hình thức ra viện",
    "discharged": "Đã cho xuất viện",
    "dischargedAt": "Ngày ra viện",
    "editRoom": "Sửa phòng",
    "editWard": "Sửa khoa",
    "expectedDischarge": "Dự kiến ra viện",
    "expectedShort": "dự kiến ra {{date}}",
    "floor": "tầng {{floor}}",
    "floorLabel": "Tầng",
    "followUpDate": "Ngày tái khám",
    "followUpInstructions": "Hướng dẫn sau ra viện",
    "from": "Từ",
    "lengthOfStay": "Số ngày nằm viện",
    "markClean": "Đã vệ sinh",
    "moveReason": "Lý do",
    "newBed": "Giường mới",
    "newWard": "Thêm khoa",
    "nights": "{{count}} đêm",
    "nightsHeader": "Đêm",
    "noAdmissions": "Không có lượt nhập viện",
    "noFreeBeds": "Không có giường trống",
    "noRooms": "Chưa có phòng",
    "noWards": "Chưa có khoa. Hãy thiết lập khoa, phòng và giường trước.",
    "notBilledYet": "Chưa lập hóa đơn",
    "now": "hiện tại",
    "occupancy": "Công suất giường",
    "occupiedOf": "{{occupied}}/{{total}} giường",
    "openChart": "Mở bệnh án",
    "patient": "Bệnh nhân",
    "patientOrRelative": "Bệnh nhân hoặc người nhà",
    "pendingWork": "Còn việc chưa hoàn thành",
    "pending": {
      "serviceOrders": "{{count}} dịch vụ chưa xong",
      "labOrders": "{{count}} xét nghiệm chưa xong",
      "prescriptions": "{{count}} đơn thuốc chưa phát",
      "draftNotes": "{{count}} ghi chép chưa ký"
    },
    "printNote": "Giữ bản tóm tắt này và mang theo khi tái khám.",
    "reason": "Lý do nhập viện",
    "release": "Đặt trống",
    "room": "Phòng",
    "roomN": "Phòng {{room}}",
    "roomType": "Loại phòng",
    "searchAdmissions": "Tên, HN hoặc số nhập viện",
    "to": "Đến",
    "transfer": "Chuyển",
    "transferBed": "Chuyển giường",
    "transferHint": "Hiện ở {{bed}}. Giường cũ chuyển sang vệ sinh.",
    "transferred": "Đã chuyển đến {{bed}}",
    "visit": "Lượt khám",
    "ward": "Khoa",
    "wardType": "Loại khoa",
    "searchBeds": "Bệnh nhân, HN, phòng hoặc giường",
    "admittedToday": "Nhập viện hôm nay",
    "dueOutToday": "Dự kiến ra viện hôm nay",
    "overdueOut": "Quá hạn ra viện từ {{date}}",
    "noBedsMatch": "Không có giường phù hợp bộ lọc",
    "wardOccupied": "Đang dùng {{occupied}}/{{total}} giường",
    "admittedAtField": "Ngày giờ nhập viện",
    "admittedAtHint": "Mặc định là bây giờ; có thể lùi lại khi nhập muộn (tối đa 30 ngày)",
    "dischargedAtField": "Ngày giờ xuất viện",
    "dischargedAtHint": "Mặc định là bây giờ; không trước giờ nhập viện ({{at}})",
    "admittedShort": "Nhập viện {{at}}"
  },
  "services": {
    "title": "Dịch vụ đặc biệt",
    "subtitle": "X-quang, CT, siêu âm, điện tim, nội soi, vật lý trị liệu và thủ thuật",
    "allCategories": "Tất cả loại",
    "billedWithVisit": "Tính tiền cùng lượt khám",
    "cancelItem": "Hủy {{name}}",
    "cancelOrder": "Hủy chỉ định",
    "category": "Loại",
    "clinicalInfo": "Thông tin lâm sàng",
    "complete": "Hoàn thành",
    "duration": "Thời gian",
    "durationMinutes": "Thời gian (phút)",
    "editReport": "Sửa kết quả",
    "editService": "Sửa dịch vụ",
    "findings": "Mô tả",
    "impression": "Kết luận",
    "inpatient": "Nội trú",
    "itemCancelled": "Đã hủy dịch vụ",
    "markDone": "Hoàn thành {{name}}",
    "minutes": "{{count}} phút",
    "newService": "Thêm dịch vụ",
    "noImages": "Không có hình ảnh",
    "noOrders": "Không có chỉ định dịch vụ",
    "noReport": "Không cần kết quả",
    "open": "Cần làm",
    "order": "Chỉ định dịch vụ",
    "orderCancelled": "Đã hủy chỉ định",
    "orderFor": "Dịch vụ đặc biệt cho {{name}}",
    "orderNumber": "Số chỉ định",
    "ordered": "Đã chỉ định: {{number}}",
    "orderedAt": "Thời gian chỉ định",
    "orderedBy": "Người chỉ định",
    "performedBy": "thực hiện: {{name}} {{at}}",
    "preparation": "Chuẩn bị bệnh nhân",
    "preparationHint": "Hiển thị khi chỉ định, ví dụ nhịn ăn",
    "prepareNote": "Chuẩn bị: {{text}}",
    "printReport": "In kết quả",
    "priority": "Mức ưu tiên",
    "recommendation": "Đề nghị",
    "report": "Kết quả",
    "reportHint": "Sau khi gửi, người khác sẽ duyệt kết quả trước khi trả cho bác sĩ.",
    "reportTitle": "Phiếu kết quả",
    "reportVerified": "Có kết quả, người thứ hai duyệt",
    "reported": "Đã gửi kết quả chờ duyệt",
    "done": "Dịch vụ đã hoàn thành",
    "reportedBy": "đọc kết quả: {{name}} {{at}}",
    "reporter": "Người đọc kết quả",
    "requiresReport": "Cần có kết quả (người thứ hai duyệt)",
    "searchCatalog": "Tìm dịch vụ",
    "searchOrders": "Tên, HN hoặc số chỉ định",
    "service": "Dịch vụ",
    "services": "Dịch vụ",
    "start": "Bắt đầu",
    "started": "Đã bắt đầu",
    "submitReport": "Gửi kết quả",
    "verified": "Đã duyệt kết quả",
    "verifiedBy": "duyệt: {{name}} {{at}}",
    "verifier": "Người duyệt",
    "verify": "Duyệt",
    "waitingMin": "chờ {{count}} phút",
    "waitingVerify": "Đang chờ người khác duyệt kết quả của bạn.",
    "writeReport": "Kết quả: {{name}}",
    "writeReportShort": "Viết kết quả"
  },
  "pos": {
    "title": "Quầy bán thuốc",
    "subtitle": "Bán thuốc, vật tư và thiết bị y tế",
    "alreadyReturned": "Đã trả",
    "cart": "Giỏ hàng",
    "cartEmpty": "Chạm vào sản phẩm để thêm",
    "cashReceived": "Tiền khách đưa",
    "cashier": "Thu ngân",
    "change": "Tiền thối",
    "charge": "Thu tiền {{total}}",
    "controlledNeedsPatient": "Thuốc kiểm soát chỉ bán cho bệnh nhân đã đăng ký",
    "customer": "Khách hàng",
    "customerName": "Tên khách",
    "giveChange": "Thối lại: {{value}}",
    "inStock": "Còn {{qty}}",
    "netTotal": "{{count}} lượt bán · thực thu {{value}}",
    "nextCustomer": "Khách tiếp theo",
    "noCashRight": "Bạn không được thu tiền mặt. Hãy chọn cách khác.",
    "noProducts": "Kho này không có hàng bán",
    "noReturns": "Không có trả hàng",
    "noSales": "Không có giao dịch trong kỳ",
    "openDrawerFirst": "Mở ca thu ngân để thu tiền mặt",
    "patientOptional": "Bệnh nhân (nếu có)",
    "purchases": "Mua hàng",
    "receipt": "Biên lai",
    "recordReturn": "Nhận trả hàng",
    "refundMethod": "Hoàn tiền bằng",
    "refunded": "Đã hoàn",
    "returnHint": "Hàng trả lại được nhập về đúng lô đã bán.",
    "returnQty": "SL trả",
    "returnTitle": "Trả hàng từ {{number}}",
    "returned": "Đã ghi trả hàng; hàng đã về kho",
    "returns": "Trả hàng",
    "saleDiscount": "Giảm giá toàn đơn",
    "saleDone": "Đã bán {{number}}",
    "saleNumber": "Số hóa đơn",
    "salesTitle": "Bán hàng tại quầy",
    "searchOrScan": "Tìm hoặc quét mã vạch",
    "searchSales": "Số hóa đơn, khách, SĐT hoặc HN",
    "sold": "Đã bán",
    "soldAt": "Thời gian bán",
    "supervisorHint": "Trả hàng và hủy do quản lý (người khác) thực hiện.",
    "suppliesDevices": "Vật tư & thiết bị",
    "void": "Hủy giao dịch",
    "voidHint": "Toàn bộ hàng về kho và giao dịch không còn tính vào ca. Chỉ khi ca còn mở.",
    "voided": "Đã hủy giao dịch",
    "voidedBecause": "Hủy bởi {{name}}: {{reason}}",
    "outlet": "Điểm bán POS",
    "noOutlet": "Chưa có điểm bán POS nào đang dùng.",
    "catalog": {
      "title": "Danh mục POS y tế",
      "subtitle": "Sản phẩm bán tại quầy và giá bán. Sản phẩm lấy từ hàng trong kho.",
      "tab": "Danh mục",
      "search": "Tên, mã, mã vạch hoặc nhóm",
      "addFromWarehouse": "Thêm từ kho",
      "addHint": "Chọn hàng trong kho để bán tại POS. Giá ban đầu là giá bán đề xuất; có thể đổi giá sau.",
      "allPublished": "Tất cả hàng trong kho đã có trong danh mục POS.",
      "publishCount": "Thêm {{count}} vào POS",
      "published": "Đã thêm {{count}} sản phẩm vào POS",
      "empty": "Chưa có sản phẩm trong danh mục POS",
      "product": "Sản phẩm",
      "price": "Giá POS",
      "posStock": "Tồn tại POS",
      "warehouseStock": "Trong kho",
      "levels": "Bổ sung khi → đến",
      "hide": "Ẩn khỏi POS",
      "show": "Hiển thị tại POS",
      "editTitle": "Sản phẩm POS: {{name}}",
      "warehouseItem": "Hàng trong kho",
      "displayName": "Tên tại POS",
      "displayNameHint": "Để trống = dùng tên trong kho",
      "suggested": "Giá đề xuất: {{price}}",
      "sortOrder": "Thứ tự hiển thị",
      "minLevel": "Bổ sung khi còn bằng hoặc dưới",
      "minLevelHint": "Tính cả hàng đang đến",
      "parLevel": "Bổ sung đến",
      "parLevelHint": "0 = không tự đề xuất",
      "parBelowMin": "Không thấp hơn mức bổ sung",
      "posPicture": "Ảnh POS",
      "useWarehousePicture": "Dùng ảnh trong kho",
      "publishedHint": "Hiển thị và bán tại POS"
    },
    "outlets": {
      "title": "Điểm bán",
      "add": "Điểm bán mới",
      "edit": "Sửa điểm bán",
      "empty": "Chưa có điểm bán",
      "hint": "Mỗi điểm bán có tồn kho riêng. Hàng chỉ vào khi kho gửi bổ sung và điểm bán xác nhận đã nhận.",
      "codeHint": "Mã ngắn, ví dụ POS2",
      "inUse": "Đang dùng",
      "products": "Sản phẩm còn hàng",
      "incoming": "Đang đến"
    },
    "stock": {
      "title": "Tồn kho POS & bổ sung",
      "subtitle": "Tồn tại điểm bán, hàng đang đến và yêu cầu bổ sung từ kho",
      "products": "Sản phẩm",
      "inTransit": "Đang đến",
      "onHand": "Tại POS",
      "nextExpiry": "Hết hạn gần nhất",
      "expired": "Đã hết hạn",
      "empty": "Không có dữ liệu"
    },
    "refill": {
      "request": "Yêu cầu bổ sung",
      "requestHint": "Đã điền sẵn sản phẩm chạm mức bổ sung, đến mức mục tiêu. Có thể sửa số lượng.",
      "fromStore": "Từ kho",
      "nothingLow": "Không có sản phẩm nào dưới mức bổ sung. Có thể thêm bên dưới.",
      "quantity": "Số lượng",
      "addProduct": "Thêm sản phẩm",
      "saveDraft": "Lưu nháp",
      "send": "Gửi cho kho",
      "created": "Đã tạo yêu cầu bổ sung {{number}}",
      "submitted": "Đã gửi cho kho",
      "listTitle": "Yêu cầu bổ sung",
      "inboxTitle": "Yêu cầu bổ sung từ POS y tế",
      "open": "Đang xử lý",
      "empty": "Không có yêu cầu bổ sung",
      "number": "Yêu cầu",
      "route": "Từ → đến",
      "lines": "Sản phẩm",
      "requestedBy": "Người yêu cầu",
      "preparedBy": "Người chuẩn bị (kho)",
      "sentAt": "Đã gửi",
      "receivedBy": "Người nhận",
      "transfer": "Phiếu chuyển kho",
      "requested": "Yêu cầu",
      "inStore": "Trong {{store}}",
      "sent": "Đã gửi",
      "received": "Đã nhận",
      "short": "Thiếu",
      "toSend": "Sẽ gửi",
      "prepare": "Chuẩn bị phiếu chuyển",
      "prepareTitle": "Chuẩn bị bổ sung {{number}}",
      "prepareHint": "POS đang chờ các sản phẩm này. Hãy chuẩn bị phiếu chuyển; một người khác của kho sẽ kiểm tra và gửi.",
      "prepareDialogHint": "Số lượng mặc định theo yêu cầu, không quá tồn kho. Sản phẩm số lượng 0 sẽ không gửi.",
      "prepared": "Đã chuẩn bị phiếu {{doc}} — chờ người kiểm tra gửi đi",
      "preparingHint": "Kho đã chuẩn bị. Một người khác của kho kiểm tra và gửi tại Kho → Chờ kiểm tra:",
      "waitingWarehouse": "Đang chờ kho chuẩn bị.",
      "sendHint": "Gửi phiếu này sẽ trừ hàng khỏi kho; hàng vào điểm bán POS khi POS xác nhận đã nhận. Yêu cầu",
      "inTransitHint": "Đang trên đường đến POS. POS kiểm đếm và xác nhận đã nhận. Yêu cầu",
      "fromRequest": "Chuẩn bị cho yêu cầu bổ sung POS",
      "receive": "Nhận hàng",
      "receiveTitle": "Nhận hàng bổ sung {{number}}",
      "receiveHint": "Hàng đang đến. Hãy kiểm đếm và xác nhận đã nhận; sau đó mới bán được.",
      "receiveDialogHint": "Nhập số thực nhận. Phần thiếu sẽ được ghi lại và cần ghi chú.",
      "receiveNote": "Ghi chú (lý do thiếu)",
      "confirmReceipt": "Xác nhận đã nhận",
      "receivedOk": "Đã nhận — sản phẩm đã có thể bán",
      "receivedShort": "Đã nhận nhưng thiếu: {{note}}",
      "shortValue": "Giá trị thiếu: {{value}}",
      "moreThanSent": "Nhiều hơn số đã gửi",
      "moreThanStore": "Nhiều hơn tồn kho",
      "reject": "Từ chối",
      "rejectTitle": "Từ chối yêu cầu {{number}}",
      "rejectReason": "Lý do",
      "rejected": "Đã từ chối yêu cầu bổ sung",
      "rejectedBecause": "Kho từ chối: {{reason}}",
      "cancelTitle": "Hủy yêu cầu {{number}}",
      "cancelHint": "Kho sẽ không chuẩn bị yêu cầu này."
    }
  },
  "finance": {
    "title": "Tài chính",
    "subtitle": "Giá và phí, ca thu ngân, chi phí và kết quả",
    "tab": {
      "dashboard": "Tổng quan",
      "prices": "Giá & phí",
      "sessions": "Ca thu ngân",
      "expenses": "Chi phí",
      "history": "Lịch sử giá"
    },
    "allCategories": "Tất cả nhóm",
    "amount": "Số tiền",
    "approveExpense": "Duyệt {{number}}",
    "approvedTotal": "Đã duyệt: {{value}}",
    "balanced": "Khớp số tiền",
    "byMethod": "Thanh toán theo hình thức",
    "cashExpenseHint": "Tiền mặt chi từ két được tính vào ca thu ngân đang mở của bạn.",
    "cashExpenses": "Chi tiền mặt",
    "cashPayments": "Thu tiền mặt hóa đơn",
    "cashRefunds": "Hoàn tiền mặt",
    "cashSales": "Bán tại quầy tiền mặt",
    "changePrice": "Đổi giá",
    "changePriceOf": "Giá của {{name}}",
    "changeReason": "Lý do thay đổi",
    "changedAt": "Thời gian",
    "changedBy": "Người đổi",
    "closeDrawer": "Đóng ca {{number}}",
    "closeDrawerShort": "Đóng ca",
    "closeNote": "Ghi chú kiểm đếm",
    "closed": "Đóng",
    "collected": "Đã thu",
    "cost": "Giá vốn",
    "costOfGoods": "Giá vốn thuốc & vật tư",
    "countedCash": "Tiền mặt đếm được",
    "counterSales": "Bán tại quầy",
    "currentPrice": "hiện tại {{value}}",
    "dailyCash": "Thu chi theo ngày",
    "date": "Ngày",
    "decidedBy": "Người duyệt / từ chối",
    "discountReason": "Lý do giảm giá",
    "discountType": "Giảm theo",
    "discountable": "Được giảm giá",
    "discountableHint": "Có thể giảm giá phí này",
    "discounts": "Đã giảm giá",
    "drawerOpenShort": "Ca {{number}} · {{cash}}",
    "drawers": "Ca thu ngân đang mở",
    "editFee": "Sửa phí",
    "expectedCash": "Tiền mặt phải có",
    "expenseApprovalHint": "Người khác phải duyệt chi phí trước khi được tính.",
    "expenseNumber": "Số phiếu chi",
    "expenseOnlyHint": "Bạn có thể ghi chi phí; phòng tài chính sẽ duyệt.",
    "expenseRecorded": "Đã gửi phiếu chi {{number}} chờ duyệt",
    "expenses": "Chi phí",
    "expensesByCategory": "Chi phí theo nhóm",
    "grossProfit": "lãi gộp {{value}}",
    "item": "Mục",
    "lastChange": "Đổi gần nhất",
    "margin": "Lãi",
    "myDrawer": "Ca thu ngân của tôi",
    "netProfit": "Lợi nhuận ròng",
    "newExpense": "Ghi chi phí",
    "newFee": "Thêm phí",
    "newPrice": "Giá mới",
    "noChanges": "Chưa đổi giá",
    "noExpenses": "Không có chi phí",
    "noOpenDrawer": "Bạn chưa mở ca thu ngân.",
    "noSessions": "Không có ca thu ngân",
    "oldPrice": "Giá cũ",
    "openDrawer": "Mở ca thu ngân",
    "openDrawerHint": "Đếm tiền lẻ trong két và nhập làm tiền đầu ca.",
    "opened": "Mở",
    "openedAt": "mở lúc {{at}}",
    "openingFloat": "Tiền đầu ca",
    "otherVerifies": "Người khác phải kiểm đếm và xác nhận ca này.",
    "outstanding": "Hóa đơn chưa thu",
    "payee": "Người nhận",
    "pendingApproval": "{{count}} chờ duyệt",
    "percent": "Phần trăm",
    "percentValue": "Phần trăm (%)",
    "price": "Giá",
    "priceChangeHint": "Hóa đơn mới dùng giá mới; hóa đơn cũ giữ nguyên. Mọi thay đổi được lưu trong lịch sử giá.",
    "priceSaved": "Đã đổi giá",
    "pricesHint": "Mọi phí, thuốc, xét nghiệm, dịch vụ đặc biệt, giá giường và hàng bán đều có giá ở đây. Giảm giá theo số tiền hoặc phần trăm trên hóa đơn hoặc tại quầy.",
    "recordedBy": "Người ghi",
    "rejectExpense": "Từ chối {{number}}",
    "revenue": "Doanh thu",
    "revenueBySource": "Doanh thu theo nguồn",
    "revenueSplit": "hóa đơn {{invoices}} · quầy {{sales}}",
    "searchPrices": "Tìm theo tên hoặc mã",
    "session": "Ca thu ngân",
    "sessionClosed": "Đã đóng ca {{number}}; chờ kiểm",
    "sessionOpened": "Đã mở ca {{number}}",
    "sessionTitle": "Ca {{number}} · {{name}}",
    "sessionVerified": "Đã xác nhận ca",
    "submitExpense": "Gửi duyệt",
    "taxRate": "Thuế suất (%)",
    "toVerify": "{{count}} đã đóng, chờ kiểm",
    "type": "Loại",
    "variance": "Chênh lệch",
    "varianceIs": "Chênh lệch {{value}}; vui lòng giải thích",
    "verifiedBy": "Người xác nhận",
    "verifyCount": "Xác nhận kiểm đếm"
  },
  "diseases": {
    "title": "Danh mục bệnh",
    "subtitle": "Mã ICD-10, tên và nhóm bệnh dùng cho chẩn đoán và báo cáo",
    "tabDiseases": "Bệnh",
    "tabTypes": "Nhóm bệnh",
    "searchPlaceholder": "Tìm theo mã ICD-10 hoặc tên…",
    "type": "Nhóm bệnh",
    "allTypes": "Tất cả nhóm",
    "notifiableOnly": "Chỉ bệnh phải báo cáo",
    "newDisease": "Thêm bệnh",
    "empty": "Không có bệnh phù hợp",
    "code": "Mã ICD-10",
    "codeHint": "VD: A90 hoặc J06.9; lưu chữ in hoa",
    "name": "Tên",
    "nameLo": "Tên (tiếng Lào)",
    "nameEn": "Tên (tiếng Anh)",
    "notifiable": "Phải báo cáo",
    "notifiableShort": "Báo cáo",
    "notifiableHint": "Bệnh phải báo cáo: ca bệnh phải báo cho cơ quan y tế",
    "notifiableWarning": "{{name}} là bệnh phải báo cáo. Hãy nhớ báo cáo ca bệnh.",
    "noType": "— Không có nhóm —",
    "activeHint": "Đang dùng (hiện khi chọn chẩn đoán)",
    "activeTypeHint": "Đang dùng",
    "deleteDisease": "Xóa bệnh",
    "deleteDiseaseMessage": "Xóa {{code}} khỏi danh mục? Các chẩn đoán đã ghi vẫn giữ mã và nội dung.",
    "deleted": "Đã xóa",
    "newType": "Thêm nhóm bệnh",
    "noTypes": "Chưa có nhóm bệnh",
    "diseaseCount": "Số bệnh",
    "sortOrder": "Thứ tự hiển thị",
    "color": "Màu",
    "customColor": "Màu tùy chọn",
    "preview": "Xem trước",
    "typeInUseHint": "{{count}} bệnh đang thuộc nhóm này nên không thể xóa. Hãy chuyển bệnh hoặc tắt nhóm.",
    "deleteType": "Xóa nhóm bệnh",
    "deleteTypeMessage": "Xóa nhóm bệnh {{code}}?",
    "pickFromCatalog": "Tìm trong danh mục bệnh"
  },
  "national": {
    "title": "Báo cáo quốc gia",
    "subtitle": "Kết quả KPI, báo cáo đã duyệt và gửi dữ liệu lên DHIS2",
    "tab": {
      "dashboard": "Tổng quan KPI",
      "snapshots": "Bản báo cáo",
      "catalog": "Danh mục KPI",
      "batches": "Gửi DHIS2",
      "mappings": "Ánh xạ DHIS2",
      "connections": "Kết nối DHIS2"
    },
    "period": "Kỳ báo cáo",
    "calculate": "Tính KPI",
    "calculated": "Đã tính KPI",
    "lastRun": "Tính lần cuối {{at}} bởi {{by}}",
    "notCalculatedYet": "Chưa tính KPI cho kỳ này. Chọn Tính KPI.",
    "notCalculatedReadOnly": "Chưa tính KPI cho kỳ này.",
    "notCalculated": "Chưa tính",
    "noKpis": "Không có KPI",
    "target": "Mục tiêu",
    "warning": "Mức cảnh báo",
    "warningAt": "Cảnh báo tại {{value}}",
    "numeratorDenominator": "Tử số / mẫu số",
    "formulaVersion": "Công thức phiên bản {{n}}",
    "trend": "Sáu kỳ gần nhất",
    "breakdown": "Phân tách",
    "report": "Báo cáo",
    "allReports": "Tất cả báo cáo",
    "allStatuses": "Tất cả trạng thái",
    "allTypes": "Tất cả loại",
    "generateSnapshot": "Tạo bản báo cáo",
    "generate": "Tạo",
    "noSnapshots": "Chưa có bản báo cáo",
    "version": "Phiên bản",
    "checks": "Kiểm tra",
    "clean": "Không có vấn đề",
    "errors": "Lỗi: {{count}}",
    "warnings": "Cảnh báo: {{count}}",
    "generated": "Tạo lúc",
    "approvedBy": "Duyệt bởi",
    "includesKpis": "Báo cáo này gồm:",
    "generateHint": "KPI được tính lại và lưu thành một phiên bản mới không thể sửa. Người khác (không phải bạn) phải duyệt trước khi gửi.",
    "snapshotGenerated": "Đã tạo bản báo cáo",
    "snapshotValidated": "Đã kiểm tra bản báo cáo",
    "snapshotApproved": "Đã duyệt bản báo cáo",
    "snapshotInvalidated": "Đã vô hiệu bản báo cáo",
    "invalidate": "Vô hiệu",
    "validate": "Kiểm tra",
    "approve": "Duyệt",
    "prepareDhis2": "Gửi lên DHIS2…",
    "cannotApproveOwn": "Bạn không thể tự duyệt việc của mình",
    "generatedBy": "Tạo bởi {{by}} lúc {{at}}",
    "approvedByAt": "duyệt bởi {{by}} lúc {{at}}",
    "approvedByName": "Duyệt bởi {{by}}",
    "createdByAt": "Tạo bởi {{by}} lúc {{at}}",
    "needsOtherApprover": "Đang chờ người khác duyệt (phân tách nhiệm vụ).",
    "invalidatedBecause": "Đã vô hiệu: {{reason}}",
    "supersededHint": "Một phiên bản mới đã duyệt thay thế bản này.",
    "values": "Giá trị",
    "kpi": "KPI",
    "value": "Giá trị",
    "formula": "Công thức",
    "quality": "Chất lượng dữ liệu",
    "dhis2Batches": "Gửi DHIS2",
    "invalidateMessage": "Bản đã vô hiệu không thể gửi nữa; các lô chưa gửi sẽ bị hủy. Hãy nêu lý do.",
    "reason": "Lý do",
    "connection": "Kết nối",
    "createBatch": "Tạo lô",
    "noConnections": "Chưa thiết lập kết nối DHIS2",
    "createBatchHint": "Các giá trị được ánh xạ tới phần tử dữ liệu DHIS2 và kiểm tra. Lô chỉ được gửi sau khi người khác duyệt.",
    "batchCreated": "Đã tạo lô",
    "noIssues": "Không tìm thấy vấn đề",
    "issue": {
      "INSUFFICIENT_DATA": "Quá ít dữ liệu",
      "NO_FORMULA": "Chưa có công thức duyệt",
      "DIMENSION_TOTAL_MISMATCH": "Phân tách không khớp",
      "PERIOD_OPEN": "Kỳ chưa kết thúc",
      "NO_ORG_UNIT_MAPPING": "Chưa ánh xạ đơn vị",
      "NO_DATA_SET_MAPPING": "Chưa ánh xạ bộ dữ liệu",
      "NO_DATA_ELEMENT_MAPPING": "Chưa ánh xạ phần tử dữ liệu",
      "NO_VALUE": "Không có giá trị",
      "NOT_SENT_QUALITY": "Không gửi (chất lượng)",
      "NO_CATEGORY_MAPPING": "Chưa ánh xạ nhóm",
      "NOTHING_TO_SEND": "Không có gì để gửi"
    },
    "catalogHint": "Công thức là các bộ tính có sẵn. Phiên bản công thức mới chỉ được dùng sau khi người khác (không phải tác giả) duyệt.",
    "newKpi": "Thêm KPI",
    "category": "Nhóm",
    "unit": "Đơn vị",
    "noFormula": "Chưa có công thức duyệt",
    "draftVersions": "Bản nháp: {{count}}",
    "nameEn": "Tên (tiếng Anh)",
    "nameLo": "Tên (tiếng Lào)",
    "direction": "Chiều hướng",
    "owner": "Người phụ trách",
    "unitFixed": "Không thể đổi đơn vị sau khi tạo",
    "newKpiHint": "Sau khi lưu, thêm một phiên bản công thức và cho duyệt trước khi tính KPI.",
    "newTarget": "Thêm mục tiêu",
    "newFormulaVersion": "Thêm phiên bản công thức",
    "targetNeedsDirection": "Hãy chọn cao tốt hay thấp tốt trước",
    "ownedBy": "Phụ trách: {{owner}}",
    "formulaVersions": "Các phiên bản công thức",
    "definition": "Định nghĩa",
    "numerator": "Tử số",
    "denominator": "Mẫu số",
    "effective": "Hiệu lực",
    "minDenominator": "Mẫu số tối thiểu",
    "targets": "Mục tiêu",
    "infoNoTarget": "KPI chỉ để thông tin không có mục tiêu",
    "noTargets": "Chưa có mục tiêu",
    "formulaApproved": "Đã duyệt công thức",
    "formulaDrafted": "Đã lưu công thức nháp",
    "calculator": "Bộ tính",
    "parameters": "Tham số (JSON)",
    "parametersInvalid": "Nhập một JSON object, ví dụ {\"windowDays\": 30}",
    "effectiveFrom": "Hiệu lực từ",
    "changeRationale": "Lý do thay đổi",
    "saveDraft": "Lưu nháp",
    "formulaApprovalHint": "Phiên bản mới bắt đầu từ ngày hiệu lực sau khi duyệt; phiên bản trước kết thúc vào ngày hôm trước.",
    "lowerBetterHint": "Thấp hơn là tốt: giá trị bằng hoặc dưới mục tiêu là đạt, đến mức cảnh báo là cảnh báo.",
    "higherBetterHint": "Cao hơn là tốt: giá trị bằng hoặc trên mục tiêu là đạt, xuống đến mức cảnh báo là cảnh báo.",
    "batchesHint": "Các lô được gửi ở chế độ nền và tự thử lại khi DHIS2 không sẵn sàng.",
    "noBatches": "Chưa có lần gửi DHIS2",
    "batch": "Lô",
    "batchApproved": "Đã duyệt lô",
    "batchQueued": "Lô đang chờ gửi",
    "batchReconciled": "Đã đối chiếu với DHIS2",
    "batchCancelled": "Đã hủy lô",
    "cancelBatch": "Hủy lô",
    "send": "Gửi lên DHIS2",
    "retry": "Gửi lại",
    "reconcile": "Đối chiếu",
    "dataSetOrgUnit": "bộ dữ liệu {{ds}} · đơn vị {{ou}}",
    "batchHasErrors": "Lô này có lỗi và không thể gửi. Sửa ánh xạ, hủy lô và tạo lô mới.",
    "reconcileHint": "DHIS2 không trả lời kịp. Hãy đối chiếu để đọc lại giá trị trước khi gửi lại.",
    "nextAttempt": "Lần thử tự động tiếp theo {{at}}",
    "dataValues": "Giá trị dữ liệu",
    "noValues": "Không có giá trị",
    "dataElement": "Phần tử dữ liệu",
    "categoryOptionCombo": "Tổ hợp nhóm (COC)",
    "importResults": "Kết quả nhập",
    "counts": "Số lượng",
    "countsLine": "{{imported}} nhập, {{updated}} cập nhật, {{ignored}} bỏ qua trên {{total}}",
    "conflicts": "Xung đột",
    "activity": "Hoạt động",
    "showPayload": "Hiện dữ liệu gửi",
    "hidePayload": "Ẩn dữ liệu gửi",
    "mappingType": "Loại ánh xạ",
    "newMapping": "Thêm ánh xạ",
    "noMappings": "Không có ánh xạ",
    "local": "Đối tượng HMS",
    "onlyFor": "Chỉ cho {{report}}",
    "notInMetadata": "Không có trong metadata",
    "transform": "Chuyển đổi giá trị",
    "retire": "Ngừng dùng",
    "mappingApproved": "Đã duyệt ánh xạ",
    "mappingRetired": "Đã ngừng ánh xạ",
    "mappingDrafted": "Đã lưu ánh xạ nháp",
    "dhis2Object": "Đối tượng DHIS2",
    "refreshMetadataFirst": "Hãy làm mới metadata DHIS2 trước",
    "cocHint": "Dùng khi gửi giá trị dạng tổng",
    "defaultCoc": "default",
    "scopeReport": "Chỉ cho báo cáo",
    "scopeReportHint": "Dùng khi cùng một KPI gửi tới phần tử dữ liệu khác trong báo cáo khác",
    "anyReport": "Mọi báo cáo",
    "mappingApprovalHint": "Ánh xạ chỉ được dùng sau khi người khác (không phải người tạo) duyệt.",
    "connectionsHint": "HMS không lưu mật khẩu: hãy nhập tên biến môi trường (environment variable) trên máy chủ chứa thông tin đó.",
    "newConnection": "Thêm kết nối",
    "connectionOk": "Đã kết nối DHIS2",
    "connectionFailed": "Không kết nối được DHIS2",
    "metadataRefreshed": "Đã làm mới metadata",
    "auth": "Xác thực",
    "secretSet": "đã đặt",
    "secretMissing": "chưa đặt trên máy chủ",
    "lastHealth": "Kiểm tra {{at}}",
    "lastMetadata": "metadata {{at}}",
    "approvedMappings": "Ánh xạ đã duyệt: {{count}}",
    "draftMappings": "Ánh xạ nháp: {{count}}",
    "testConnection": "Thử kết nối",
    "refreshMetadata": "Làm mới metadata",
    "baseUrl": "Địa chỉ (URL)",
    "baseUrlHint": "ví dụ https://dhis2.example.gov.la (không ghi tên đăng nhập hay mật khẩu trong liên kết)",
    "environment": "Môi trường",
    "apiVersion": "Phiên bản API",
    "authPat": "Personal access token",
    "authBasic": "Tên đăng nhập và mật khẩu",
    "secretReference": "Biến môi trường",
    "secretHint": "Đặt biến trên máy chủ: token cho personal access token, hoặc username:password cho xác thực cơ bản.",
    "enabled": "Bật",
    "urlError": {
      "invalid": "Nhập liên kết http(s) không có tên đăng nhập hay mật khẩu",
      "httpsRequired": "Môi trường thật cần https"
    },
    "periodOpenText": "Kỳ này chưa kết thúc; giá trị có thể còn thay đổi.",
    "msg": {
      "minRecords": "Chỉ có {{count}} bản ghi; cần ít nhất {{min}}",
      "noData": "Không có dữ liệu trong kỳ này",
      "noFormula": "Không có công thức đã duyệt cho kỳ này",
      "stockPoint": "Tồn kho tại thời điểm tính",
      "medianNote": "Trung vị của các phiếu có đủ thời gian",
      "breakdownGap": "Phân tách cộng lại {{sum}} trên {{total}} (không rõ giới tính hoặc ngày sinh)"
    }
  },
  "tenants": {
    "title": "Tổ chức và bệnh viện",
    "subtitle": "Các tổ chức dùng hệ thống này và bệnh viện của họ. Mỗi bệnh viện có dữ liệu bệnh nhân, nhân viên, kho và tài chính riêng.",
    "newTenant": "Thêm tổ chức",
    "none": "Chưa có tổ chức",
    "suspend": "Tạm ngừng",
    "activate": "Kích hoạt",
    "deactivate": "Ngừng dùng",
    "addHospital": "Thêm bệnh viện",
    "noHospitals": "Chưa có bệnh viện",
    "hospital": "Bệnh viện",
    "users": "Người dùng",
    "patients": "Bệnh nhân",
    "created": "Ngày tạo",
    "signInLink": "Liên kết đăng nhập",
    "linkCopied": "Đã sao chép liên kết đăng nhập",
    "openHospital": "Mở",
    "current": "Đang đăng nhập",
    "sharedCatalogNote": "Thuốc, xét nghiệm, phí và dịch vụ đặc biệt là danh mục quốc gia dùng chung, kể cả giá. Giá riêng cho từng tổ chức sẽ làm trong giai đoạn tăng cường tách tổ chức.",
    "codeHint": "Mã ngắn viết hoa, ví dụ MOH hoặc OPI",
    "type": "Loại",
    "nameLo": "Tên (tiếng Lào)",
    "nameEn": "Tên (tiếng Anh)",
    "hospitalCodeHint": "Mã duy nhất, cũng dùng trong liên kết đăng nhập",
    "startingData": "Dữ liệu ban đầu",
    "startingDataHint": "Mỗi bệnh viện mới có danh mục bệnh, danh mục KPI và các báo cáo quốc gia. Loại lịch hẹn và (nếu chọn) khoa phòng được sao chép từ bệnh viện khác.",
    "copyFrom": "Sao chép thiết lập từ",
    "noTemplate": "Không sao chép",
    "copyDepartments": "Sao chép cả khoa phòng",
    "firstAdmin": "Quản trị viên đầu tiên",
    "adminNew": "Tài khoản mới",
    "adminExisting": "Người dùng có sẵn",
    "adminLater": "Để sau",
    "passwordHint": "Ít nhất 8 ký tự gồm chữ hoa, chữ thường và số; quản trị viên đổi lại sau khi đăng nhập",
    "grantMe": "Cho tôi truy cập bệnh viện này (để thiết lập)",
    "createHospital": "Tạo bệnh viện",
    "hospitalCreated": "Đã tạo và thiết lập bệnh viện"
  },
  "referrals": {
    "title": "Chuyển tuyến",
    "subtitle": "Bệnh nhân chúng ta chuyển đi nơi khác và bệnh nhân được chuyển đến, cùng phản hồi và kết quả",
    "new": "Tạo chuyển tuyến",
    "refer": "Chuyển tuyến",
    "none": "Không có chuyển tuyến",
    "number": "Số chuyển tuyến",
    "direction": "Chiều",
    "patient": "Bệnh nhân",
    "facility": "Cơ sở",
    "reason": "Lý do chuyển",
    "priority": "Mức ưu tiên",
    "open": "Chưa xong",
    "search": "Tìm theo số, bệnh nhân hoặc cơ sở…",
    "outLong": "Chúng ta chuyển bệnh nhân đi",
    "inLong": "Được chuyển đến",
    "toFacility": "Chuyển đến",
    "fromFacility": "Chuyển từ",
    "facilityContact": "Liên hệ cơ sở",
    "specialty": "Chuyên khoa / dịch vụ",
    "diagnosis": "Chẩn đoán",
    "clinicalSummary": "Tóm tắt lâm sàng",
    "clinicalSummaryHint": "Bệnh sử, khám, xét nghiệm và điều trị đến nay",
    "transport": "Phương tiện",
    "created": "Đã tạo chuyển tuyến",
    "sent": "Đã đánh dấu đã gửi",
    "printLetter": "In giấy chuyển tuyến",
    "printSummary": "In tóm tắt",
    "logContact": "Ghi lần liên hệ",
    "markSent": "Đánh dấu đã gửi",
    "markUnreachable": "Không liên lạc được",
    "decline": "Bị từ chối",
    "accept": "Đã nhận",
    "complete": "Ghi kết quả",
    "byOn": "Bởi {{by}} lúc {{at}}",
    "encounter": "Lần khám",
    "appointmentAt": "Lịch hẹn",
    "contactAttempts": "Số lần liên hệ",
    "response": "Phản hồi",
    "outcome": "Kết quả",
    "cancelledBecause": "Đã hủy: {{reason}}",
    "history": "Lịch sử",
    "contactResult": "Kết quả liên hệ",
    "step": {
      "accept": "Chuyển tuyến được nhận",
      "decline": "Chuyển tuyến bị từ chối",
      "unreachable": "Không liên lạc được cơ sở",
      "complete": "Kết quả chuyển tuyến",
      "cancel": "Hủy chuyển tuyến",
      "contact": "Liên hệ với cơ sở hoặc bệnh nhân"
    },
    "done": {
      "accept": "Đã nhận chuyển tuyến",
      "decline": "Đã từ chối",
      "unreachable": "Đã đánh dấu không liên lạc được",
      "complete": "Đã ghi kết quả",
      "cancel": "Đã hủy",
      "contact": "Đã ghi liên hệ"
    },
    "noteLabel": {
      "accept": "Ghi chú (người nhận, hướng dẫn)",
      "decline": "Lý do từ chối",
      "unreachable": "Đã thử những gì",
      "complete": "Kết quả (chẩn đoán, điều trị, kế hoạch)",
      "cancel": "Lý do hủy",
      "contact": "Ghi chú"
    },
    "letterTitle": "GIẤY CHUYỂN TUYẾN",
    "summaryTitle": "TIẾP NHẬN CHUYỂN TUYẾN",
    "referringClinician": "Bác sĩ chuyển",
    "receivingFacility": "Cơ sở tiếp nhận",
    "feedbackRequest": "Phản hồi",
    "feedbackText": "Vui lòng gửi lại kết quả khám và kế hoạch điều trị để chúng tôi tiếp tục chăm sóc bệnh nhân."
  },
  "followUps": {
    "title": "Tái khám",
    "subtitle": "Lịch tái khám của mọi khoa: đến hạn, quá hạn và đã xong",
    "new": "Tạo lịch tái khám",
    "plan": "Hẹn tái khám",
    "none": "Không có lịch tái khám",
    "due": "Hạn",
    "patient": "Bệnh nhân",
    "reason": "Lý do",
    "who": "Khoa / bác sĩ",
    "outcome": "Kết quả",
    "done": "Xong",
    "missed": "Không đến",
    "reopen": "Mở lại",
    "overdueBy": "Quá hạn {{days}} ngày",
    "inDays": "còn {{days}} ngày",
    "created": "Đã hẹn tái khám",
    "priority": "Mức ưu tiên",
    "department": "Khoa",
    "practitioner": "Bác sĩ",
    "instructions": "Hướng dẫn cho bệnh nhân",
    "instructionsHint": "ví dụ nhịn ăn, mang theo thuốc",
    "filter": {
      "upcoming": "Đến hạn trong tuần",
      "overdue": "Quá hạn",
      "today": "Hạn hôm nay",
      "week": "7 ngày tới"
    },
    "action": {
      "complete": "Đã tái khám",
      "missed": "Bệnh nhân không đến",
      "cancel": "Hủy lịch tái khám"
    },
    "noteLabel": {
      "complete": "Kết quả",
      "missed": "Ghi chú (không bắt buộc)",
      "cancel": "Lý do hủy"
    }
  },
  "duplicates": {
    "title": "Bệnh nhân trùng",
    "subtitle": "Các hồ sơ có thể là cùng một người. Một người yêu cầu gộp, người khác duyệt.",
    "tabSuggestions": "Có thể trùng",
    "tabRequests": "Yêu cầu gộp",
    "noneFound": "Không thấy hồ sơ có khả năng trùng",
    "suggestionsHint": "{{count}} cặp có thể trùng, khả năng cao nhất trước",
    "requestPending": "Đang chờ duyệt gộp",
    "notDuplicates": "Không phải cùng người",
    "askMerge": "Yêu cầu gộp",
    "dismissed": "Cặp này sẽ không được gợi ý nữa",
    "dismissMessage": "Hai hồ sơ này là hai người khác nhau và sẽ không được gợi ý nữa.",
    "dismissReason": "Lý do (ví dụ sinh đôi, cha mẹ và con)",
    "visits": "{{count}} lần khám",
    "lastVisit": "gần nhất {{date}}",
    "registered": "đăng ký {{date}}",
    "keepThis": "Giữ hồ sơ này",
    "keeping": "Hồ sơ được giữ",
    "chooseSurvivor": "Chọn hồ sơ để giữ. Mọi thứ của hồ sơ kia sẽ chuyển sang.",
    "mergeExplain": "{{merge}} sẽ được gộp vào {{keep}}: lần khám, hóa đơn, kết quả và dữ liệu khác được chuyển sang, hồ sơ bị gộp không dùng được nữa.",
    "reasonLabel": "Lý do",
    "sendForApproval": "Gửi duyệt",
    "requested": "Đã gửi yêu cầu gộp để duyệt",
    "noRequests": "Không có yêu cầu gộp",
    "askedBy": "Yêu cầu bởi {{by}} lúc {{at}}",
    "decidedBy": "quyết định bởi {{by}} lúc {{at}}",
    "survivor": "Giữ lại",
    "duplicate": "Gộp vào hồ sơ được giữ",
    "decisionNote": "Ghi chú quyết định",
    "movedRecords": "Đã chuyển {{count}} mục sang bệnh nhân được giữ",
    "keptOnDuplicate": "giữ trên hồ sơ bị gộp (một mỗi bệnh nhân): {{list}}",
    "cancelRequest": "Hủy yêu cầu",
    "reject": "Từ chối",
    "approveMerge": "Duyệt gộp",
    "mergeNow": "Gộp ngay",
    "approveNote": "Ghi chú (không bắt buộc)",
    "rejectNote": "Lý do từ chối",
    "merged": "Đã gộp hồ sơ",
    "rejected": "Đã từ chối gộp",
    "mergedBanner": "Hồ sơ này đã được gộp vào hồ sơ bệnh nhân khác và không dùng được nữa.",
    "openSurvivor": "Mở hồ sơ được giữ",
    "reason": {
      "NAME_DOB": "Cùng tên và ngày sinh",
      "SIMILAR_NAME_DOB": "Tên gần giống, cùng ngày sinh",
      "PHONE_NAME": "Cùng số điện thoại, tên gần giống",
      "IDENTIFIER": "Cùng số giấy tờ"
    }
  },
  "registry": {
    "sectionNamesEn": "Tên tiếng Anh và tên gọi",
    "firstNameEn": "Tên (tiếng Anh)",
    "lastNameEn": "Họ (tiếng Anh)",
    "nickname": "Tên gọi",
    "nicknameEn": "Tên gọi (tiếng Anh)",
    "sectionBackground": "Thông tin cơ bản",
    "nationality": "Quốc tịch",
    "country": "Quốc gia (công dân)",
    "ethnicity": "Dân tộc",
    "religion": "Tôn giáo",
    "firstLanguage": "Tiếng mẹ đẻ",
    "occupation": "Nghề nghiệp",
    "educationLevel": "Trình độ học vấn",
    "sectionBirth": "Nơi sinh",
    "birthCountry": "Quốc gia nơi sinh",
    "birthPlace": "Nơi sinh (khác)",
    "birthPlaceHint": "Bệnh viện hoặc nơi khác, nếu không phải bản",
    "sectionHousehold": "Hộ gia đình",
    "houseNo": "Số nhà",
    "householdUnit": "Tổ (ໜ່ວຍ)",
    "familyBookNo": "Số sổ hộ khẩu",
    "relationshipToHead": "Quan hệ với chủ hộ",
    "isHouseholdHead": "Là chủ hộ",
    "sectionParents": "Cha mẹ",
    "fatherName": "Tên cha",
    "motherName": "Tên mẹ",
    "parentOccupation": "Nghề nghiệp",
    "parentPhone": "Điện thoại",
    "parentNationalId": "Số CMND/CCCD",
    "parentWorkplace": "Nơi làm việc",
    "sectionHealth": "Tiền sử sức khỏe",
    "hearingIssue": "Có vấn đề về nghe",
    "speakingIssue": "Có vấn đề về nói",
    "visionIssue": "Có vấn đề về mắt",
    "heightCm": "Chiều cao (cm)",
    "weightKg": "Cân nặng (kg)",
    "medicalIssues": "Vấn đề sức khỏe",
    "seriousIllness": "Từng bệnh nặng",
    "title": "Thông tin hộ tịch",
    "namesEn": "Tên tiếng Anh",
    "heightWeight": "Chiều cao và cân nặng",
    "sectionDisability": "Khuyết tật",
    "disabilityTypes": "Loại khuyết tật",
    "disabilityTypesHint": "Chọn tất cả các mục phù hợp; loại con hiện ra dưới loại đã chọn. \"Không rõ / Chưa đánh giá\" không thể chọn cùng mục khác.",
    "disabilityChooseOne": "chọn một",
    "disabilityChooseAny": "chọn các mục phù hợp"
  },
  "staffKpi": {
    "title": "Tóm tắt công việc",
    "titleFor": "Tóm tắt công việc: {{name}}",
    "subtitle": "Công việc được ghi dưới tài khoản này mỗi tháng, theo từng phần của hệ thống",
    "backToUsers": "Quay lại danh sách người dùng",
    "showAll": "Hiện cả việc không có mục nào",
    "nothing": "Không có công việc nào trong {{period}}",
    "vsPrevious": "kỳ trước {{value}}",
    "column": "Tóm tắt công việc",
    "open": "Xem",
    "mine": "Tóm tắt công việc của tôi",
    "metric": {
      "PATIENTS_REGISTERED": "Bệnh nhân đã đăng ký",
      "APPOINTMENTS_BOOKED": "Lịch hẹn đã đặt",
      "QUEUE_CALLED": "Gọi bệnh nhân từ hàng chờ",
      "ENCOUNTERS_SEEN": "Lượt khám (là bác sĩ)",
      "VITALS_RECORDED": "Ghi dấu hiệu sinh tồn",
      "DIAGNOSES_RECORDED": "Ghi chẩn đoán",
      "NOTES_SIGNED": "Ký ghi chú",
      "LAB_ORDERS": "Chỉ định xét nghiệm",
      "LAB_RESULTS_ENTERED": "Nhập kết quả xét nghiệm",
      "LAB_RESULTS_VERIFIED": "Duyệt kết quả xét nghiệm",
      "SERVICES_REPORTED": "Báo cáo dịch vụ đặc biệt",
      "REFERRALS_MADE": "Chuyển tuyến",
      "FOLLOW_UPS_DONE": "Tái khám hoàn tất",
      "EYE_EXAMS_SIGNED": "Ký khám mắt",
      "VA_MEASURED": "Đo thị lực",
      "SURGERIES_PERFORMED": "Ca phẫu thuật",
      "INJECTIONS_GIVEN": "Mũi tiêm",
      "ADMISSIONS": "Nhập viện",
      "DISCHARGES": "Xuất viện",
      "PRESCRIPTIONS_WRITTEN": "Kê đơn thuốc",
      "DISPENSED": "Cấp phát thuốc",
      "POS_SALES": "Bán tại quầy",
      "STOCK_DOCUMENTS": "Chứng từ kho",
      "INVOICES_ISSUED": "Hóa đơn đã lập",
      "PAYMENTS_RECEIVED": "Khoản thu",
      "PAYMENTS_AMOUNT": "Số tiền đã thu",
      "SYSTEM_ACTIONS": "Thao tác trong hệ thống"
    },
    "team": {
      "title": "KPI nhân viên",
      "subtitle": "Công việc ghi nhận của từng người mỗi tháng, so với chỉ tiêu tháng",
      "leaderboard": "Bảng xếp hạng",
      "targets": "Chỉ tiêu",
      "metric": "Chỉ số",
      "role": "Vai trò",
      "anyRole": "Tất cả vai trò",
      "showZero": "Hiện cả nhân viên không có công việc",
      "rank": "Hạng",
      "staff": "Nhân viên",
      "roles": "Vai trò",
      "department": "Khoa",
      "thisMonth": "Kỳ này",
      "lastMonth": "Kỳ trước",
      "target": "Chỉ tiêu",
      "achievement": "Đạt",
      "noTarget": "Chưa có chỉ tiêu",
      "total": "Tổng cả nhóm",
      "counted": "Nhân viên có công việc",
      "withTarget": "Nhân viên có chỉ tiêu",
      "metTarget": "Đạt chỉ tiêu",
      "empty": "Không có công việc nào cho chỉ số và tháng này.",
      "supervisionNote": "Chỉ dùng để giám sát và hướng dẫn — KPI nhân viên không gửi lên DHIS2 và không dùng để tự động ra quyết định nhân sự.",
      "addTarget": "Thêm chỉ tiêu",
      "editTarget": "Sửa chỉ tiêu",
      "appliesTo": "Áp dụng cho",
      "forRole": "Một vai trò",
      "forPerson": "Một người",
      "person": "Người",
      "monthlyTarget": "Chỉ tiêu tháng",
      "monthlyTargetMoney": "Chỉ tiêu tháng (số tiền)",
      "targetHint": "Mỗi tháng. Quý ×3, năm ×12, ngày và khoảng ngày tính theo tỷ lệ số ngày. Chỉ tiêu riêng của một người thay cho chỉ tiêu theo vai trò.",
      "targetsHelp": "Chỉ tiêu theo vai trò áp dụng cho mọi người có vai trò đó; chỉ tiêu riêng của một người sẽ thay thế.",
      "noTargets": "Chưa có chỉ tiêu.",
      "updated": "Sửa lần cuối",
      "deleteTarget": "Xóa chỉ tiêu"
    },
    "dash": {
      "title": "Tổng quan",
      "vsLastMonth": "so với kỳ trước",
      "activeStaff": "Nhân viên có công việc",
      "targetsMet": "Đạt chỉ tiêu",
      "ofTargets": "{{met}} / {{total}}",
      "byArea": "Công việc theo lĩnh vực theo thời gian",
      "attainment": "Chỉ tiêu trong kỳ này",
      "met": "Đạt",
      "close": "Gần đạt (70–99%)",
      "behind": "Chưa đạt (dưới 70%)",
      "noTargets": "Chưa đặt chỉ tiêu — thêm ở thẻ Chỉ tiêu.",
      "withoutTarget": "{{value}} nhân viên có công việc chưa có chỉ tiêu.",
      "top5": "Top 5",
      "byRole": "Công việc theo vai trò trong kỳ này",
      "byRoleHint": "Người có nhiều vai trò được tính ở mỗi vai trò.",
      "people": "{{value}} người",
      "workItems": "Số công việc",
      "heatmap": "Công việc của từng người theo thời gian",
      "heatmapHint": "Màu đậm = nhiều công việc. Nhấn vào dòng để xem tóm tắt của người đó."
    },
    "period": {
      "day": "Ngày",
      "month": "Tháng",
      "quarter": "Quý",
      "year": "Năm",
      "range": "Khoảng ngày",
      "from": "Từ",
      "to": "Đến",
      "vs": "so với {{previous}}",
      "prorated": "chỉ tiêu tính theo tỷ lệ số ngày"
    },
    "trendTotal": "tổng trên biểu đồ {{value}}"
  },
  "roles": {
    "title": "Vai trò và quyền",
    "subtitle": "Mỗi vai trò là một tập quyền. Gán vai trò cho nhân viên ở trang Người dùng.",
    "newRole": "Thêm vai trò",
    "howItWorks": "Thay đổi có hiệu lực với mỗi người trong 15 phút (khi đăng nhập hoặc gia hạn token). Vai trò dùng chung cho mọi bệnh viện; quyền nền tảng chỉ thuộc quản trị viên cấp cao.",
    "searchRoles": "Tìm vai trò…",
    "permissionCount": "{{count}} quyền",
    "pick": "Chọn một vai trò",
    "locked": "Đã khóa",
    "builtIn": "Có sẵn",
    "custom": "Tự tạo",
    "inUse": "Vẫn đang gán cho người dùng",
    "name": "Tên vai trò",
    "usersLine": "{{here}} người ở bệnh viện này · {{total}} ở mọi bệnh viện",
    "saveDetails": "Lưu thông tin",
    "lockedHint": "Quản trị viên cấp cao luôn có mọi quyền.",
    "permissions": "Quyền ({{count}})",
    "searchPermissions": "Tìm quyền…",
    "savePermissions": "Lưu quyền",
    "platformOnly": "Chỉ nền tảng",
    "deleteRole": "Xóa vai trò",
    "deleteMessage": "Xóa vai trò {{name}}? Không ai có vai trò này.",
    "create": "Tạo vai trò",
    "codeHint": "Chữ hoa và _, ví dụ EYE_SCREENER",
    "copyFrom": "Sao chép quyền từ",
    "startEmpty": "Bắt đầu không có quyền",
    "saved": "Đã lưu quyền",
    "deleted": "Đã xóa vai trò",
    "created": "Đã tạo vai trò"
  },
  "permGroup": {
    "appointment": "Lịch hẹn",
    "audit": "Nhật ký kiểm tra",
    "billing": "Hóa đơn",
    "careplan": "Kế hoạch chăm sóc",
    "cash": "Ngăn kéo tiền",
    "dhis2": "DHIS2",
    "diagnosis": "Chẩn đoán",
    "disease": "Danh mục bệnh",
    "encounter": "Lượt khám",
    "finance": "Tài chính",
    "followup": "Tái khám",
    "i18n": "Ngôn ngữ và văn bản",
    "inpatient": "Nội trú",
    "inventory": "Kho",
    "kpi": "KPI",
    "lab": "Xét nghiệm",
    "location": "Địa danh",
    "medication": "Thuốc",
    "note": "Ghi chép lâm sàng",
    "ophthalmology": "Trung tâm mắt",
    "organization": "Bệnh viện và khoa",
    "pathway": "Chu trình điều trị",
    "patient": "Bệnh nhân",
    "payment": "Thanh toán",
    "pharmacy": "Nhà thuốc",
    "portal": "Ứng dụng bệnh nhân",
    "pos": "Quầy thuốc POS",
    "prescription": "Đơn thuốc",
    "purchase": "Mua sắm",
    "queue": "Hàng chờ",
    "referral": "Chuyển tuyến",
    "report": "Báo cáo",
    "role": "Vai trò",
    "sales": "Bán tại quầy",
    "service": "Dịch vụ đặc biệt",
    "tenant": "Tổ chức",
    "user": "Người dùng",
    "ward": "Khoa phòng và giường",
    "reference": "Danh mục mã dùng chung",
    "staffkpi": "KPI nhân viên"
  },
  "permAction": {
    "admin": "Quản trị",
    "approve": "Duyệt",
    "collect": "Thu tiền",
    "discount": "Giảm giá",
    "dispense": "Cấp phát",
    "enter": "Nhập kết quả",
    "global": "Mọi bệnh viện",
    "manage": "Quản lý",
    "merge": "Gộp hồ sơ",
    "order": "Chỉ định",
    "perform": "Thực hiện",
    "prepare": "Chuẩn bị",
    "read": "Xem",
    "refund": "Hoàn tiền",
    "request": "Yêu cầu",
    "sell": "Bán",
    "sensitive": "Thông tin nhạy cảm",
    "session": "Mở và đóng",
    "sign": "Ký",
    "stock": "Tồn kho",
    "submit": "Gửi",
    "surgery": "Phẫu thuật",
    "verify": "Xác nhận",
    "void": "Hủy",
    "write": "Tạo và sửa",
    "kiosk": "Vận hành kiosk",
    "display": "Hiển thị màn hình",
    "triage": "Ưu tiên lâm sàng",
    "configure": "Cấu hình"
  },
  "apptDash": {
    "title": "Tổng quan lịch hẹn",
    "subtitle": "Lịch hẹn hôm nay, tổng quan tháng và các lần tái khám cần chú ý",
    "followUpWatch": "Theo dõi tái khám",
    "followUpWatchHint": "Lịch tái khám quá hạn hoặc sắp đến hạn",
    "followUpRestOfWeek": "Các ngày còn lại trong 7 ngày tới",
    "patients": "{{value}} bệnh nhân",
    "openFollowUps": "lượt tái khám đang mở",
    "needsAttention": "Cần chú ý",
    "noOverdue": "Không có lịch tái khám quá hạn.",
    "otherDepartments": "Khác",
    "byDepartment": "Lịch hẹn theo khoa",
    "byDepartmentHint": "Tỷ lệ lịch hẹn tháng {{month}}",
    "lastMonth": "Tháng trước",
    "pillHint": "Nhãn trong cột cho thấy thay đổi so với tháng trước.",
    "scheduled": "Đã đặt",
    "overview": "Tổng hợp lịch hẹn",
    "overviewHint": "Tổng tháng {{month}} · lịch ngày {{date}}",
    "calendar": "Lịch hẹn theo tháng",
    "calendarHint": "Chọn một ngày để xem lịch",
    "more": "+{{value}} lịch khác",
    "legend": "Chú giải",
    "legendHint": "Màu lịch theo khoa",
    "waiting": "Đang chờ",
    "arrived": "Đã đến",
    "patientsBooked": "Bệnh nhân",
    "beds": "Giường",
    "bedsHint": "Khoa nội trú",
    "doctorsOnDuty": "Bác sĩ trực",
    "activeDoctors": "Bác sĩ đang làm việc",
    "departmentsOpen": "Khoa",
    "upcoming": "Sắp tới",
    "next7Days": "7 ngày tới",
    "weekdays": {
      "1": "T2",
      "2": "T3",
      "3": "T4",
      "4": "T5",
      "5": "T6",
      "6": "T7",
      "7": "CN"
    }
  },
  "disabilityTypes": {
    "title": "Loại khuyết tật",
    "subtitle": "Phân loại dùng khi đăng ký bệnh nhân. Dùng chung cho tất cả bệnh viện.",
    "new": "Thêm loại khuyết tật",
    "deleted": "Đã xóa loại khuyết tật",
    "inUseHint": "Có {{count}} bệnh nhân thuộc loại này nên không thể xóa. Bỏ chọn \"Đang dùng\" để ẩn khỏi màn hình đăng ký.",
    "codeHint": "Chữ in hoa, chữ số, - hoặc _ (ví dụ PWD11)",
    "sortOrder": "Thứ tự hiển thị",
    "nameLa": "Tên (tiếng Lào)",
    "nameEn": "Tên (tiếng Anh)",
    "activeLabel": "Đang dùng (hiển thị khi đăng ký bệnh nhân)",
    "deleteTitle": "Xóa loại khuyết tật?",
    "deleteMessage": "{{code}} sẽ bị xóa. Không bệnh nhân nào thuộc loại này.",
    "patients": "Bệnh nhân",
    "parent": "Là loại con của",
    "noParent": "— Loại chính —",
    "icd11Code": "Mã ICD-11",
    "exclusiveLabel": "Không thể chọn cùng loại khác (ví dụ Không rõ / Chưa đánh giá)",
    "singleChoiceLabel": "Chỉ được chọn một loại con của nó",
    "exclusiveBadge": "Chỉ chọn riêng",
    "singleChoiceBadge": "Một loại con"
  },
  "queueServices": {
    "title": "Điểm phục vụ hàng đợi",
    "subtitle": "Mỗi điểm phục vụ có hàng đợi riêng mỗi ngày. Bệnh nhân giữ một số khi di chuyển giữa các điểm.",
    "add": "Thêm điểm phục vụ",
    "edit": "Sửa {{code}}",
    "prefix": "Tiền tố số",
    "prefixHint": "Chữ hoặc số, ví dụ R cho R-001",
    "nameLocal": "Tên (tiếng Lào)",
    "nameEn": "Tên (tiếng Anh)",
    "departmentHint": "Lịch hẹn và bệnh nhân vãng lai của khoa bắt đầu tại điểm phục vụ đầu tiên của khoa",
    "noDepartment": "Không có khoa",
    "counters": "Quầy / phòng",
    "countersHint": "Phân cách bằng dấu phẩy, ví dụ Phòng 1, Phòng 2",
    "sortOrder": "Thứ tự",
    "sortOrderHint": "Số nhỏ đứng trước",
    "kiosk": "Kiosk",
    "kioskEnabled": "Bệnh nhân vãng lai có thể chọn tại kiosk"
  }
}
